import { createIcon } from '@chakra-ui/react';
import React from 'react';

export const OutpostLogo = createIcon({
  displayName: 'OutpostLogo',
  viewBox: '0 0 29.075 25.88',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg">
      <path
        id="Path_20351"
        d="M21.757,25.159h0A1.655,1.655,0,0,1,22.018,23,11.413,11.413,0,0,0,25.669,16a11.006,11.006,0,0,0-2.524-8.72A11.209,11.209,0,0,0,8.033,5.429c-4.409,3.378-6,9.6-3.61,14.161a7.257,7.257,0,0,0,.612.981A4.311,4.311,0,0,0,8.13,22.462a7.214,7.214,0,0,0,4.564-1.425,18.12,18.12,0,0,1-1.914-3.089,7.239,7.239,0,0,1-.691-4.391,6.984,6.984,0,0,1,2.232-3.873,7.356,7.356,0,0,1,3.985-1.907,5.041,5.041,0,0,1,2.42.276,4.877,4.877,0,0,1,1.88,1.282,5.524,5.524,0,0,1,1.256,2.35,5.983,5.983,0,0,1,.052,2.729,11.252,11.252,0,0,1-2.408,4.721,23.886,23.886,0,0,1-2.161,2.3,13.614,13.614,0,0,0,1.2,1.076,1.661,1.661,0,0,1,.4,2.157h0a1.655,1.655,0,0,1-2.445.448,17.265,17.265,0,0,1-1.677-1.527,10.972,10.972,0,0,1-6.233,2.2,7.8,7.8,0,0,1-.789-.039,7.646,7.646,0,0,1-5.41-3.2A10.624,10.624,0,0,1,1.5,21.124,13.8,13.8,0,0,1,.51,11.129,15.587,15.587,0,0,1,6.022,2.8,13.878,13.878,0,0,1,16.31.126,14.952,14.952,0,0,1,21.4,1.741a14.458,14.458,0,0,1,4.259,3.392,14.107,14.107,0,0,1,2.887,5.426,14.84,14.84,0,0,1-4.309,14.9,1.658,1.658,0,0,1-2.482-.3ZM16.965,11.046a2.129,2.129,0,0,0-.258.017,4.183,4.183,0,0,0-3.36,3.067c-.268,1.532.7,3.124,1.874,4.756,1.593-1.529,3.045-3.256,3.453-5.163a2.459,2.459,0,0,0-.514-2.153,1.56,1.56,0,0,0-1.195-.524Z"
        transform="translate(-0.004 -0.004)"
        fill="currentColor"
      />
    </svg>
  ),
});

export const MenuDotIcon = createIcon({
  displayName: 'MenuDotIcon',
  viewBox: '0 0 16 17',
  path: (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 4.5C8.82843 4.5 9.5 3.82843 9.5 3C9.5 2.17157 8.82843 1.5 8 1.5C7.17157 1.5 6.5 2.17157 6.5 3C6.5 3.82843 7.17157 4.5 8 4.5Z"
        fill="currentColor"
      />
      <path
        d="M8 10C8.82843 10 9.5 9.32843 9.5 8.5C9.5 7.67157 8.82843 7 8 7C7.17157 7 6.5 7.67157 6.5 8.5C6.5 9.32843 7.17157 10 8 10Z"
        fill="currentColor"
      />
      <path
        d="M8 15.5C8.82843 15.5 9.5 14.8284 9.5 14C9.5 13.1716 8.82843 12.5 8 12.5C7.17157 12.5 6.5 13.1716 6.5 14C6.5 14.8284 7.17157 15.5 8 15.5Z"
        fill="currentColor"
      />
    </svg>
  ),
});

export const CloseIcon2 = createIcon({
  displayName: 'CloseIcon2',
  viewBox: '0 0 12.671 12.673',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12.671"
      height="12.673"
      viewBox="0 0 12.671 12.673"
    >
      <g
        id="Iconly_Light_Close_Square"
        data-name="Iconly/Light/Close Square"
        transform="translate(1.061 1.061)"
      >
        <g id="Close_Square" data-name="Close Square" transform="translate(0 0)">
          <path
            id="Stroke_1"
            data-name="Stroke 1"
            d="M10.541,0,0,10.541"
            transform="translate(0.005 0.005)"
            fill="#fff"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="1.5"
          />
          <path
            id="Stroke_2"
            data-name="Stroke 2"
            d="M10.549,10.552,0,0"
            fill="#fff"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="1.5"
          />
        </g>
      </g>
    </svg>
  ),
});

export const PlayIcon = createIcon({
  displayName: 'PlayIcon',
  viewBox: '0 0 77 77',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="77" height="77" viewBox="0 0 77 77">
      <g id="Group_15061" data-name="Group 15061" transform="translate(-431 -422)">
        <circle
          id="Ellipse_1575"
          data-name="Ellipse 1575"
          cx="38.5"
          cy="38.5"
          r="38.5"
          transform="translate(431 422)"
          fill="rgba(255,255,255,0.14)"
        />
        <circle
          id="Ellipse_1576"
          data-name="Ellipse 1576"
          cx="28.5"
          cy="28.5"
          r="28.5"
          transform="translate(441 432)"
          fill="#fff"
        />
        <path
          id="Polygon_3"
          data-name="Polygon 3"
          d="M12.506,2.986a2,2,0,0,1,3.461,0L26.732,21.56a2,2,0,0,1-1.73,3H3.471a2,2,0,0,1-1.73-3Z"
          transform="translate(484.563 446.264) rotate(90)"
          fill="#2e2d2f"
        />
      </g>
    </svg>
  ),
});

export const MentalHealthLogo = createIcon({
  displayName: 'MentalHealthLogo',
  viewBox: '0 0 37 34',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="34" viewBox="0 0 37 34">
      <g id="Group_14798" data-name="Group 14798" transform="translate(-530 -271)">
        <rect
          id="Rectangle_2801"
          data-name="Rectangle 2801"
          width="37"
          height="34"
          rx="4"
          transform="translate(530 271)"
          fill="#636ff2"
        />
        <g id="Layer_2" data-name="Layer 2" transform="translate(542.835 279.152)">
          <g id="Icons_24px" data-name="Icons 24px">
            <path
              id="Path_20930"
              data-name="Path 20930"
              d="M11.79,12.75a2.5,2.5,0,0,0-.29-1.1,4.77,4.77,0,0,0-1.44-1.46L4.93,6.3A5.22,5.22,0,0,1,3.34,4.68,2.8,2.8,0,0,1,3.22,2.5,3.17,3.17,0,0,1,7.55.82,2.79,2.79,0,0,1,9.1,3.2,3.32,3.32,0,0,1,8.53,5,9.11,9.11,0,0,1,6,7.39L2.69,9.71a5.19,5.19,0,0,0-2,2.17,2.52,2.52,0,0,0,.91,2.91,4.85,4.85,0,0,0,2.77.53h4a4.83,4.83,0,0,0,2-.31,2.48,2.48,0,0,0,1.26-1.42,2.72,2.72,0,0,0,.16-.84Z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
              strokeWidth="1.5"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
});

export const WellBeingLogo = createIcon({
  displayName: 'WellBeingLogo',
  viewBox: '0 0 37 34',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="34" viewBox="0 0 37 34">
      <g id="Group_14800" data-name="Group 14800" transform="translate(-530 -271)">
        <rect
          id="Rectangle_2801"
          data-name="Rectangle 2801"
          width="37"
          height="34"
          rx="4"
          transform="translate(530 271)"
          fill="#ffc235"
        />
        <g id="Layer_2" data-name="Layer 2" transform="translate(540.097 280.002)">
          <g id="Icons_24px" data-name="Icons 24px">
            <path
              id="Path_20931"
              data-name="Path 20931"
              d="M9,.87l1.93,3.88a.66.66,0,0,0,.5.36l4.32.63A.62.62,0,0,1,16.2,6a.64.64,0,0,1-.07.86L13,9.88a.64.64,0,0,0-.19.59l.75,4.27a.66.66,0,0,1-.54.74.78.78,0,0,1-.43-.06l-3.85-2a.62.62,0,0,0-.62,0l-3.87,2a.67.67,0,0,1-1-.7L4,10.46a.63.63,0,0,0-.19-.58l-3.15-3a.67.67,0,0,1,0-.93h0a.71.71,0,0,1,.38-.18l4.32-.63a.67.67,0,0,0,.5-.36L7.82.87A.7.7,0,0,1,8.2.53a.69.69,0,0,1,.51,0A.62.62,0,0,1,9,.87Z"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
});

export const PhysicalHealthLogo = createIcon({
  displayName: 'PhysicalHealthLogo',
  viewBox: '0 0 37 34',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="34" viewBox="0 0 37 34">
      <g id="Group_14802" data-name="Group 14802" transform="translate(-530 -271)">
        <rect
          id="Rectangle_2801"
          data-name="Rectangle 2801"
          width="37"
          height="34"
          rx="4"
          transform="translate(530 271)"
          fill="#00a18f"
        />
        <g id="Layer_2" data-name="Layer 2" transform="translate(539.515 279.502)">
          <g id="Icons_24px" data-name="Icons 24px">
            <path
              id="Path_20932"
              data-name="Path 20932"
              d="M5,7.33v5.72"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
            <path
              id="Path_20933"
              data-name="Path 20933"
              d="M8.87,4.6v8.45"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
            <path
              id="Path_20934"
              data-name="Path 20934"
              d="M12.69,10.36v2.69"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
            <path
              id="Path_20935"
              data-name="Path 20935"
              d="M12.74.5H4.93A4.3,4.3,0,0,0,.5,5.15v7.36c0,2.73,1.7,4.66,4.43,4.66h7.81c2.73,0,4.43-1.93,4.43-4.66V5.15C17.17,2.43,15.47.5,12.74.5Z"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
});

export const VitalsLogo = createIcon({
  displayName: 'VitalsLogo',
  viewBox: '0 0 37 34',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="34">
      <g id="Group_14796" data-name="Group 14796" transform="translate(-530 -271)">
        <rect
          id="Rectangle_2801"
          data-name="Rectangle 2801"
          width="37"
          height="34"
          rx="4"
          transform="translate(530 271)"
          fill="#ed1a4b"
        />
        <g id="Layer_2" data-name="Layer 2" transform="translate(538.48 280.047)">
          <g id="Icons_24px" data-name="Icons 24px" transform="translate(0.503 0.513)">
            <path
              id="Path_20928"
              data-name="Path 20928"
              d="M20.5,6.877a4.734,4.734,0,0,0-.284-3.231,5.516,5.516,0,0,0-7.291-2.557,4.876,4.876,0,0,0-.746.462L9.1,3.682a2.509,2.509,0,1,0,2.9,0L9.033,1.5a5.468,5.468,0,0,0-7.244.864A5,5,0,0,0,.511,6a9.942,9.942,0,0,0,2.462,5.066A56.813,56.813,0,0,0,7.033,15.8c.485.533.982,1.065,1.456,1.61a3.432,3.432,0,0,0,1.894,1.349,2.249,2.249,0,0,0,1.361-.213,3.953,3.953,0,0,0,1.089-.994l1.184-1.408"
              transform="translate(-0.503 -0.513)"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
            <path
              id="Path_20929"
              data-name="Path 20929"
              d="M12.07,10.075l1.858,2.355L16.153,7.72l2.166,3.646"
              transform="translate(1.621 0.811)"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
});

export const MyNetworkIcon = createIcon({
  displayName: 'MyNetworkIcon',
  viewBox: '0 0 77 77',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.08 15.82">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Icons_24px" data-name="Icons 24px">
          <path
            fill="none"
            stroke="currentColor"
            strokeMiterlimit="10"
            d="M13.18,12.75a2.36,2.36,0,0,0-.28-1.1,4.81,4.81,0,0,0-1.45-1.46L6.32,6.3A5.3,5.3,0,0,1,4.74,4.68,2.76,2.76,0,0,1,4.62,2.5,3.17,3.17,0,0,1,9,.82,2.81,2.81,0,0,1,10.5,3.2,3.32,3.32,0,0,1,9.93,5,9.11,9.11,0,0,1,7.36,7.39L4.09,9.71a5.15,5.15,0,0,0-2,2.17A2.54,2.54,0,0,0,3,14.79a4.82,4.82,0,0,0,2.77.53l4,0a4.78,4.78,0,0,0,2-.31,2.45,2.45,0,0,0,1.26-1.42A2.19,2.19,0,0,0,13.18,12.75Z"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M11.91,1A2.76,2.76,0,0,1,13,4.19a6.27,6.27,0,0,1-2,2.56.42.42,0,0,0,0,.71c1.11.91,2.33,1.68,3.48,2.55"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3.17,1A2.75,2.75,0,0,0,2.06,4.19,6.27,6.27,0,0,0,4,6.75.43.43,0,0,1,4,7.46C2.86,8.37,1.65,9.14.5,10"
          />
        </g>
      </g>
    </svg>
  ),
});

export const EyeIcon2 = createIcon({
  displayName: 'EyeIcon2',
  viewBox: '0 0 16 10',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.666626 5C1.81996 2.07333 4.66663 0 7.99996 0C11.3333 0 14.18 2.07333 15.3333 5C14.18 7.92667 11.3333 10 7.99996 10C4.66663 10 1.81996 7.92667 0.666626 5ZM13.8799 5C12.7799 2.75333 10.5266 1.33333 7.9999 1.33333C5.47323 1.33333 3.2199 2.75333 2.1199 5C3.2199 7.24667 5.47323 8.66667 7.9999 8.66667C10.5266 8.66667 12.7799 7.24667 13.8799 5ZM7.99996 3.33333C8.91996 3.33333 9.66663 4.08 9.66663 5C9.66663 5.92 8.91996 6.66667 7.99996 6.66667C7.07996 6.66667 6.33329 5.92 6.33329 5C6.33329 4.08 7.07996 3.33333 7.99996 3.33333ZM4.99996 5C4.99996 3.34667 6.34663 2 7.99996 2C9.65329 2 11 3.34667 11 5C11 6.65333 9.65329 8 7.99996 8C6.34663 8 4.99996 6.65333 4.99996 5Z"
      fill="currentColor"
    />
  ),
});

export const SwipeHandleIcon = createIcon({
  displayName: 'SwipeHandleIcon',
  viewBox: '0 0 24.433 26.58',
  path: (
    <svg
      id="Group_15057"
      data-name="Group 15057"
      xmlns="http://www.w3.org/2000/svg"
      width="24.433"
      height="26.58"
      viewBox="0 0 24.433 26.58"
    >
      <path
        id="Path_21026"
        data-name="Path 21026"
        d="M50.836-499.587c-1.258,1.258-1.351,1.388-1.177,1.712a15.864,15.864,0,0,0,1.2,1.276c1.071,1.065,1.127,1.108,1.363,1.108a.476.476,0,0,0,.523-.517c0-.212-.056-.286-.654-.865a6.119,6.119,0,0,1-.654-.685c0-.025,1.669-.05,3.7-.05,3.605,0,3.711-.006,3.829-.124a.529.529,0,0,0-.124-.853,28.788,28.788,0,0,0-3.792-.081H51.415l.666-.679c.554-.56.666-.7.666-.866,0-.274-.056-.38-.255-.479C52.144-500.87,52.094-500.839,50.836-499.587Z"
        transform="translate(-49.592 500.775)"
      />
      <path
        id="Path_21027"
        data-name="Path 21027"
        d="M604.812-500.942a.5.5,0,0,0-.268.51c0,.174.087.293.666.872l.672.672H602.24a29.259,29.259,0,0,0-3.8.081.519.519,0,0,0-.124.853c.118.118.224.125,3.842.125h3.718l-.666.679c-.623.629-.666.691-.666.922a.478.478,0,0,0,.529.517c.224,0,.3-.062,1.351-1.108a17.174,17.174,0,0,0,1.214-1.276c.168-.324.075-.455-1.183-1.712C605.211-501.048,605.161-501.079,604.812-500.942Z"
        transform="translate(-583.27 500.997)"
      />
      <path
        id="Path_21028"
        data-name="Path 21028"
        d="M286.407-383.218a1.669,1.669,0,0,0-1.171.859c-.137.255-.137.261-.168,5.38l-.031,5.125-.735-1.277c-.791-1.37-1.059-1.694-1.526-1.831a1.57,1.57,0,0,0-2.067,1.513c0,.461.044.548.965,2.148.411.7.8,1.432.878,1.619s.3.909.492,1.6a22.311,22.311,0,0,0,2.665,6.276c.423.76.473.9.305.9a.473.473,0,0,0-.261.156.539.539,0,0,0-.012.735l.143.137,4.981.019,4.981.012.187-.181a.473.473,0,0,0,.025-.722.472.472,0,0,0-.249-.156c-.237,0-.081-.716.6-2.771a31.308,31.308,0,0,0,1.077-3.817,16.558,16.558,0,0,0,.318-4,8.055,8.055,0,0,0-.1-2.248,1.689,1.689,0,0,0-1.476-.99c-.6,0-.573-.069-.573,1.5v1.37l-.156.149a.486.486,0,0,1-.7.006l-.174-.149L294.6-373.8a13.5,13.5,0,0,0-.106-2.111,1.7,1.7,0,0,0-1.868-.89l-.143.037v3.854l-.162.149a.47.47,0,0,1-.716-.025l-.181-.181v-1.862c0-1.818-.006-1.862-.149-2.167a1.524,1.524,0,0,0-1.42-.9c-.6,0-.548-.243-.548,2.5v2.428l-.181.181a.436.436,0,0,1-.672.031l-.174-.149-.031-4.6c-.031-4.583-.031-4.6-.168-4.85a1.845,1.845,0,0,0-.791-.741A2.053,2.053,0,0,0,286.407-383.218Z"
        transform="translate(-274.441 386.424)"
      />
    </svg>
  ),
});

export const CurledNextArrow = createIcon({
  displayName: 'CurledNextArrow',
  viewBox: '0 0 14 14',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
      <g id="Ellipse_1553" data-name="Ellipse 1553" fill="none" stroke="#00a18f" strokeWidth="3">
        <circle cx="7" cy="7" r="7" stroke="none" />
        <circle cx="7" cy="7" r="5.5" fill="none" />
      </g>
    </svg>
  ),
});

export const ActiveDot = createIcon({
  displayName: 'ActiveDot',
  viewBox: '0 0 14 14',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
      <g id="Ellipse_1553" data-name="Ellipse 1553" fill="none" stroke="#00a18f" strokeWidth="3">
        <circle cx="7" cy="7" r="7" stroke="none" />
        <circle cx="7" cy="7" r="5.5" fill="none" />
      </g>
    </svg>
  ),
});

export const RatingStar = createIcon({
  displayName: 'RatingStar',
  viewBox: '0 0 10.808 10.317',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10.808"
      height="10.317"
      viewBox="0 0 10.808 10.317"
    >
      <g id="noun_Star_2120030" transform="translate(-96.839 -67.673)">
        <g id="Group_14966" data-name="Group 14966" transform="translate(96.839 67.673)">
          <path
            id="Path_21001"
            data-name="Path 21001"
            d="M5.784.273,6.877,3.658l3.558-.007a.387.387,0,0,1,.226.7L7.78,6.436,8.885,9.817a.387.387,0,0,1-.617.415L5.416,8.151l-2.874,2.1a.386.386,0,0,1-.594-.431l1.1-3.381L.171,4.35a.388.388,0,0,1,.255-.7l3.529.007L5.048.273a.387.387,0,0,1,.736,0Z"
            transform="translate(-0.011 -0.006)"
            fill="#e8950f"
            fillRule="evenodd"
          />
        </g>
      </g>
    </svg>
  ),
});

export const ArrowRightIcon = createIcon({
  displayName: 'ArrowRightIcon',
  viewBox: '0 0 19 9.999',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="9.999" viewBox="0 0 19 9.999">
      <defs>
        <clipPath id="clip-path">
          <path
            id="Color"
            d="M1,10A1,1,0,0,1,.293,8.292L3.6,4.987.418,1.694A1,1,0,0,1,1.857.3l3.862,4a1,1,0,0,1-.012,1.4l-4,4A1,1,0,0,1,1,10"
            transform="translate(9.5 7.001)"
            fill="currentColor"
          />
        </clipPath>
      </defs>
      <g id="Group_14442" data-name="Group 14442" transform="translate(-5122.5 2673.999)">
        <g
          id="Icons_Arrow_Chevron_Right"
          data-name="Icons / Arrow / Chevron / Right"
          transform="translate(5135.5 -2673.999)"
        >
          <g id="Group_79" data-name="Group 79" transform="translate(-9.5 -7.001)">
            <path
              id="Color-2"
              data-name="Color"
              d="M1,10A1,1,0,0,1,.293,8.292L3.6,4.987.418,1.694A1,1,0,0,1,1.857.3l3.862,4a1,1,0,0,1-.012,1.4l-4,4A1,1,0,0,1,1,10"
              transform="translate(9.5 7.001)"
              fill="currentColor"
            />
          </g>
        </g>
        <line
          id="Line_201"
          data-name="Line 201"
          x2="17"
          transform="translate(5122.5 -2669)"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  ),
});

export const LogoIcon = createIcon({
  displayName: 'LogoIcon',
  viewBox: '0 0 31.352 27.907',
  path: (
    <svg
      id="Group_13584"
      data-name="Group 13584"
      xmlns="http://www.w3.org/2000/svg"
      width="31.352"
      height="27.907"
      viewBox="0 0 31.352 27.907"
    >
      <path
        id="Path_19827"
        data-name="Path 19827"
        d="M23.46,27.13h0a1.785,1.785,0,0,1,.282-2.333,12.307,12.307,0,0,0,3.936-7.54,11.868,11.868,0,0,0-2.721-9.4,12.086,12.086,0,0,0-16.3-2C3.908,9.5,2.2,16.2,4.77,21.125a7.825,7.825,0,0,0,.66,1.057,4.649,4.649,0,0,0,3.337,2.039,7.779,7.779,0,0,0,4.921-1.536,19.539,19.539,0,0,1-2.064-3.331,7.806,7.806,0,0,1-.745-4.735,7.531,7.531,0,0,1,2.406-4.176,7.932,7.932,0,0,1,4.3-2.056,5.436,5.436,0,0,1,2.609.3,5.259,5.259,0,0,1,2.028,1.383A5.957,5.957,0,0,1,23.573,12.6a6.452,6.452,0,0,1,.056,2.942,12.133,12.133,0,0,1-2.6,5.091A25.757,25.757,0,0,1,18.7,23.118,14.681,14.681,0,0,0,20,24.279a1.791,1.791,0,0,1,.431,2.325h0a1.785,1.785,0,0,1-2.636.483,18.617,18.617,0,0,1-1.808-1.647,11.831,11.831,0,0,1-6.721,2.373,8.41,8.41,0,0,1-.851-.043,8.245,8.245,0,0,1-5.834-3.454,11.456,11.456,0,0,1-.964-1.539A14.88,14.88,0,0,1,.55,12,16.807,16.807,0,0,1,6.493,3.021,14.965,14.965,0,0,1,17.587.136a16.123,16.123,0,0,1,5.491,1.741,15.59,15.59,0,0,1,4.592,3.657,15.212,15.212,0,0,1,3.113,5.851,16,16,0,0,1-4.647,16.063,1.788,1.788,0,0,1-2.676-.319ZM18.294,11.911a2.3,2.3,0,0,0-.279.018,4.511,4.511,0,0,0-3.623,3.307c-.289,1.652.751,3.369,2.021,5.129,1.718-1.649,3.284-3.51,3.723-5.568a2.652,2.652,0,0,0-.554-2.321,1.682,1.682,0,0,0-1.288-.565Z"
        transform="translate(-0.004 -0.003)"
        fill="#000310"
      />
    </svg>
  ),
});

export const HeartFilledIcon2 = createIcon({
  displayName: 'HeartFilledIcon2',
  viewBox: '0 0 21.439 18.375',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21.439"
      height="18.375"
      viewBox="0 0 21.439 18.375"
    >
      <g
        id="_4ec89e0721b7410286a63cb8137066f6"
        data-name="4ec89e0721b7410286a63cb8137066f6"
        transform="translate(-10 -80)"
      >
        <path
          id="Path_248"
          data-name="Path 248"
          d="M20.719,98.375a.723.723,0,0,1-.527-.214l-7.464-7.2a3.671,3.671,0,0,1-.328-.311q-.21-.217-.665-.783a10.366,10.366,0,0,1-.814-1.166,7.314,7.314,0,0,1-.641-1.448A5.239,5.239,0,0,1,10,85.6a5.478,5.478,0,0,1,1.52-4.115A5.756,5.756,0,0,1,15.72,80a4.791,4.791,0,0,1,1.514.256,6.172,6.172,0,0,1,1.435.693q.663.436,1.142.818a11.464,11.464,0,0,1,.908.814,11.09,11.09,0,0,1,.908-.814q.479-.384,1.144-.818a6.169,6.169,0,0,1,1.435-.693A4.791,4.791,0,0,1,25.719,80a5.76,5.76,0,0,1,4.2,1.483,5.486,5.486,0,0,1,1.52,4.115q0,2.645-2.741,5.383L21.246,98.16A.723.723,0,0,1,20.719,98.375Z"
          fill="#ff677f"
        />
      </g>
    </svg>
  ),
});

export const VerifiedIcon = createIcon({
  displayName: 'VerifiedIcon',
  viewBox: '0 0 15.656 15.656',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15.656"
      height="15.653"
      viewBox="0 0 15.656 15.653"
    >
      <g id="noun_verified_1983696" transform="translate(-5.033 -4.988)">
        <path
          id="Path_20406"
          data-name="Path 20406"
          d="M20.4,13.858a2.609,2.609,0,0,1,0-1.982l.087-.209a2.616,2.616,0,0,0-1.408-3.408l-.191-.087a2.546,2.546,0,0,1-1.408-1.408l-.07-.174a2.65,2.65,0,0,0-3.426-1.408l-.174.07a2.653,2.653,0,0,1-2,0l-.156-.07A2.625,2.625,0,0,0,8.261,6.607l-.07.139A2.546,2.546,0,0,1,6.783,8.155l-.156.07a2.622,2.622,0,0,0-1.391,3.408l.07.156a2.609,2.609,0,0,1,0,1.982l-.07.191a2.576,2.576,0,0,0,1.408,3.391l.174.07a2.546,2.546,0,0,1,1.408,1.408l.087.191A2.6,2.6,0,0,0,11.7,20.449l.191-.087a2.653,2.653,0,0,1,2,0l.156.07a2.616,2.616,0,0,0,3.408-1.408l.07-.139a2.546,2.546,0,0,1,1.408-1.408l.139-.052a2.6,2.6,0,0,0,1.408-3.408Zm-8.277,2.347h0L8.731,13.354,9.774,12.12l2.156,1.826,3.808-4.521,1.235,1.043-4.851,5.738Z"
          fill="#969798"
        />
      </g>
    </svg>
  ),
});

export const VideoIcon2 = createIcon({
  displayName: 'VideoIcon2',
  viewBox: '0 0 22.333 17.976',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22.333"
      height="17.976"
      viewBox="0 0 22.333 17.976"
    >
      <g id="Video" transform="translate(0.75 0.75)">
        <path
          id="Stroke_1"
          data-name="Stroke 1"
          d="M16.055,12.407a3.939,3.939,0,0,1-4.272,4.069H4.259A3.93,3.93,0,0,1,0,12.407V4.08A3.942,3.942,0,0,1,4.272,0h7.511a3.948,3.948,0,0,1,4.272,4.08Z"
          fill="none"
          stroke="#200e32"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Stroke_3"
          data-name="Stroke 3"
          d="M0,5,3.414.319C3.956-.428,4.778.221,4.778,1.4V11c0,1.184-.823,1.83-1.364,1.085L0,7.4"
          transform="translate(16.055 2.037)"
          fill="none"
          stroke="#200e32"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  ),
});

export const ProfileIcon2 = createIcon({
  displayName: 'ProfileIcon2',
  viewBox: '0 0 16.001 20',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="16.001" height="20" viewBox="0 0 16.001 20">
      <g id="Profile" transform="translate(0)">
        <path
          id="Profile-2"
          data-name="Profile"
          d="M6.676,19.964c-.121,0-.206,0-.284,0l-.144-.005a2.214,2.214,0,0,1-.4-.047,15.4,15.4,0,0,1-2.333-.338l-.256-.054a3.961,3.961,0,0,1-2.975-1.9A2.936,2.936,0,0,1,0,16.363,2.876,2.876,0,0,1,.287,15.1a4.334,4.334,0,0,1,3.2-1.948,16.744,16.744,0,0,1,2.339-.331c.718-.063,1.448-.094,2.17-.094s1.452.031,2.17.094l.461.039a17.218,17.218,0,0,1,1.873.292c1.727.355,2.749.979,3.215,1.962a2.912,2.912,0,0,1,0,2.5c-.464.978-1.512,1.616-3.2,1.949l-.468.1a15.713,15.713,0,0,1-1.88.245c-.715.061-1.442.092-2.158.092C7.563,20,7.114,19.988,6.676,19.964Zm-.734-5.7a15.528,15.528,0,0,0-2.156.305,3.21,3.21,0,0,0-2.205,1.168,1.417,1.417,0,0,0-.14.624,1.452,1.452,0,0,0,.139.627c.255.527,1.025.93,2.228,1.165l.353.075a15.507,15.507,0,0,0,1.874.249,1.84,1.84,0,0,0,.287.033l.393.006c.429.023.866.035,1.3.035.678,0,1.366-.029,2.047-.087a14.344,14.344,0,0,0,2.162-.315l.225-.048c1.061-.24,1.743-.624,1.973-1.108a1.463,1.463,0,0,0,0-1.259c-.245-.516-1.008-.92-2.209-1.167a15.575,15.575,0,0,0-2.152-.3l-.013,0c-.675-.059-1.361-.089-2.038-.089S6.628,14.2,5.943,14.264ZM2.692,5.335A5.313,5.313,0,1,1,8,10.67,5.33,5.33,0,0,1,2.692,5.335Zm1.442,0A3.871,3.871,0,1,0,8,1.448,3.883,3.883,0,0,0,4.134,5.335Z"
          fill="#200e32"
        />
      </g>
    </svg>
  ),
});

export const CalendarIcon3 = createIcon({
  displayName: 'Calendar3',
  viewBox: '0 0 19.5 21.5',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="19.5" height="21.5" viewBox="0 0 19.5 21.5">
      <g id="Calendar" transform="translate(0.75 0.75)">
        <path
          id="Line_200"
          d="M0,.473H17.824"
          transform="translate(0.093 6.931)"
          fill="none"
          stroke="#200e32"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Line_201"
          d="M.459.473H.468"
          transform="translate(12.984 10.837)"
          fill="none"
          stroke="#200e32"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Line_202"
          d="M.459.473H.468"
          transform="translate(8.546 10.837)"
          fill="none"
          stroke="#200e32"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Line_203"
          d="M.459.473H.468"
          transform="translate(4.099 10.837)"
          fill="none"
          stroke="#200e32"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Line_204"
          d="M.459.473H.468"
          transform="translate(12.984 14.723)"
          fill="none"
          stroke="#200e32"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Line_205"
          d="M.459.473H.468"
          transform="translate(8.546 14.723)"
          fill="none"
          stroke="#200e32"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Line_206"
          d="M.459.473H.468"
          transform="translate(4.099 14.723)"
          fill="none"
          stroke="#200e32"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Line_207"
          d="M.463,0V3.291"
          transform="translate(12.581 0)"
          fill="none"
          stroke="#200e32"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Line_208"
          d="M.463,0V3.291"
          transform="translate(4.502 0)"
          fill="none"
          stroke="#200e32"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Path"
          d="M13.238,0H4.771C1.834,0,0,1.636,0,4.643v9.05c0,3.054,1.834,4.728,4.771,4.728h8.458c2.946,0,4.771-1.645,4.771-4.652V4.643C18.009,1.636,16.184,0,13.238,0Z"
          transform="translate(0 1.579)"
          fill="none"
          stroke="#200e32"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  ),
});

export const PersonIcon = createIcon({
  displayName: 'PersonIcon',
  viewBox: '0 0 64 64',
  path: (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse
        cx="30.508"
        cy="19.7922"
        rx="12.5891"
        ry="12.5891"
        stroke="#07A560"
        strokeWidth="3.95217"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5391 49.8918C10.5357 49.0068 10.7336 48.1327 11.1179 47.3354C12.3238 44.9237 15.7243 43.6455 18.546 43.0667C20.5809 42.6325 22.6441 42.3423 24.7199 42.1985C28.5632 41.8609 32.4287 41.8609 36.2719 42.1985C38.3476 42.344 40.4106 42.6341 42.4459 43.0667C45.2676 43.6455 48.6681 44.8031 49.8739 47.3354C50.6467 48.9606 50.6467 50.8472 49.8739 52.4724C48.6681 55.0046 45.2676 56.1623 42.4459 56.7169C40.4133 57.1692 38.3494 57.4675 36.2719 57.6093C33.1438 57.8745 30.0011 57.9228 26.8663 57.754C26.1428 57.754 25.4434 57.754 24.7199 57.6093C22.6502 57.4692 20.5942 57.1709 18.5701 56.7169C15.7243 56.1623 12.3479 55.0046 11.1179 52.4724C10.7356 51.6659 10.5379 50.7843 10.5391 49.8918Z"
        stroke="#07A560"
        strokeWidth="3.95217"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const CameraIcon = createIcon({
  displayName: 'CameraIcon',
  viewBox: '0 0 64 64',
  path: (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.7509 41.7719C41.7509 47.023 38.1728 50.7328 32.4501 50.7328H16.0697C10.3522 50.7328 6.79785 47.023 6.79785 41.7719V23.4338C6.79785 18.1853 10.3522 14.4492 16.0986 14.4492H32.4501C38.1728 14.4492 41.7509 18.1853 41.7509 23.4338V41.7719Z"
        stroke="#F79C17"
        strokeWidth="3.95217"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.751 30.3252L52.5457 21.4882C54.2583 20.0785 56.8588 21.3037 56.8588 23.5354V41.6416C56.8588 43.8759 54.2583 45.0958 52.5457 43.6888L41.751 34.8518"
        stroke="#F79C17"
        strokeWidth="3.95217"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const SearchIcon = createIcon({
  displayName: 'SearchIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg
      id="Iconly_Light_Search"
      data-name="Iconly/Light/Search"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="Search" transform="translate(2 2)">
        <circle
          id="Ellipse_739"
          cx="8.989"
          cy="8.989"
          r="8.989"
          transform="translate(0.778 0.778)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Line_181"
          d="M0,0,3.524,3.515"
          transform="translate(16.018 16.485)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  ),
});

export const DialerIcon = createIcon({
  displayName: 'DialerIcon',
  viewBox: '0 0 37.052 37.052',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="37.052" height="37.052">
      <path
        d="M22.51 0A14.557 14.557 0 008.583 10.359H2.191A2.2 2.2 0 000 12.55v22.311a2.2 2.2 0 002.191 2.191H14.94a2.2 2.2 0 002.191-2.191V28.05A14.541 14.541 0 1022.509 0zm0 1.2A13.347 13.347 0 119.163 14.538 13.338 13.338 0 0122.51 1.195zm-6.375 4.383a2.59 2.59 0 102.59 2.59 2.6 2.6 0 00-2.59-2.595zm6.374 0a2.59 2.59 0 102.59 2.59 2.6 2.6 0 00-2.59-2.595zm6.375 0a2.59 2.59 0 102.59 2.59 2.6 2.6 0 00-2.59-2.595zm-12.749 1.2a1.394 1.394 0 11-1.394 1.394 1.385 1.385 0 011.394-1.404zm6.374 0a1.394 1.394 0 11-1.394 1.394 1.385 1.385 0 011.394-1.404zm6.375 0a1.394 1.394 0 11-1.394 1.394 1.385 1.385 0 011.394-1.404zM2.191 11.554h6.087a14.515 14.515 0 00-.275 2.036.6.6 0 00-.233-.044H5.378a.6.6 0 000 1.2h2.39a.6.6 0 00.2-.033 14.547 14.547 0 007.964 12.8v7.351a.981.981 0 01-1 1H2.191a.981.981 0 01-1-1V12.55a.981.981 0 011-.996zm13.943.4a2.59 2.59 0 102.59 2.59 2.6 2.6 0 00-2.589-2.592zm6.374 0a2.59 2.59 0 102.59 2.59 2.6 2.6 0 00-2.589-2.592zm6.375 0a2.59 2.59 0 102.59 2.59 2.6 2.6 0 00-2.589-2.592zm-12.749 1.2a1.394 1.394 0 11-1.394 1.384 1.385 1.385 0 011.395-1.39zm6.374 0a1.394 1.394 0 11-1.394 1.394 1.385 1.385 0 011.395-1.4zm6.375 0a1.394 1.394 0 11-1.394 1.394 1.385 1.385 0 011.395-1.4zm-12.749 5.179a2.59 2.59 0 102.59 2.59 2.6 2.6 0 00-2.589-2.596zm6.374 0a2.59 2.59 0 102.59 2.59 2.6 2.6 0 00-2.589-2.596zm6.375 0a2.59 2.59 0 102.59 2.59 2.6 2.6 0 00-2.589-2.596zm-12.749 1.2a1.394 1.394 0 11-1.394 1.394 1.385 1.385 0 011.395-1.405zm6.374 0a1.394 1.394 0 11-1.394 1.394 1.385 1.385 0 011.395-1.405zm6.375 0a1.394 1.394 0 11-1.394 1.394 1.385 1.385 0 011.395-1.405zM8.566 32.271a1 1 0 101 1 1 1 0 00-1-1z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  ),
});

export const CreditCardLightIcon = createIcon({
  displayName: 'CreditCardLightIcon',
  viewBox: '0 0 39.552 28.898',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="39.552" height="28.898">
      <path
        d="M3.972 0A3.975 3.975 0 000 3.968v20.958a3.979 3.979 0 003.972 3.972h31.607a3.98 3.98 0 003.972-3.972V3.968A3.976 3.976 0 0035.578 0zm0 1.411h31.607a2.538 2.538 0 012.562 2.557v3.108H1.411V3.968a2.537 2.537 0 012.561-2.557zM1.411 8.488h36.73v3.514H1.411zm0 4.925h36.73v11.513a2.541 2.541 0 01-2.563 2.561H3.972a2.54 2.54 0 01-2.561-2.561zm4.316 4.655a.706.706 0 100 1.411h8.878a.706.706 0 000-1.411zm0 3.812a.706.706 0 100 1.411h3.791a.706.706 0 100-1.411z"
        fill="currentColor"
      />
    </svg>
  ),
});

export const WalletLightIcon = createIcon({
  displayName: 'WalletLightIcon',
  viewBox: '0 0 33.139 31.672',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="33.139" height="31.672">
      <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
        <path d="M32.638 18.257H28.59a2.692 2.692 0 110-5.383h4.048M26.57 15.501h-.312" />
        <path d="M9.312.5h14.515a8.964 8.964 0 018.812 9.108v12.456a8.964 8.964 0 01-8.812 9.108H9.312A8.964 8.964 0 01.5 22.064V9.608A8.964 8.964 0 019.312.5zM9.327 8.377h5.4" />
      </g>
    </svg>
  ),
});

export const ClockIcon = createIcon({
  displayName: 'ClockIcon',
  viewBox: '0 0 16.417 16.417',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.42 16.42">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Icons_24px" data-name="Icons 24px">
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.92,8.21A7.71,7.71,0,1,1,8.21.5,7.71,7.71,0,0,1,15.92,8.21Z"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M11.07,10.66,7.93,8.79v-4"
          />
        </g>
      </g>
    </svg>
  ),
});

export const BulbIcon = createIcon({
  displayName: 'BulbIcon',
  viewBox: '0 0 15.5 20.5',
  path: (
    <svg
      id="Lightbulb"
      xmlns="http://www.w3.org/2000/svg"
      width="15.5"
      height="20.5"
      viewBox="0 0 15.5 20.5"
    >
      <g id="Lightbulb-2" data-name="Lightbulb">
        <path
          fill="currentColor"
          id="Shape"
          d="M7.75,20.5a8.11,8.11,0,0,1-1.715-.184l-.2-.042a2.59,2.59,0,0,1-2.052-2.349,21.081,21.081,0,0,0-.364-2.372c-.121-.619-.264-1.291-.393-1.843a.324.324,0,0,0-.133-.176A7.334,7.334,0,0,1,0,7.516,7.644,7.644,0,0,1,7.75,0,7.644,7.644,0,0,1,15.5,7.516a7.335,7.335,0,0,1-2.9,6.018.315.315,0,0,0-.133.176c-.128.542-.272,1.214-.394,1.843a21.378,21.378,0,0,0-.364,2.372,2.59,2.59,0,0,1-2.052,2.349l-.2.042A8.1,8.1,0,0,1,7.75,20.5ZM5.062,16.16a16.573,16.573,0,0,1,.223,1.675,1.083,1.083,0,0,0,.871.974l.2.042a6.622,6.622,0,0,0,2.8,0l.2-.042a1.085,1.085,0,0,0,.872-.974,16.238,16.238,0,0,1,.223-1.675ZM7.75,1.5A6.143,6.143,0,0,0,1.5,7.516a5.78,5.78,0,0,0,2.285,4.81,1.818,1.818,0,0,1,.7,1.04c.067.287.171.744.284,1.293h5.951c.1-.478.2-.926.284-1.293a1.822,1.822,0,0,1,.7-1.04A5.78,5.78,0,0,0,14,7.516,6.143,6.143,0,0,0,7.75,1.5Z"
          transform="translate(0 0)"
        />
      </g>
    </svg>
  ),
});

export const HouseIcon = createIcon({
  displayName: 'HouseIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 8.7773C3.5 8.28991 3.7368 7.83291 4.13498 7.55184L11.135 2.61067C11.6536 2.2446 12.3464 2.2446 12.865 2.61067L19.865 7.55184C20.2632 7.83291 20.5 8.28991 20.5 8.77729V19.0001C20.5 19.8285 19.8284 20.5001 19 20.5001H14.5V13.5001H9.5V20.5001H5C4.17157 20.5001 3.5 19.8285 3.5 19.0001V8.7773Z"
        stroke="currentColor"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const EllipseIcon = createIcon({
  displayName: 'EllipseIcon',
  viewBox: '0 0 4 16',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="4" height="16" viewBox="0 0 4 16">
      <path
        id="path"
        d="M596,879.6a1.933,1.933,0,1,1-.6,1.4A1.64,1.64,0,0,1,596,879.6Zm6,0a1.933,1.933,0,1,1-.6,1.4A1.64,1.64,0,0,1,602,879.6Zm6,0a1.933,1.933,0,1,1-.6,1.4A1.64,1.64,0,0,1,608,879.6Z"
        transform="translate(883 -595.4) rotate(90)"
      />
    </svg>
  ),
});

export const CardChipIcon = createIcon({
  displayName: 'CardChipIcon',
  viewBox: '0 0 4 16',
  path: (
    <svg
      id="Group_14732"
      data-name="Group 14732"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="35.94"
      height="31.494"
      viewBox="0 0 35.94 31.494"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.047"
          y1="0.083"
          x2="0.944"
          y2="0.953"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stop-color="#FBCA6D" />
          <stop offset="1" stop-color="#AA8106" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopOpacity="0" />
          <stop offset="1" />
        </linearGradient>
      </defs>
      <rect id="Rectangle" width="35.939" height="31.494" rx="3.3" fill="url(#linear-gradient)" />
      <path
        id="Rectangle_2"
        data-name="Rectangle 2"
        d="M0,15.359H10.4a1.958,1.958,0,0,0,1.986-1.928V2.779A1.958,1.958,0,0,0,10.4.851H0V0H10.4a2.809,2.809,0,0,1,2.837,2.779V13.431A2.809,2.809,0,0,1,10.4,16.21H0Z"
        transform="translate(0 7.41)"
        fill="url(#linear-gradient-2)"
      />
      <path
        id="Union_6"
        data-name="Union 6"
        d="M24.874,31.281V23.62h.851v7.661Zm-16.173,0V23.62h.851v7.661ZM25.063,23.62a2.809,2.809,0,0,1-2.838-2.779V19.578H13.241v1.264A2.808,2.808,0,0,1,10.4,23.62H0v-.851H10.4a1.958,1.958,0,0,0,1.986-1.927v-5.52H0V14.47H12.39V10.19A1.958,1.958,0,0,0,10.4,8.261H0V7.41H8.7V0h.851V7.41H10.4a2.809,2.809,0,0,1,2.838,2.779v.025h8.985V10.19a2.8,2.8,0,0,1,2.648-2.773V0h.851V7.41H35.94v.851H25.063a1.958,1.958,0,0,0-1.986,1.928V14.47H35.94v.851H23.077v5.52a1.958,1.958,0,0,0,1.986,1.927H35.94v.851Zm-2.838-4.894V11.065H13.241v7.661Z"
        fill="url(#linear-gradient-2)"
      />
    </svg>
  ),
});

export const JpgIcon = createIcon({
  displayName: 'JpgIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34.316"
      height="31.457"
      viewBox="0 0 34.316 31.457"
    >
      <g id="image" transform="translate(0 -0.492)">
        <path
          id="Path_20329"
          data-name="Path 20329"
          d="M8.936,163.486a5.354,5.354,0,0,1-5.065-3.648l-.05-.164a5.219,5.219,0,0,1-.247-1.55v-9.749L.105,159.954a3.247,3.247,0,0,0,2.276,3.939l22.11,5.921a3.28,3.28,0,0,0,.824.106,3.188,3.188,0,0,0,3.09-2.338l1.288-4.1Zm0,0"
          transform="translate(0 -137.971)"
          fill="#ECEFF1"
        />
        <path
          id="Path_20330"
          data-name="Path 20330"
          d="M113.918,3.709V20.153A3.222,3.222,0,0,1,110.7,23.37H88.537a3.755,3.755,0,0,1-.415-.029,3.2,3.2,0,0,1-2.788-2.931,1.545,1.545,0,0,1-.014-.257V3.709A3.222,3.222,0,0,1,88.537.492H110.7A3.222,3.222,0,0,1,113.918,3.709Zm0,0"
          transform="translate(-79.602)"
          fill="#ECEFF1"
        />
        <path
          id="Path_20331"
          data-name="Path 20331"
          d="M155.04,67.352a2.86,2.86,0,1,1-2.86-2.86A2.86,2.86,0,0,1,155.04,67.352Zm0,0"
          transform="translate(-139.312 -59.71)"
          fill="#FFC107"
        />
        <path
          id="Path_20332"
          data-name="Path 20332"
          d="M152.928,119.037v4.018a3.222,3.222,0,0,1-3.217,3.217H127.548a3.758,3.758,0,0,1-.415-.029l14.728-14.727a2.52,2.52,0,0,1,3.546,0Zm0,0"
          transform="translate(-118.612 -102.902)"
          fill="#388E3C"
        />
        <path
          id="Path_20333"
          data-name="Path 20333"
          d="M105.624,195.935H88.738a3.754,3.754,0,0,1-.415-.029,3.2,3.2,0,0,1-2.788-2.931l6.792-6.792a2.52,2.52,0,0,1,3.546,0Zm0,0"
          transform="translate(-79.802 -172.565)"
          fill="#4CAF50"
        />
      </g>
    </svg>
  ),
});

export const PdfIcon = createIcon({
  displayName: 'PdfIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg">
      <g id="file" transform="translate(-28.155)">
        <path
          id="Path_20334"
          data-name="Path 20334"
          d="M107.643,58.759A2.446,2.446,0,0,0,105.2,56.32H86.914a2.446,2.446,0,0,0-2.439,2.439V81.52a2.446,2.446,0,0,0,2.439,2.439h13.818l6.91-6.5Z"
          transform="translate(-51.849 -51.849)"
          fill="#DADEE0"
        />
        <path
          id="Path_20335"
          data-name="Path 20335"
          d="M32.626,6.91a2.446,2.446,0,0,1,2.439-2.439H51.323V2.439A2.446,2.446,0,0,0,48.884,0H30.594a2.446,2.446,0,0,0-2.439,2.439V25.2a2.446,2.446,0,0,0,2.439,2.439h2.032Z"
          transform="translate(0)"
          fill="#1BB7EA"
        />
        <path
          id="Path_20336"
          data-name="Path 20336"
          d="M291.7,322.56h4.471l-6.91,6.5V325A2.446,2.446,0,0,1,291.7,322.56Z"
          transform="translate(-240.382 -296.954)"
          fill="#F2F2F2"
        />
        <g id="Group_13303" data-name="Group 13303" transform="translate(38.113 9.958)">
          <path
            id="Path_20337"
            data-name="Path 20337"
            d="M154.2,177.859h10.974a.61.61,0,0,0,0-1.219H154.2a.61.61,0,0,0,0,1.219"
            transform="translate(-153.595 -172.576)"
            fill="#1F4254"
          />
          <path
            id="Path_20338"
            data-name="Path 20338"
            d="M154.2,126.659h10.974a.61.61,0,0,0,0-1.219H154.2a.61.61,0,0,0,0,1.219"
            transform="translate(-153.595 -125.44)"
            fill="#1F4254"
          />
          <path
            id="Path_20339"
            data-name="Path 20339"
            d="M154.2,229.059h10.974a.61.61,0,1,0,0-1.219H154.2a.61.61,0,0,0,0,1.219"
            transform="translate(-153.595 -219.711)"
            fill="#1F4254"
          />
          <path
            id="Path_20340"
            data-name="Path 20340"
            d="M154.2,280.259h6.1a.61.61,0,0,0,0-1.219h-6.1a.61.61,0,0,0,0,1.219"
            transform="translate(-153.595 -266.847)"
            fill="#1F4254"
          />
        </g>
      </g>
    </svg>
  ),
});

export const FolderIcon = createIcon({
  displayName: 'FolderIcon',
  viewBox: '0 0 64.895 51.375',
  path: (
    <svg
      id="folder"
      xmlns="http://www.w3.org/2000/svg"
      width="64.895"
      height="51.375"
      viewBox="0 0 64.895 51.375"
    >
      <path
        id="Path_20327"
        data-name="Path 20327"
        d="M74.1,53.334H28.13a6.743,6.743,0,0,0-6.695,7.639,1.352,1.352,0,0,0,2.025.992,3.829,3.829,0,0,1,1.966-.519h9.626A4.077,4.077,0,0,1,38.9,64.2l.23.741a6.792,6.792,0,0,0,6.416,4.618H76.8a4.055,4.055,0,0,1,2.02.541,1.355,1.355,0,0,0,2.036-1.168V60.094A6.76,6.76,0,0,0,74.1,53.334Z"
        transform="translate(-18.666 -53.334)"
        fill="currentColor"
        fillOpacity="0.5"
      />
      <path
        id="Path_20328"
        data-name="Path 20328"
        d="M61.523,105.025a6.72,6.72,0,0,0-3.388-.914H26.877a4.077,4.077,0,0,1-3.845-2.753l-.23-.741A6.792,6.792,0,0,0,16.386,96H6.76a6.469,6.469,0,0,0-3.31.873A6.744,6.744,0,0,0,0,102.759v32.447a6.76,6.76,0,0,0,6.76,6.76H58.135a6.76,6.76,0,0,0,6.76-6.76V110.871A6.714,6.714,0,0,0,61.523,105.025Z"
        transform="translate(0 -90.591)"
        fill="currentColor"
      />
    </svg>
  ),
});

export const EmptyFolderIcon = createIcon({
  displayName: 'EmptyFolderIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg
      id="Capa_1"
      enable-background="new 0 0 512.001 512.001"
      height="512"
      viewBox="0 0 512.001 512.001"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <g clipRule="evenodd" fillRule="evenodd">
          <path
            d="m416.001 432.937v-68.465-264.962l-89.511-89.51h-230.489v354.472 68.465z"
            fill="#fff"
          />
          <path
            d="m416.001 432.937h-320v-68.465c-33.743 4.474-60 33.551-60 68.465 0 37.986 31.079 69.065 69.065 69.065h301.87c37.986 0 69.065-31.079 69.065-69.065 0-34.914-26.257-63.991-60-68.465z"
            fill="#60a4ff"
          />
        </g>
        <g>
          <path d="m186 186.944c-5.523 0-10 4.477-10 10v9.508c0 5.523 4.477 10 10 10s10-4.477 10-10v-9.508c0-5.523-4.477-10-10-10z" />
          <path d="m326.001 216.452c5.523 0 10-4.477 10-10v-9.508c0-5.523-4.477-10-10-10s-10 4.477-10 10v9.508c0 5.523 4.477 10 10 10z" />
          <path d="m296.748 257.56c-10.884-10.884-25.354-16.878-40.747-16.878s-29.863 5.994-40.747 16.878c-3.905 3.905-3.905 10.237 0 14.142s10.237 3.905 14.142 0c7.106-7.106 16.554-11.02 26.604-11.02s19.499 3.914 26.604 11.02c1.953 1.953 4.512 2.929 7.071 2.929s5.119-.977 7.071-2.929c3.906-3.905 3.907-10.237.002-14.142z" />
          <path d="m426.001 356.214v-256.704c0-2.652-1.054-5.196-2.929-7.071l-89.51-89.51c-1.876-1.875-4.419-2.929-7.072-2.929h-230.49c-5.523 0-10 4.477-10 10v346.215c-34.682 8.681-60 40.426-60 76.721 0 43.597 35.468 79.065 79.064 79.065h301.871c43.596 0 79.064-35.468 79.064-79.065.001-36.345-25.298-68.045-59.998-76.722zm-89.511-322.072 55.368 55.368h-55.368zm70.446 457.859h-301.871c-32.568 0-59.064-26.497-59.064-59.065 0-25.399 16.599-47.816 40-55.88v45.88c-5.523 0-10 4.477-10 10s4.477 10 10 10h124.997c5.523 0 10-4.477 10-10s-4.477-10-10-10h-104.997v-402.936h210.49v79.51c0 5.523 4.477 10 10 10h79.509v313.426h-105.002c-5.523 0-10 4.477-10 10s4.477 10 10 10h125.003c5.523 0 10-4.477 10-10s-4.477-10-10-10v-45.883c23.411 8.057 40 30.447 40 55.883-.001 32.569-26.497 59.065-59.065 59.065z" />
          <path d="m256.001 422.937h-.008c-5.523 0-9.996 4.477-9.996 10s4.481 10 10.004 10 10-4.477 10-10-4.477-10-10-10z" />
        </g>
      </g>
    </svg>
  ),
});

export const CircleIcon = createIcon({
  displayName: 'CircleIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
      <g id="Path_20391" fill="#fff">
        <path
          d="M 7.5 13 C 4.467289924621582 13 2 10.53271007537842 2 7.5 C 2 4.467289924621582 4.467289924621582 2 7.5 2 C 9.449299812316895 2 11.15517044067383 2.999340057373047 12.30338954925537 4.813940048217773 L 12.30778026580811 4.820879936218262 L 12.31223011016846 4.827789783477783 C 12.62950038909912 5.320189952850342 13 6.315489768981934 13 7.5 C 13 10.53271007537842 10.53271007537842 13 7.5 13 Z"
          stroke="none"
        />
        <path
          d="M 7.5 4 C 5.570090293884277 4 4 5.570090293884277 4 7.5 C 4 9.429910659790039 5.570090293884277 11 7.5 11 C 9.429910659790039 11 11 9.429910659790039 11 7.5 C 11 6.759639739990234 10.7736701965332 6.13247013092041 10.63101005554199 5.911060333251953 L 10.61331939697266 5.883359909057617 C 10.06966018676758 5.02418041229248 9.088210105895996 4 7.5 4 M 7.5 0 C 10.16339015960693 0 12.50253009796143 1.388310432434082 13.99345970153809 3.74452018737793 C 14.57203960418701 4.642470359802246 15 6.021260261535645 15 7.5 C 15 11.64213943481445 11.64213943481445 15 7.5 15 C 3.35785961151123 15 0 11.64213943481445 0 7.5 C 0 3.35785961151123 3.35785961151123 0 7.5 0 Z"
          stroke="none"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
});

export const SaveMoneyIcon = createIcon({
  displayName: 'SaveMoneyIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12.806"
      height="14.637"
      viewBox="0 0 12.806 14.637"
    >
      <g id="noun_Save_3560585" transform="translate(-22 -18)">
        <g id="Group_14757" data-name="Group 14757" transform="translate(22 18)">
          <path
            id="Path_20842"
            data-name="Path 20842"
            d="M34.806,24.4V19.829A1.829,1.829,0,0,0,32.977,18H23.829A1.829,1.829,0,0,0,22,19.829V24.4a1.829,1.829,0,0,0,1.829,1.829h1.829V24.4H23.829V19.829h9.147V24.4H31.147v1.829h1.829A1.829,1.829,0,0,0,34.806,24.4Z"
            transform="translate(-22 -18)"
            fill="#fff"
          />
          <path
            id="Path_20843"
            data-name="Path 20843"
            d="M35.464,34v7.853l-1.829-1.829L32.34,41.318l3.391,3.391a.915.915,0,0,0,1.294,0l3.391-3.391-1.294-1.294-1.829,1.829V34Z"
            transform="translate(-29.975 -30.341)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  ),
});

export const PillsIcon = createIcon({
  displayName: 'PillsIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.73 16.45">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Icons_24px" data-name="Icons 24px">
          <path
            fill="none"
            stroke="#200e32"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.02px"
            d="M1,11,4.82,2.36A3.14,3.14,0,0,1,9,.79H9A3.15,3.15,0,0,1,10.56,5L9.42,7.47"
          />
          <line
            fill="none"
            stroke="#200e32"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.02px"
            x1="4.45"
            y1="6.51"
            x2="7.66"
            y2="7.95"
          />
          <rect
            fill="none"
            stroke="#200e32"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.02px"
            x="0.51"
            y="9.56"
            width="15.71"
            height="6.3"
            rx="3.15"
            transform="translate(0.24 -0.16) rotate(1.09)"
          />
          <line
            fill="none"
            stroke="#200e32"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.02px"
            x1="8.4"
            y1="10.95"
            x2="8.33"
            y2="14.46"
          />
        </g>
      </g>
    </svg>
  ),
});

export const HealthJournalIcon = createIcon({
  displayName: 'HealthJournalIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.69 17.88">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Icons_24px" data-name="Icons 24px">
          <path
            fill="none"
            stroke="#200e32"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.02px"
            d="M7.78,1.69H4.67A4,4,0,0,0,.5,6.07V13a4,4,0,0,0,4.17,4.38H12A4,4,0,0,0,16.19,13V9.64"
          />
          <path
            fill="none"
            stroke="#200e32"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.02px"
            d="M8,4,10.39,1A1.45,1.45,0,0,1,12.54.94l2.77,1.84a1.46,1.46,0,0,1,.36,2.12l-6.4,7.81a1.1,1.1,0,0,1-.87.4L6,13.09,5.5,10.74a1.14,1.14,0,0,1,.23-.94l4.94-6.08a1,1,0,0,1,1.45-.14h0A1,1,0,0,1,12.26,5l-.55.67a1,1,0,0,1-1.45.14Z"
          />
        </g>
      </g>
    </svg>
  ),
});

export const WhatsappIcon = createIcon({
  displayName: 'WhatsappIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M 12.011719 2 C 6.5057187 2 2.0234844 6.478375 2.0214844 11.984375 C 2.0204844 13.744375 2.4814687 15.462563 3.3554688 16.976562 L 2 22 L 7.2324219 20.763672 C 8.6914219 21.559672 10.333859 21.977516 12.005859 21.978516 L 12.009766 21.978516 C 17.514766 21.978516 21.995047 17.499141 21.998047 11.994141 C 22.000047 9.3251406 20.962172 6.8157344 19.076172 4.9277344 C 17.190172 3.0407344 14.683719 2.001 12.011719 2 z M 12.009766 4 C 14.145766 4.001 16.153109 4.8337969 17.662109 6.3417969 C 19.171109 7.8517969 20.000047 9.8581875 19.998047 11.992188 C 19.996047 16.396187 16.413812 19.978516 12.007812 19.978516 C 10.674812 19.977516 9.3544062 19.642812 8.1914062 19.007812 L 7.5175781 18.640625 L 6.7734375 18.816406 L 4.8046875 19.28125 L 5.2851562 17.496094 L 5.5019531 16.695312 L 5.0878906 15.976562 C 4.3898906 14.768562 4.0204844 13.387375 4.0214844 11.984375 C 4.0234844 7.582375 7.6067656 4 12.009766 4 z M 8.4765625 7.375 C 8.3095625 7.375 8.0395469 7.4375 7.8105469 7.6875 C 7.5815469 7.9365 6.9355469 8.5395781 6.9355469 9.7675781 C 6.9355469 10.995578 7.8300781 12.182609 7.9550781 12.349609 C 8.0790781 12.515609 9.68175 15.115234 12.21875 16.115234 C 14.32675 16.946234 14.754891 16.782234 15.212891 16.740234 C 15.670891 16.699234 16.690438 16.137687 16.898438 15.554688 C 17.106437 14.971687 17.106922 14.470187 17.044922 14.367188 C 16.982922 14.263188 16.816406 14.201172 16.566406 14.076172 C 16.317406 13.951172 15.090328 13.348625 14.861328 13.265625 C 14.632328 13.182625 14.464828 13.140625 14.298828 13.390625 C 14.132828 13.640625 13.655766 14.201187 13.509766 14.367188 C 13.363766 14.534188 13.21875 14.556641 12.96875 14.431641 C 12.71875 14.305641 11.914938 14.041406 10.960938 13.191406 C 10.218937 12.530406 9.7182656 11.714844 9.5722656 11.464844 C 9.4272656 11.215844 9.5585938 11.079078 9.6835938 10.955078 C 9.7955938 10.843078 9.9316406 10.663578 10.056641 10.517578 C 10.180641 10.371578 10.223641 10.267562 10.306641 10.101562 C 10.389641 9.9355625 10.347156 9.7890625 10.285156 9.6640625 C 10.223156 9.5390625 9.737625 8.3065 9.515625 7.8125 C 9.328625 7.3975 9.131125 7.3878594 8.953125 7.3808594 C 8.808125 7.3748594 8.6425625 7.375 8.4765625 7.375 z" />
    </svg>
  ),
});

export const HomeCareIcon = createIcon({
  displayName: 'HomeCareIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27.793"
      height="29.118"
      viewBox="0 0 27.793 29.118"
    >
      <g id="Layer_2" data-name="Layer 2" transform="translate(0.5 0.673)">
        <g id="Icons_24px" data-name="Icons 24px" transform="translate(0.5 0.489)">
          <path
            id="Path_21005"
            data-name="Path 21005"
            d="M17.763,26.19a5.948,5.948,0,0,0,7.372-.689A3.631,3.631,0,0,0,26.293,23h0V11.149a3.271,3.271,0,0,0-1.3-2.582L16.057,1.43a4.32,4.32,0,0,0-5.384,0L1.8,8.583A3.271,3.271,0,0,0,.5,11.165V23a3.882,3.882,0,0,0,.986,2.5,5.2,5.2,0,0,0,6.621.955l7.262-4.21a3.365,3.365,0,1,0-3.882,0Z"
            transform="translate(-0.5 -0.489)"
            fill="none"
            stroke="#200E32"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </g>
      </g>
    </svg>
  ),
});

export const CovidIcon = createIcon({
  displayName: 'CovidIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.14 16.14">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Icons_24px" data-name="Icons 24px">
          <circle fill="none" stroke="#200e32" strokeMiterlimit="10" cx="8.07" cy="8.07" r="5.23" />
          <circle fill="none" stroke="#200e32" strokeMiterlimit="10" cx="7.28" cy="6.07" r="0.87" />
          <circle
            fill="none"
            stroke="#200e32"
            strokeMiterlimit="10"
            cx="10.83"
            cy="8.59"
            r="0.87"
          />
          <circle
            fill="none"
            stroke="#200e32"
            strokeMiterlimit="10"
            cx="6.31"
            cy="10.04"
            r="0.87"
          />
          <line
            strokeLinecap="round"
            fill="none"
            stroke="#200e32"
            strokeMiterlimit="10"
            x1="8.07"
            y1="2.84"
            x2="8.07"
            y2="0.5"
          />
          <line
            strokeLinecap="round"
            fill="none"
            stroke="#200e32"
            strokeMiterlimit="10"
            x1="7.08"
            y1="0.5"
            x2="9.05"
            y2="0.5"
          />
          <line
            strokeLinecap="round"
            fill="none"
            stroke="#200e32"
            strokeMiterlimit="10"
            x1="4.37"
            y1="4.37"
            x2="2.72"
            y2="2.72"
          />
          <line
            strokeLinecap="round"
            fill="none"
            stroke="#200e32"
            strokeMiterlimit="10"
            x1="2.02"
            y1="3.41"
            x2="3.41"
            y2="2.02"
          />
          <line
            strokeLinecap="round"
            fill="none"
            stroke="#200e32"
            strokeMiterlimit="10"
            x1="2.84"
            y1="8.07"
            x2="0.5"
            y2="8.07"
          />
          <line
            strokeLinecap="round"
            fill="none"
            stroke="#200e32"
            strokeMiterlimit="10"
            x1="0.5"
            y1="9.05"
            x2="0.5"
            y2="7.08"
          />
          <line
            strokeLinecap="round"
            fill="none"
            stroke="#200e32"
            strokeMiterlimit="10"
            x1="4.37"
            y1="11.77"
            x2="2.72"
            y2="13.42"
          />
          <line
            strokeLinecap="round"
            fill="none"
            stroke="#200e32"
            strokeMiterlimit="10"
            x1="3.41"
            y1="14.12"
            x2="2.02"
            y2="12.73"
          />
          <line
            strokeLinecap="round"
            fill="none"
            stroke="#200e32"
            strokeMiterlimit="10"
            x1="8.07"
            y1="13.3"
            x2="8.07"
            y2="15.64"
          />
          <line
            strokeLinecap="round"
            fill="none"
            stroke="#200e32"
            strokeMiterlimit="10"
            x1="9.05"
            y1="15.64"
            x2="7.08"
            y2="15.64"
          />
          <line
            strokeLinecap="round"
            fill="none"
            stroke="#200e32"
            strokeMiterlimit="10"
            x1="11.77"
            y1="11.77"
            x2="13.42"
            y2="13.42"
          />
          <line
            strokeLinecap="round"
            fill="none"
            stroke="#200e32"
            strokeMiterlimit="10"
            x1="14.12"
            y1="12.73"
            x2="12.73"
            y2="14.12"
          />
          <line
            strokeLinecap="round"
            fill="none"
            stroke="#200e32"
            strokeMiterlimit="10"
            x1="13.3"
            y1="8.07"
            x2="15.64"
            y2="8.07"
          />
          <line
            strokeLinecap="round"
            fill="none"
            stroke="#200e32"
            strokeMiterlimit="10"
            x1="15.64"
            y1="7.08"
            x2="15.64"
            y2="9.05"
          />
          <line
            strokeLinecap="round"
            fill="none"
            stroke="#200e32"
            strokeMiterlimit="10"
            x1="11.77"
            y1="4.37"
            x2="13.42"
            y2="2.72"
          />
          <line
            strokeLinecap="round"
            fill="none"
            stroke="#200e32"
            strokeMiterlimit="10"
            x1="12.73"
            y1="2.02"
            x2="14.12"
            y2="3.41"
          />
        </g>
      </g>
    </svg>
  ),
});

export const DashboardIcon = createIcon({
  displayName: 'DashboardIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.67 17.67">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Icons_24px" data-name="Icons 24px">
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12.4.5h2.73a2.05,2.05,0,0,1,2,2.06V5.3a2.05,2.05,0,0,1-2,2.06H12.4a2.05,2.05,0,0,1-2-2.06V2.56A2.05,2.05,0,0,1,12.4.5Z"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M2.54.5H5.26a2,2,0,0,1,2,2.06V5.3a2,2,0,0,1-2,2.06H2.54A2,2,0,0,1,.5,5.3V2.56A2,2,0,0,1,2.54.5Z"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M2.54,10.3H5.26a2.05,2.05,0,0,1,2,2.06v2.75a2,2,0,0,1-2,2.06H2.54a2,2,0,0,1-2-2.06V12.36A2.05,2.05,0,0,1,2.54,10.3Z"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12.4,10.3h2.73a2.06,2.06,0,0,1,2,2.06v2.75a2.05,2.05,0,0,1-2,2.06H12.4a2.05,2.05,0,0,1-2-2.06V12.36A2.06,2.06,0,0,1,12.4,10.3Z"
          />
        </g>
      </g>
    </svg>
  ),
});

export const CrossIcon = createIcon({
  displayName: 'CrossIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.08 16">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Icons_24px" data-name="Icons 24px">
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M5.81,11.11A.81.81,0,0,0,5,10.29l-.83,0c-.58,0-1.17,0-1.74,0A2.17,2.17,0,0,1,.5,8a2.14,2.14,0,0,1,1.37-2,2.46,2.46,0,0,1,.85-.16H5.08a.8.8,0,0,0,.8-.8V2.76A2.16,2.16,0,0,1,7,.81,2.09,2.09,0,0,1,9,.72,2.18,2.18,0,0,1,10.3,2.84V4.93a.81.81,0,0,0,.81.81c.7,0,1.68,0,2.27,0a2.19,2.19,0,0,1,2.18,2.51A2.24,2.24,0,0,1,13.4,10.1H11a.81.81,0,0,0-.8.81v2.39a2.21,2.21,0,1,1-4.42-.08C5.78,12.68,5.79,11.78,5.81,11.11Z"
          />
        </g>
      </g>
    </svg>
  ),
});

export const CodeIcon = createIcon({
  displayName: 'CodeIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.96027 8.109H4.99429L3 9.43333V10.4149L4.94755 9.12173H4.99429V16.0862H5.96027V8.109Z"
        fill="currentColor"
      />
      <path
        d="M10.6757 16.1952C12.222 16.1952 13.3711 15.2253 13.3711 13.9205C13.3711 12.9078 12.7712 12.1716 11.7663 12.0041V11.9418C12.5726 11.6964 13.075 11.0342 13.075 10.1344C13.075 9.00487 12.1831 7.99994 10.7068 7.99994C9.32797 7.99994 8.18281 8.84907 8.13607 10.1033H9.07089C9.10595 9.30869 9.86159 8.84128 10.6912 8.84128C11.5715 8.84128 12.1402 9.37491 12.1402 10.1812C12.1402 11.0225 11.482 11.5678 10.5354 11.5678H9.89665V12.4248H10.5354C11.7468 12.4248 12.4207 13.0402 12.4207 13.9205C12.4207 14.7657 11.6845 15.3383 10.6601 15.3383C9.73695 15.3383 9.00467 14.8631 8.94625 14.0919H7.96468C8.02311 15.3461 9.12932 16.1952 10.6757 16.1952Z"
        fill="currentColor"
      />
      <path
        d="M15.1574 16.0862L15.9598 13.827H19.1849L19.9873 16.0862H21L18.0709 8.109H17.0737L14.1446 16.0862H15.1574ZM16.2636 12.9701L17.5412 9.37101H17.6035L18.8811 12.9701H16.2636Z"
        fill="currentColor"
      />
    </svg>
  ),
});

export const AlertIcon = createIcon({
  displayName: 'AlertIcon',
  viewBox: '0 0 21.002 18',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="21.002" height="18" viewBox="0 0 21.002 18">
      <g id="noun_Error_2472926" transform="translate(-0.999 -2)">
        <g id="Group_13434" data-name="Group 13434">
          <path
            id="Path_20476"
            data-name="Path 20476"
            d="M11.5,15.5a1,1,0,1,1-1,1A1,1,0,0,1,11.5,15.5Zm.5-6v4a.5.5,0,1,1-1,0v-4A.5.5,0,1,1,12,9.5ZM2.374,19H20.626L11.5,3.486Zm-1.305.246,10-17a.5.5,0,0,1,.862,0l10,17A.5.5,0,0,1,21.5,20H1.5A.5.5,0,0,1,1.069,19.246Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  ),
});

export const UserIcon = createIcon({
  displayName: 'UserIcon',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.29 15.82">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Icons_24px" data-name="Icons 24px">
          <path
            fill="none"
            stroke="currentColor"
            strokeMiterlimit={10}
            d="M11.79,12.75a2.5,2.5,0,0,0-.29-1.1,4.77,4.77,0,0,0-1.44-1.46L4.93,6.3A5.22,5.22,0,0,1,3.34,4.68,2.8,2.8,0,0,1,3.22,2.5,3.17,3.17,0,0,1,7.55.82,2.79,2.79,0,0,1,9.1,3.2,3.32,3.32,0,0,1,8.53,5,9.11,9.11,0,0,1,6,7.39L2.69,9.71a5.19,5.19,0,0,0-2,2.17,2.52,2.52,0,0,0,.91,2.91,4.85,4.85,0,0,0,2.77.53l4,0a4.83,4.83,0,0,0,2-.31,2.48,2.48,0,0,0,1.26-1.42A2.72,2.72,0,0,0,11.79,12.75Z"
          />
        </g>
      </g>
    </svg>
  ),
});

export const StethoscopeIcon = createIcon({
  displayName: 'StethoscopeIcon',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.49 16.22">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Icons_24px" data-name="Icons 24px">
          <path
            fill="none"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeWidth="1.02px"
            d="M11.89,1.48h0a2.09,2.09,0,0,1,2,2.81l-1.2,3.26a3,3,0,0,1-2.83,2h0A3,3,0,0,1,7,7.55L5.8,4.29a2.09,2.09,0,0,1,2-2.81h0"
          />
          <line
            fill="none"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeWidth="1.02px"
            strokeLinecap="round"
            x1="7.66"
            y1="0.51"
            x2="7.66"
            y2="2.45"
          />
          <line
            fill="none"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeWidth="1.02px"
            strokeLinecap="round"
            x1="11.87"
            y1="0.51"
            x2="11.87"
            y2="2.45"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeWidth="1.02px"
            d="M1.41,13.91V9.67A2.09,2.09,0,0,1,3.5,7.58h0A2.1,2.1,0,0,1,5.59,9.67v3.68a2.17,2.17,0,0,0,2.17,2.16h0a2.17,2.17,0,0,0,2.17-2.16V9.53"
          />
          <circle
            fill="none"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeWidth="1.02px"
            cx="1.41"
            cy="14.81"
            r="0.9"
          />
        </g>
      </g>
    </svg>
  ),
});

export const UserIconAlt = createIcon({
  displayName: 'UserIcon',
  path: (
    <svg
      id="Iconly_Light_Profile"
      data-name="Iconly/Light/Profile"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="Profile" transform="translate(4 2.5)">
        <circle
          id="Ellipse_736"
          cx="4.778"
          cy="4.778"
          r="4.778"
          transform="translate(2.801 0)"
          fill="none"
          stroke="#200E32"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Path_33945"
          d="M0,3.016a2.215,2.215,0,0,1,.22-.97A4.042,4.042,0,0,1,3.039.426,16.787,16.787,0,0,1,5.382.1,25.053,25.053,0,0,1,9.767.1a16.979,16.979,0,0,1,2.343.33c1.071.22,2.362.659,2.819,1.62a2.27,2.27,0,0,1,0,1.95c-.458.961-1.748,1.4-2.819,1.611a15.716,15.716,0,0,1-2.343.339A25.822,25.822,0,0,1,6.2,6a4.066,4.066,0,0,1-.815-.055,15.423,15.423,0,0,1-2.334-.339C1.968,5.4.687,4.957.22,4A2.279,2.279,0,0,1,0,3.016Z"
          transform="translate(0 13.185)"
          fill="none"
          stroke="#200E32"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  ),
});

export const HistoryIcon = createIcon({
  displayName: 'HistoryIcon',
  path: (
    <svg
      id="Iconly_Light_Time_Square"
      data-name="Iconly/Light/Time Square"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="Time_Square" data-name="Time Square" transform="translate(2 2)">
        <path
          id="Stroke_1"
          data-name="Stroke 1"
          d="M13.584,0H4.915C1.894,0,0,2.139,0,5.166v8.168C0,16.361,1.884,18.5,4.915,18.5h8.668c3.031,0,4.917-2.139,4.917-5.166V5.166C18.5,2.139,16.614,0,13.584,0Z"
          transform="translate(0.751 0.75)"
          fill="none"
          stroke="#200E32"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Stroke_3"
          data-name="Stroke 3"
          d="M3.391,6.384,0,4.361V0"
          transform="translate(10 5.634)"
          fill="none"
          stroke="#200E32"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  ),
});

export const HomeIcon = createIcon({
  displayName: 'HomeIcon',
  path: (
    <svg
      id="Home"
      xmlns="http://www.w3.org/2000/svg"
      width="23.433"
      height="24.667"
      viewBox="0 0 23.433 24.667"
    >
      <path
        id="Home-2"
        data-name="Home"
        d="M8.183,23.154V19.383A1.75,1.75,0,0,1,9.939,17.64h3.545a1.762,1.762,0,0,1,1.242.511,1.737,1.737,0,0,1,.514,1.233v3.771a1.5,1.5,0,0,0,.439,1.069,1.518,1.518,0,0,0,1.074.444h2.418a4.268,4.268,0,0,0,3.013-1.232,4.205,4.205,0,0,0,1.249-2.988V9.7a3.05,3.05,0,0,0-1.1-2.346L14.1.834a3.82,3.82,0,0,0-4.87.088L1.193,7.356A3.051,3.051,0,0,0,0,9.7V20.435a4.247,4.247,0,0,0,4.263,4.232H6.626a1.519,1.519,0,0,0,1.524-1.5Z"
        transform="translate(0 0)"
        fill="currentColor"
      />
    </svg>
  ),
});

export const User2Icon = createIcon({
  displayName: 'User2Icon',
  viewBox: '0 0 24 24',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.58 15.82">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Icons_24px" data-name="Icons 24px">
          <path
            fill="none"
            stroke="currentColor"
            strokeMiterlimit={10}
            d="M11.79,12.75a2.5,2.5,0,0,0-.29-1.1,4.77,4.77,0,0,0-1.44-1.46L4.93,6.3A5.22,5.22,0,0,1,3.34,4.68,2.8,2.8,0,0,1,3.22,2.5,3.17,3.17,0,0,1,7.55.82,2.79,2.79,0,0,1,9.1,3.2,3.32,3.32,0,0,1,8.53,5,9.11,9.11,0,0,1,6,7.39L2.69,9.71a5.19,5.19,0,0,0-2,2.17,2.52,2.52,0,0,0,.91,2.91,4.85,4.85,0,0,0,2.77.53l4,0a4.83,4.83,0,0,0,2-.31,2.48,2.48,0,0,0,1.26-1.42A2.72,2.72,0,0,0,11.79,12.75Z"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M10.41,1a2.76,2.76,0,0,1,1.11,3.21,6.27,6.27,0,0,1-2,2.56.42.42,0,0,0,0,.71c1.11.91,2.33,1.68,3.48,2.55"
          />
        </g>
      </g>
    </svg>
  ),
});

export const OutpostIcon = createIcon({
  displayName: 'OutpostIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27.174"
      height="24.203"
      viewBox="0 0 27.174 24.203"
    >
      <g id="Layer_2" data-name="Layer 2" transform="translate(-0.022 0.003)">
        <g id="Layer_1" data-name="Layer 1" transform="translate(0.022 -0.003)">
          <path
            id="Path_21158"
            data-name="Path 21158"
            d="M26.7,9.859A13.2,13.2,0,0,0,24,4.8a13.514,13.514,0,0,0-3.98-3.173A13.963,13.963,0,0,0,15.262.117,13.805,13.805,0,0,0,13.477,0,12.761,12.761,0,0,0,5.643,2.616,14.541,14.541,0,0,0,.5,10.395a12.924,12.924,0,0,0,.918,9.344,9.889,9.889,0,0,0,.833,1.339,7.184,7.184,0,0,0,5.081,3.006,7.365,7.365,0,0,0,.745.037,9.659,9.659,0,0,0,5.739-2.068,15.984,15.984,0,0,0,1.571,1.428,1.613,1.613,0,1,0,1.992-2.536A12.719,12.719,0,0,1,16.32,20a21.971,21.971,0,0,0,1.959-2.093,10.528,10.528,0,0,0,2.254-4.42,5.653,5.653,0,0,0-.05-2.572A5.2,5.2,0,0,0,19.293,8.7a4.6,4.6,0,0,0-1.776-1.21,4.669,4.669,0,0,0-1.657-.3,5.118,5.118,0,0,0-.628.039,6.9,6.9,0,0,0-3.747,1.791A6.552,6.552,0,0,0,9.393,12.66a6.81,6.81,0,0,0,.651,4.126,16.9,16.9,0,0,0,1.739,2.819,6.959,6.959,0,0,1-3.711,1.289,3.858,3.858,0,0,1-3.24-1.748,6.848,6.848,0,0,1-.563-.9C2.07,14.034,3.534,8.294,7.6,5.177A9.64,9.64,0,0,1,13.53,3.211,10.524,10.524,0,0,1,21.548,6.89a10.155,10.155,0,0,1,2.328,8.047,10.532,10.532,0,0,1-3.368,6.453,1.614,1.614,0,1,0,2.165,2.394A13.875,13.875,0,0,0,26.7,9.858Zm-12.449,7.65c-.952-1.327-1.932-2.856-1.679-4.292a3.823,3.823,0,0,1,3.057-2.79,1.938,1.938,0,0,1,.231-.014,1.381,1.381,0,0,1,1.059.463,2.208,2.208,0,0,1,.458,1.933,10.069,10.069,0,0,1-3.127,4.7Z"
            transform="translate(-0.022 0.003)"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  ),
});

export const SquareClockIcon = createIcon({
  displayName: 'SquareClockIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.42 16.42">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Icons_24px" data-name="Icons 24px">
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M11.82.5H4.6A4,4,0,0,0,.5,4.8v6.81a4,4,0,0,0,4.1,4.31h7.22a4,4,0,0,0,4.1-4.31V4.8A4,4,0,0,0,11.82.5Z"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M11,9.89,8.21,8.2V4.57"
          />
        </g>
      </g>
    </svg>
  ),
});

export const DocumentIcon = createIcon({
  displayName: 'DocumentIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.7162 16.2233H8.49622"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7162 12.0368H8.49622"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2513 7.86003H8.49628"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9086 2.74974C15.9086 2.74974 8.23161 2.75374 8.21961 2.75374C5.45961 2.77074 3.75061 4.58674 3.75061 7.35674V16.5527C3.75061 19.3367 5.47261 21.1597 8.25661 21.1597C8.25661 21.1597 15.9326 21.1567 15.9456 21.1567C18.7056 21.1397 20.4156 19.3227 20.4156 16.5527V7.35674C20.4156 4.57274 18.6926 2.74974 15.9086 2.74974Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const ListIcon = createIcon({
  displayName: 'PaperIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.5 5.49994H8.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 11.9999H8.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 18.4999H8.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 5.49994H4.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 11.9999H4.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 18.4999H4.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const PaperIcon = createIcon({
  displayName: 'PaperIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7368 2.76184H8.08376C6.02476 2.76184 4.24976 4.43084 4.24976 6.49084V17.2038C4.24976 19.3798 5.90876 21.1148 8.08376 21.1148H16.0728C18.1328 21.1148 19.8018 19.2648 19.8018 17.2038V8.03784L14.7368 2.76184Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4741 2.75014V5.65914C14.4741 7.07914 15.6231 8.23114 17.0421 8.23414C18.3591 8.23714 19.7061 8.23814 19.7971 8.23214"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.284 15.5577H8.88702"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2425 10.6056H8.88654"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const PowerIcon = createIcon({
  displayName: 'PowerIcon',
  viewBox: '0 0 18 18',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.77 4.97998C14.7138 5.92407 15.3564 7.12681 15.6167 8.43612C15.877 9.74543 15.7432 11.1025 15.2322 12.3358C14.7212 13.5691 13.8561 14.6231 12.7461 15.3647C11.6361 16.1063 10.3311 16.5022 8.99622 16.5022C7.66129 16.5022 6.35633 16.1063 5.24635 15.3647C4.13636 14.6231 3.2712 13.5691 2.76024 12.3358C2.24929 11.1025 2.11549 9.74543 2.37576 8.43612C2.63603 7.12681 3.27869 5.92407 4.22247 4.97998"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 1.5V9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const RewindIcon = createIcon({
  displayName: 'RewindIcon',
  viewBox: '0 0 16 16',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.66663 3.66665L8.99996 7.99998L3.66663 12.3333L3.66663 3.66665Z"
        stroke="#666666"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.66663 3.66665L13 7.99998L7.66663 12.3333"
        stroke="#666666"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const NotificationIcon = createIcon({
  displayName: 'NotificationIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.50083 13.7871V13.5681C3.53295 12.9202 3.7406 12.2925 4.10236 11.7496C4.7045 11.0975 5.1167 10.2983 5.29571 9.43598C5.29571 8.7695 5.29571 8.0935 5.35393 7.42703C5.65469 4.21842 8.82728 2 11.9611 2H12.0387C15.1725 2 18.345 4.21842 18.6555 7.42703C18.7137 8.0935 18.6555 8.7695 18.704 9.43598C18.8854 10.3003 19.2972 11.1019 19.8974 11.7591C20.2618 12.2972 20.4698 12.9227 20.4989 13.5681V13.7776C20.5206 14.648 20.2208 15.4968 19.6548 16.1674C18.907 16.9515 17.8921 17.4393 16.8024 17.5384C13.607 17.8812 10.383 17.8812 7.18762 17.5384C6.09914 17.435 5.08576 16.9479 4.33521 16.1674C3.778 15.4963 3.48224 14.6526 3.50083 13.7871Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.55493 20.8518C10.0542 21.4785 10.7874 21.884 11.5922 21.9788C12.3971 22.0735 13.2072 21.8495 13.8433 21.3564C14.0389 21.2106 14.2149 21.041 14.3672 20.8518"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const MessageIcon = createIcon({
  displayName: 'MessageIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.2678 9.0611L13.0024 12.4954C12.1952 13.1282 11.0636 13.1282 10.2564 12.4954L5.95435 9.0611"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.88787 3.5H16.3158C17.6752 3.51525 18.969 4.08993 19.896 5.0902C20.823 6.09048 21.3022 7.42903 21.222 8.79412V15.322C21.3022 16.6871 20.823 18.0256 19.896 19.0259C18.969 20.0262 17.6752 20.6009 16.3158 20.6161H6.88787C3.96796 20.6161 2 18.2407 2 15.322V8.79412C2 5.87545 3.96796 3.5 6.88787 3.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const ShoppingCartIcon = createIcon({
  displayName: 'ShoppingCartIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Size=24, Weight=01 Thin, State=Active">
        <path
          id="Rectangle"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.5 7.5L19.1126 7.5C19.7951 7.5 20.2771 8.1687 20.0613 8.81623L17.7279 15.8162C17.5918 16.2246 17.2097 16.5 16.7792 16.5H7.39504C6.88549 16.5 6.45743 16.1169 6.40116 15.6104L5.5 7.5Z"
          stroke="currentColor"
          strokeLinejoin="round"
        />
        <circle id="Oval" cx="7" cy="20" r="1" fill="currentColor" />
        <circle id="Oval Copy" cx="15" cy="20" r="1" fill="currentColor" />
        <path
          id="Path 34"
          d="M1.5 4.5H5.17177L5.5 7.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
});

export const ShoppingCartIconNew = createIcon({
  displayName: 'ShoppingCartIconNew',
  viewBox: '0 0 19.652 18.75',
  path: (
    <svg
      id="Shopping-cart"
      xmlns="http://www.w3.org/2000/svg"
      width="19.652"
      height="18.75"
      viewBox="0 0 19.652 18.75"
    >
      <g id="Shopping-cart-2" data-name="Shopping-cart">
        <path
          fill="currentColor"
          id="Shape"
          d="M10.75,14.74a40.967,40.967,0,0,1-4.627-.263l-2.458-.282A.749.749,0,0,1,3.2,12.937L5.9,10.06l-.237-.523,0-.006L2.974,3.587,1.81,1.5H.75A.75.75,0,0,1,.75,0h1.5a.75.75,0,0,1,.655.384L4.085,2.5H17.9a1.75,1.75,0,0,1,1.463,2.71L18.284,6.852a.7.7,0,0,1-.054.073l-.578.685a9.352,9.352,0,0,1-6.367,3.268c-.4.032-.807.048-1.209.048A15.292,15.292,0,0,1,8.1,10.8l-.753-.1a.716.716,0,0,1-.053.064L5.318,12.874l.976.112a39.4,39.4,0,0,0,4.456.254,39.4,39.4,0,0,0,4.456-.254l2.459-.281a.757.757,0,0,1,.087-.005.75.75,0,0,1,.083,1.495l-2.458.282A40.967,40.967,0,0,1,10.75,14.74ZM4.807,4l2.22,4.913a.485.485,0,0,0,.379.282L8.3,9.31a13.82,13.82,0,0,0,1.783.116c.361,0,.727-.014,1.087-.043a7.837,7.837,0,0,0,5.338-2.741l.549-.65,1.053-1.6A.251.251,0,0,0,17.9,4Z"
          transform="translate(0 0)"
        />
        <path
          fill="currentColor"
          id="Path"
          d="M1.5,0A1.5,1.5,0,1,0,3,1.5,1.5,1.5,0,0,0,1.5,0Z"
          transform="translate(3.75 15.75)"
        />
        <path
          fill="currentColor"
          id="Path-2"
          data-name="Path"
          d="M0,1.5A1.5,1.5,0,1,1,1.5,3,1.5,1.5,0,0,1,0,1.5Z"
          transform="translate(14.75 15.75)"
        />
      </g>
    </svg>
  ),
});

export const PlusIconBig = createIcon({
  displayName: 'PlusIconBig',
  viewBox: '0 0 28 28',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29.914"
      height="29.914"
      viewBox="0 0 29.914 29.914"
    >
      <g id="Group_411" data-name="Group 411" transform="translate(0 0)">
        <path
          id="Path_207"
          data-name="Path 207"
          d="M24.957,10a1.5,1.5,0,0,1,1.5,1.5V23.461H38.418a1.434,1.434,0,0,1,1.056.44,1.45,1.45,0,0,1,.44,1.056,1.5,1.5,0,0,1-1.5,1.5H26.453V38.418A1.494,1.494,0,0,1,23.9,39.475a1.45,1.45,0,0,1-.44-1.056V26.453H11.5A1.494,1.494,0,0,1,10.44,23.9a1.45,1.45,0,0,1,1.056-.44H23.461V11.5a1.434,1.434,0,0,1,.44-1.056A1.45,1.45,0,0,1,24.957,10Z"
          transform="translate(-10 -10)"
          fill="#fff"
        />
      </g>
    </svg>
  ),
});

export const QuickMenuIcon = createIcon({
  displayName: 'PlusIconBig',
  viewBox: '0 0 27 27',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27">
      <g id="Group_12450" transform="translate(-723 -445.646)">
        <g id="Group_12451" transform="translate(723 446)">
          <circle
            id="Ellipse_91"
            cx="13.5"
            cy="13.5"
            r="13.5"
            transform="translate(0 -0.354)"
            fill="#dbc4ff43"
          />
          <g id="noun_Lightning_2184156" transform="translate(8.033 5.58)">
            <g id="Group_12450-2" transform="translate(0 0)">
              <path
                id="Path_19723"
                d="M34.6,963.362l-6.6,9.2h3.8l-1.8,6.4,6.8-9.2h-4Z"
                transform="translate(-28 -963.362)"
                fill="#3B1089"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
});

export const QuickMenuIconActive = createIcon({
  displayName: 'PlusIconBig',
  viewBox: '0 0 27 27',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27">
      <g id="Group_12450" transform="translate(-723 -445.646)">
        <g id="Group_12451" transform="translate(723 446)">
          <circle
            id="Ellipse_91"
            cx="13.5"
            cy="13.5"
            r="13.5"
            transform="translate(0 -0.354)"
            fill="#3B1089"
          />
          <g id="noun_Lightning_2184156" transform="translate(8.033 5.58)">
            <g id="Group_12450-2" transform="translate(0 0)">
              <path
                id="Path_19723"
                d="M34.6,963.362l-6.6,9.2h3.8l-1.8,6.4,6.8-9.2h-4Z"
                transform="translate(-28 -963.362)"
                fill="#fbf9fe"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
});

export const WalletIcon = createIcon({
  displayName: 'WalletIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.95 15.73">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Icons_24px" data-name="Icons 24px">
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M16.45,10H13.08a2.25,2.25,0,1,1,0-4.49h3.37"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13.46,7.7H13.2"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4.87.5h7.21a4.37,4.37,0,0,1,4.37,4.37v6a4.38,4.38,0,0,1-4.37,4.38H4.87A4.38,4.38,0,0,1,.5,10.85v-6A4.37,4.37,0,0,1,4.87.5Z"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4.28,4.28h4.5"
          />
        </g>
      </g>
    </svg>
  ),
});

export const AwardIcon = createIcon({
  displayName: 'AwardIcon',
  viewBox: '0 0 20 20',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.57143 3.5H13.4286C14.0203 3.5 14.5 3.97969 14.5 4.57143V9C14.5 11.4853 12.4853 13.5 10 13.5C7.51472 13.5 5.5 11.4853 5.5 9V4.57143C5.5 3.97969 5.97969 3.5 6.57143 3.5Z"
        stroke="currentColor"
      />
      <path d="M7 18H13" stroke="currentColor" strokeLinecap="round" />
      <path d="M10 15L10 18" stroke="currentColor" strokeLinecap="round" />
      <path
        d="M5.5 5H4C3.44772 5 3 5.44772 3 6V8.32297C3 8.73187 3.24895 9.09958 3.62861 9.25144L5.5 10"
        stroke="currentColor"
      />
      <path
        d="M14.5 5H16C16.5523 5 17 5.44772 17 6V8.32297C17 8.73187 16.751 9.09958 16.3714 9.25144L14.5 10"
        stroke="currentColor"
      />
    </svg>
  ),
});

export const UssdIcon = createIcon({
  displayName: 'UssdIcon',
  viewBox: '0 0 20 20',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37.052"
      height="37.052"
      viewBox="0 0 37.052 37.052"
    >
      <g id="noun_dialer_136570" transform="translate(-3.5 -3.5)">
        <g id="Group_13364" data-name="Group 13364" transform="translate(3.5 3.5)">
          <path
            id="Path_19830"
            data-name="Path 19830"
            d="M26.01,955.862a14.557,14.557,0,0,0-13.927,10.359H5.691A2.2,2.2,0,0,0,3.5,968.412v22.311a2.2,2.2,0,0,0,2.191,2.191H18.44a2.2,2.2,0,0,0,2.191-2.191v-6.811a14.541,14.541,0,1,0,5.378-28.05Zm0,1.2A13.347,13.347,0,1,1,12.663,970.4,13.338,13.338,0,0,1,26.01,957.057Zm-6.375,4.383a2.59,2.59,0,1,0,2.59,2.59A2.6,2.6,0,0,0,19.635,961.44Zm6.374,0a2.59,2.59,0,1,0,2.59,2.59A2.6,2.6,0,0,0,26.009,961.44Zm6.375,0a2.59,2.59,0,1,0,2.59,2.59A2.6,2.6,0,0,0,32.384,961.44Zm-12.749,1.2a1.394,1.394,0,1,1-1.394,1.394A1.385,1.385,0,0,1,19.635,962.635Zm6.374,0a1.394,1.394,0,1,1-1.394,1.394A1.385,1.385,0,0,1,26.009,962.635Zm6.375,0a1.394,1.394,0,1,1-1.394,1.394A1.385,1.385,0,0,1,32.384,962.635ZM5.691,967.416h6.087a14.515,14.515,0,0,0-.275,2.036.6.6,0,0,0-.233-.044H8.878a.6.6,0,0,0,0,1.2h2.39a.6.6,0,0,0,.2-.033,14.547,14.547,0,0,0,7.964,12.8v7.351a.981.981,0,0,1-1,1H5.691a.981.981,0,0,1-1-1V968.412A.981.981,0,0,1,5.691,967.416Zm13.943.4a2.59,2.59,0,1,0,2.59,2.59A2.6,2.6,0,0,0,19.635,967.814Zm6.374,0a2.59,2.59,0,1,0,2.59,2.59A2.6,2.6,0,0,0,26.009,967.814Zm6.375,0a2.59,2.59,0,1,0,2.59,2.59A2.6,2.6,0,0,0,32.384,967.814Zm-12.749,1.2A1.394,1.394,0,1,1,18.24,970.4,1.385,1.385,0,0,1,19.635,969.01Zm6.374,0a1.394,1.394,0,1,1-1.394,1.394A1.385,1.385,0,0,1,26.009,969.01Zm6.375,0a1.394,1.394,0,1,1-1.394,1.394A1.385,1.385,0,0,1,32.384,969.01Zm-12.749,5.179a2.59,2.59,0,1,0,2.59,2.59A2.6,2.6,0,0,0,19.635,974.189Zm6.374,0a2.59,2.59,0,1,0,2.59,2.59A2.6,2.6,0,0,0,26.009,974.189Zm6.375,0a2.59,2.59,0,1,0,2.59,2.59A2.6,2.6,0,0,0,32.384,974.189Zm-12.749,1.2a1.394,1.394,0,1,1-1.394,1.394A1.385,1.385,0,0,1,19.635,975.384Zm6.374,0a1.394,1.394,0,1,1-1.394,1.394A1.385,1.385,0,0,1,26.009,975.384Zm6.375,0a1.394,1.394,0,1,1-1.394,1.394A1.385,1.385,0,0,1,32.384,975.384ZM12.066,988.133a1,1,0,1,0,1,1A1,1,0,0,0,12.066,988.133Z"
            transform="translate(-3.5 -955.862)"
            fill="currentColor"
            fillRule="evenodd"
          />
        </g>
      </g>
    </svg>
  ),
});

export const PlusIcon = createIcon({
  displayName: 'PlusIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 4.99994V18.9999"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5 11.9999H19" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
});

export const MinusIcon = createIcon({
  displayName: 'MinusIcon',
  viewBox: '0 0 25 24',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.03125 12H19.0796"
        stroke="#9992A0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const ChatIcon = createIcon({
  displayName: 'ChatIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.69524 13.3908C7.05048 13.3908 6.52667 12.867 6.52667 12.2222C6.52667 11.5794 7.05048 11.0556 7.69524 11.0556C8.34001 11.0556 8.86382 11.5794 8.86382 12.2222C8.86382 12.867 8.34001 13.3908 7.69524 13.3908ZM12.2381 13.3908C11.5933 13.3908 11.0695 12.867 11.0695 12.2222C11.0695 11.5794 11.5933 11.0556 12.2381 11.0556C12.8829 11.0556 13.4067 11.5794 13.4067 12.2222C13.4067 12.867 12.8829 13.3908 12.2381 13.3908ZM15.6125 12.2222C15.6125 12.867 16.1363 13.3908 16.7811 13.3908C17.4258 13.3908 17.9496 12.867 17.9496 12.2222C17.9496 11.5794 17.4258 11.0556 16.7811 11.0556C16.1363 11.0556 15.6125 11.5794 15.6125 12.2222Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.02 1.99994C6.21 1.99994 2 6.74606 2 12.015C2 13.6975 2.49 15.4291 3.35 17.0115C3.51 17.2728 3.53 17.6023 3.42 17.9138L2.75 20.1572C2.6 20.698 3.06 21.0976 3.57 20.9373L5.59 20.3374C6.14 20.1572 6.57 20.3865 7.08 20.698C8.54 21.5583 10.36 21.9999 12 21.9999C16.96 21.9999 22 18.1642 22 11.9849C22 6.65592 17.7 1.99994 12.02 1.99994Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const HeartIcon = createIcon({
  displayName: 'HeartIcon',
  viewBox: '0 0 25.823 24.543',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25.823"
      height="24.543"
      viewBox="0 0 25.823 24.543"
    >
      <g id="Iconly_Light_Heart" data-name="Iconly/Light/Heart" transform="translate(0.774 0.795)">
        <g id="Heart">
          <path
            id="Path_33961"
            d="M11.832,22.811a44.512,44.512,0,0,1-7.694-5.99A15.319,15.319,0,0,1,.477,10.982C-.9,6.708.708,1.815,5.2.367a7.638,7.638,0,0,1,6.931,1.168A7.649,7.649,0,0,1,19.064.367c4.494,1.448,6.111,6.341,4.736,10.614a15.319,15.319,0,0,1-3.662,5.839,44.512,44.512,0,0,1-7.694,5.99l-.3.187Z"
            transform="translate(0 0)"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <path
            id="Path_33964"
            d="M0,0A3.554,3.554,0,0,1,2.449,3.094"
            transform="translate(16.915 5.178)"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
        </g>
      </g>
    </svg>
  ),
});

export const HeartFilledIcon = createIcon({
  displayName: 'HeartFilledIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg fill="#FF6040" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.761 20.8538C9.5904 19.5179 7.57111 17.9456 5.73929 16.1652C4.45144 14.8829 3.47101 13.3198 2.8731 11.5954C1.79714 8.25031 3.05393 4.42083 6.57112 3.28752C8.41961 2.69243 10.4384 3.03255 11.9961 4.20148C13.5543 3.03398 15.5725 2.69398 17.4211 3.28752C20.9383 4.42083 22.2041 8.25031 21.1281 11.5954C20.5302 13.3198 19.5498 14.8829 18.2619 16.1652C16.4301 17.9456 14.4108 19.5179 12.2402 20.8538L12.0051 21L11.761 20.8538Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7393 7.05298C16.8046 7.39328 17.5615 8.34968 17.6561 9.47496"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const OutpostLoveIcon = createIcon({
  displayName: 'OutpostLoveIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.53 15.98">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Icons_24px" data-name="Icons 24px">
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M7.5,1.33A4.5,4.5,0,0,0,1.55,2a4.13,4.13,0,0,0-1,3,8.13,8.13,0,0,0,2,4.16A46.9,46.9,0,0,0,5.85,13l1.21,1.32a2.75,2.75,0,0,0,1.55,1.11A1.86,1.86,0,0,0,9.7,15.3a2.9,2.9,0,0,0,.89-.82c1.18-1.31,2.33-2.65,3.43-4,1.6-2,3.91-4.63,2.65-7.37a4.51,4.51,0,0,0-6-2.13,4.23,4.23,0,0,0-.62.37L7.55,3.11a2.06,2.06,0,1,0,2.38,0Z"
          />
        </g>
      </g>
    </svg>
  ),
});

export const ClinicStaffIcon = createIcon({
  displayName: 'ClinicStaffIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.9 16">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Icons_24px" data-name="Icons 24px">
          <path
            fill="currentColor"
            d="M4.92,4.65a.18.18,0,0,0-.19-.19h-.2a2.81,2.81,0,0,1-.41,0,.51.51,0,0,1-.45-.52A.5.5,0,0,1,4,3.46a.79.79,0,0,1,.2,0h.56a.18.18,0,0,0,.19-.19V2.68a.51.51,0,0,1,.26-.46.48.48,0,0,1,.48,0,.51.51,0,0,1,.3.5v.49a.19.19,0,0,0,.2.19h.53A.52.52,0,0,1,7.23,4a.54.54,0,0,1-.51.45H6.15A.19.19,0,0,0,6,4.6v.57a.52.52,0,0,1-.85.4.49.49,0,0,1-.19-.42Z"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M2.26.5H8.64A1.76,1.76,0,0,1,10.4,2.26V15.5H.5V2.26A1.76,1.76,0,0,1,2.26.5Z"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4.81,11.11H6.09a1,1,0,0,1,1,1v3.35a0,0,0,0,1,0,0H3.83a0,0,0,0,1,0,0V12.09A1,1,0,0,1,4.81,11.11Z"
          />
        </g>
      </g>
    </svg>
  ),
});

export const Users3Icon = createIcon({
  displayName: 'Users3Icon',
  viewBox: '0 0 24 24',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.5949 10.9319C19.1972 10.9319 20.497 9.63298 20.497 8.03064C20.497 6.42831 19.1972 5.12939 17.5949 5.12939"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9291 14.0847C19.4076 14.1177 19.8834 14.1856 20.3518 14.291C21.0026 14.4184 21.7854 14.6851 22.0641 15.2691C22.2419 15.6431 22.2419 16.0785 22.0641 16.4534C21.7864 17.0373 21.0026 17.3031 20.3518 17.437"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.29001 10.9319C4.68768 10.9319 3.38785 9.63298 3.38785 8.03064C3.38785 6.42831 4.68768 5.12939 6.29001 5.12939"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.9558 14.0847C4.4773 14.1177 4.00155 14.1856 3.53313 14.291C2.8823 14.4184 2.09947 14.6851 1.82172 15.2691C1.64297 15.6431 1.64297 16.0785 1.82172 16.4534C2.09855 17.0373 2.8823 17.3031 3.53313 17.437"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9378 14.7095C15.1846 14.7095 17.9584 15.2008 17.9584 17.1671C17.9584 19.1324 15.2029 19.6421 11.9378 19.6421C8.69003 19.6421 5.91711 19.1507 5.91711 17.1845C5.91711 15.2182 8.67261 14.7095 11.9378 14.7095Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9378 11.9049C9.79645 11.9049 8.07953 10.188 8.07953 8.04575C8.07953 5.90442 9.79645 4.1875 11.9378 4.1875C14.0791 4.1875 15.796 5.90442 15.796 8.04575C15.796 10.188 14.0791 11.9049 11.9378 11.9049Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const CalendarIcon = createIcon({
  displayName: 'CalendarIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 17.67">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Icons_24px" data-name="Icons 24px">
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M.58,6.67H15.43"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M11.7,9.92h0"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8,9.92H8"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4.3,9.92h0"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M11.7,13.16h0"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8,13.16H8"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4.3,13.16h0"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M11.37.5V3.24"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4.64.5V3.24"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M11.53,1.82h-7C2,1.82.5,3.18.5,5.69v7.54a3.62,3.62,0,0,0,4,3.94h7c2.46,0,4-1.37,4-3.88V5.69C15.51,3.18,14,1.82,11.53,1.82Z"
          />
        </g>
      </g>
    </svg>
  ),
});

export const HealthConcernIcon = createIcon({
  displayName: 'HealthConcernIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-inside-1" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.04498 7.04522C4.65135 8.43885 4.65135 10.6984 6.04498 12.092L12.3541 18.4011L17.4008 13.3543L17.3993 13.3528L18.8248 11.9273C20.1784 10.5738 20.1784 8.37922 18.8248 7.02566C17.4713 5.6721 15.2767 5.6721 13.9232 7.02566L12.4977 8.45114L11.0917 7.04522C9.69812 5.65159 7.4386 5.65159 6.04498 7.04522Z"
        />
      </mask>
      <path
        d="M6.04498 12.092L5.33787 12.7991L5.33787 12.7991L6.04498 12.092ZM6.04498 7.04522L5.33787 6.33811V6.33811L6.04498 7.04522ZM12.3541 18.4011L11.647 19.1082L12.3541 19.8153L13.0612 19.1082L12.3541 18.4011ZM17.4008 13.3543L18.1079 14.0614L18.8152 13.3542L18.1078 12.6471L17.4008 13.3543ZM17.3993 13.3528L16.6922 12.6457L15.985 13.3529L16.6923 14.06L17.3993 13.3528ZM18.8248 11.9273L19.5319 12.6344V12.6344L18.8248 11.9273ZM18.8248 7.02566L19.5319 6.31855L18.8248 7.02566ZM13.9232 7.02566L13.216 6.31855V6.31855L13.9232 7.02566ZM12.4977 8.45114L11.7906 9.15825L12.4977 9.86536L13.2048 9.15825L12.4977 8.45114ZM11.0917 7.04522L11.7989 6.33811V6.33811L11.0917 7.04522ZM6.75208 11.3849C5.74898 10.3818 5.74898 8.75543 6.75208 7.75233L5.33787 6.33811C3.55372 8.12226 3.55372 11.0149 5.33787 12.7991L6.75208 11.3849ZM13.0612 17.694L6.75208 11.3849L5.33787 12.7991L11.647 19.1082L13.0612 17.694ZM16.6937 12.6472L11.647 17.694L13.0612 19.1082L18.1079 14.0614L16.6937 12.6472ZM16.6923 14.06L16.6938 14.0615L18.1078 12.6471L18.1063 12.6456L16.6923 14.06ZM18.1177 11.2202L16.6922 12.6457L18.1064 14.0599L19.5319 12.6344L18.1177 11.2202ZM18.1177 7.73276C19.0808 8.6958 19.0808 10.2572 18.1177 11.2202L19.5319 12.6344C21.276 10.8904 21.276 8.06263 19.5319 6.31855L18.1177 7.73276ZM14.6303 7.73277C15.5933 6.76973 17.1547 6.76973 18.1177 7.73276L19.5319 6.31855C17.7878 4.57447 14.9601 4.57447 13.216 6.31855L14.6303 7.73277ZM13.2048 9.15825L14.6303 7.73277L13.216 6.31855L11.7906 7.74404L13.2048 9.15825ZM10.3846 7.75233L11.7906 9.15825L13.2048 7.74404L11.7989 6.33811L10.3846 7.75233ZM6.75208 7.75233C7.75518 6.74922 9.38153 6.74922 10.3846 7.75233L11.7989 6.33811C10.0147 4.55396 7.12202 4.55396 5.33787 6.33811L6.75208 7.75233Z"
        fill="currentColor"
        mask="url(#path-1-inside-1)"
      />
      <circle cx="12.5" cy="12.5" r="0.5" fill="currentColor" />
    </svg>
  ),
});

export const ActivityIcon = createIcon({
  displayName: 'ActivityIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.24487 14.7815L10.238 10.8913L13.6522 13.5732L16.5813 9.7929"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="19.9954"
        cy="4.20023"
        r="1.9222"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9245 3.12014H7.65679C4.64535 3.12014 2.77808 5.25286 2.77808 8.2643V16.3467C2.77808 19.3581 4.60874 21.4817 7.65679 21.4817H16.2609C19.2724 21.4817 21.1396 19.3581 21.1396 16.3467V9.30778"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const AllergyIcon = createIcon({
  displayName: 'AllergyIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-inside-1" fill="currentColor">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.0488 6.23945C3.43735 7.8509 3.43735 10.4636 5.0488 12.075L12.344 19.3702L18.1796 13.5346L18.1779 13.533L19.8263 11.8846C21.3914 10.3195 21.3914 7.78196 19.8263 6.21684C18.2612 4.65172 15.7236 4.65172 14.1585 6.21684L12.5101 7.8652L10.8844 6.23945C9.27292 4.628 6.66025 4.628 5.0488 6.23945Z"
        />
      </mask>
      <path
        d="M5.0488 12.075L5.86642 11.2574H5.86642L5.0488 12.075ZM5.0488 6.23945L5.86642 7.05708H5.86642L5.0488 6.23945ZM12.344 19.3702L11.5264 20.1878L12.344 21.0055L13.1616 20.1878L12.344 19.3702ZM18.1796 13.5346L18.9972 14.3523L19.8148 13.5346L18.9972 12.717L18.1796 13.5346ZM18.1779 13.533L17.3603 12.7154L16.5427 13.533L17.3603 14.3506L18.1779 13.533ZM19.8263 11.8846L19.0087 11.067L19.8263 11.8846ZM19.8263 6.21684L20.6439 5.39921V5.39921L19.8263 6.21684ZM14.1585 6.21684L13.3409 5.39921V5.39921L14.1585 6.21684ZM12.5101 7.8652L11.6925 8.68283L12.5101 9.50046L13.3278 8.68283L12.5101 7.8652ZM10.8844 6.23945L10.0667 7.05707L10.8844 6.23945ZM5.86642 11.2574C4.70654 10.0975 4.70654 8.21696 5.86642 7.05708L4.23117 5.42182C2.16816 7.48483 2.16816 10.8296 4.23117 12.8927L5.86642 11.2574ZM13.1616 18.5526L5.86642 11.2574L4.23117 12.8927L11.5264 20.1878L13.1616 18.5526ZM17.3619 12.717L11.5264 18.5526L13.1616 20.1878L18.9972 14.3523L17.3619 12.717ZM17.3603 14.3506L17.3619 14.3523L18.9972 12.717L18.9956 12.7154L17.3603 14.3506ZM19.0087 11.067L17.3603 12.7154L18.9956 14.3506L20.6439 12.7023L19.0087 11.067ZM19.0087 7.03447C20.1222 8.14802 20.1222 9.95345 19.0087 11.067L20.6439 12.7023C22.6606 10.6856 22.6606 7.41589 20.6439 5.39921L19.0087 7.03447ZM14.9761 7.03447C16.0897 5.92091 17.8951 5.92091 19.0087 7.03447L20.6439 5.39921C18.6272 3.38253 15.3575 3.38253 13.3409 5.39921L14.9761 7.03447ZM13.3278 8.68283L14.9761 7.03447L13.3409 5.39921L11.6925 7.04758L13.3278 8.68283ZM10.0667 7.05707L11.6925 8.68283L13.3278 7.04758L11.702 5.42182L10.0667 7.05707ZM5.86642 7.05708C7.02631 5.89719 8.90686 5.89719 10.0667 7.05707L11.702 5.42182C9.63899 3.35881 6.29418 3.35881 4.23117 5.42182L5.86642 7.05708Z"
        fill="currentColor"
        mask="url(#path-1-inside-1)"
      />
      <path
        d="M8.46582 10.8123L10.7784 13.1249V10.8123L13.6692 13.1249"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  ),
});

export const StarIcon = createIcon({
  displayName: 'StarIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7141 3.44083L15.0301 8.09983C15.1461 8.33483 15.3701 8.49883 15.6301 8.53683L20.8151 9.28583C21.0251 9.31383 21.2141 9.42383 21.3431 9.59183C21.5851 9.90683 21.5481 10.3528 21.2581 10.6238L17.5001 14.2578C17.3091 14.4378 17.2241 14.7018 17.2741 14.9588L18.1741 20.0868C18.2371 20.5118 17.9471 20.9098 17.5221 20.9788C17.3461 21.0058 17.1661 20.9778 17.0061 20.8988L12.3881 18.4778C12.1561 18.3518 11.8781 18.3518 11.6461 18.4778L6.99413 20.9118C6.60513 21.1098 6.12913 20.9628 5.91713 20.5818C5.83613 20.4278 5.80813 20.2528 5.83613 20.0818L6.73613 14.9538C6.78113 14.6978 6.69613 14.4348 6.51013 14.2538L2.73213 10.6208C2.42413 10.3148 2.42213 9.81683 2.72913 9.50883C2.73013 9.50783 2.73113 9.50583 2.73213 9.50483C2.85913 9.38983 3.01513 9.31283 3.18413 9.28283L8.37013 8.53383C8.62913 8.49283 8.85213 8.33083 8.97013 8.09583L11.2841 3.44083C11.3771 3.25183 11.5421 3.10683 11.7421 3.04083C11.9431 2.97383 12.1631 2.98983 12.3521 3.08483C12.5071 3.16183 12.6341 3.28683 12.7141 3.44083Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const ChatAltIcon = createIcon({
  displayName: 'ChatAltIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" fill="transparent">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 5.5C2.5 4.39543 3.39543 3.5 4.5 3.5L14.5 3.5C15.6046 3.5 16.5 4.39543 16.5 5.5V11.5C16.5 12.6046 15.6046 13.5 14.5 13.5H5.5L2.5 16.5V5.5Z"
        stroke="currentColor"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 16.5C7.5 17.6046 8.39543 18.5 9.5 18.5H18.5L21.5 21.5V10.5C21.5 9.39543 20.6046 8.5 19.5 8.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const ClinicIcon = createIcon({
  displayName: 'ClinicIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" fill="transparent">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2685 2.2934C12.9338 1.23545 11.0378 1.23545 9.70308 2.2934L9.70307 2.29339L9.70073 2.29527L3.15451 7.54838C2.43581 8.09576 2.00917 8.94116 2.00027 9.84236H2.00024V9.8473V18.5618C2.00024 20.7415 3.78373 22.4999 5.97316 22.4999H7.89721C8.79958 22.4999 9.54846 21.8158 9.63072 20.9331C9.64806 20.8824 9.65746 20.8279 9.65746 20.7713V17.7046C9.65745 17.2046 10.066 16.7898 10.583 16.7855H13.4673C13.9876 16.7855 14.4008 17.2017 14.4008 17.7046V20.7807V20.7809C14.4006 21.7193 15.1559 22.4781 16.0917 22.4998L16.0917 22.4999H16.1033H18.0273C20.2168 22.4999 22.0002 20.7415 22.0002 18.5618V9.83778H22.0003L22.0002 9.83092C21.9896 9.05625 21.6724 8.32336 21.1275 7.78427C20.9588 8.07919 20.7497 8.34796 20.5076 8.58301C20.8162 8.92861 20.993 9.37416 21.0002 9.84136V18.5618C21.0002 20.1798 19.674 21.4999 18.0273 21.4999H16.1098C15.7105 21.488 15.4006 21.1654 15.4008 20.781V20.7809V17.7046C15.4008 16.64 14.5304 15.7855 13.4673 15.7855L10.5813 15.7855L10.5779 15.7855C9.5199 15.7926 8.65743 16.6451 8.65746 17.7046V20.7713H8.63822C8.63822 21.169 8.31121 21.4999 7.89721 21.4999H5.97316C4.32651 21.4999 3.00024 20.1798 3.00024 18.5618V9.84991C3.0068 9.25901 3.28753 8.70223 3.76424 8.34101L3.76436 8.34117L3.7752 8.33246L10.3254 3.07619C11.296 2.30769 12.6765 2.30786 13.6469 3.07669L13.6474 3.07708L14.9378 4.10621C15.1147 3.82085 15.3303 3.56205 15.5773 3.33716L14.2697 2.29433L14.2685 2.2934Z"
        fill="currentColor"
      />
      <path
        d="M18.0001 3.59998V8.39997"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4001 6H15.6001"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const ProfileIcon = createIcon({
  displayName: 'ProfileIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" fill="transparent">
      <circle
        cx="11.5789"
        cy="7.27803"
        r="4.77803"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.00002 18.7014C3.99873 18.3655 4.07385 18.0337 4.2197 17.7311C4.67736 16.8158 5.96798 16.3307 7.03892 16.111C7.81128 15.9462 8.59431 15.836 9.38217 15.7815C10.8408 15.6533 12.3079 15.6533 13.7666 15.7815C14.5544 15.8367 15.3374 15.9468 16.1099 16.111C17.1808 16.3307 18.4714 16.77 18.9291 17.7311C19.2224 18.3479 19.2224 19.064 18.9291 19.6808C18.4714 20.6419 17.1808 21.0812 16.1099 21.2918C15.3384 21.4634 14.5551 21.5766 13.7666 21.6304C12.5794 21.7311 11.3866 21.7494 10.1968 21.6854C9.92221 21.6854 9.65677 21.6854 9.38217 21.6304C8.59663 21.5773 7.81632 21.4641 7.04807 21.2918C5.96798 21.0812 4.68652 20.6419 4.2197 19.6808C4.0746 19.3747 3.99955 19.0401 4.00002 18.7014Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const VerifiedShieldIcon = createIcon({
  displayName: 'VerifiedShieldIcon',
  viewBox: '0 0 34.061 42.46',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34.061"
      height="42.46"
      viewBox="0 0 34.061 42.46"
    >
      <g id="noun_verified_1749820" transform="translate(-13.515 -4.393)">
        <g id="Group_13898" data-name="Group 13898" transform="translate(14.016 5.002)">
          <path
            id="Path_20745"
            data-name="Path 20745"
            d="M14.041,9.828A27.361,27.361,0,0,0,30.546,5a27.363,27.363,0,0,0,16.5,4.826c.443,21.771-4.812,34.48-16.5,36.518C18.853,44.309,13.6,31.6,14.041,9.828Z"
            transform="translate(-14.016 -5.002)"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            fillRule="evenodd"
          />
        </g>
      </g>
      <path
        id="path"
        d="M266.131,882.23l7.63-7.63,1.008,1.008-8.638,8.638-4.031-4.031,1.008-1.008Z"
        transform="translate(-251.404 -859.187)"
        fill="currentColor"
      />
    </svg>
  ),
});

export const CheckMarkIcon = createIcon({
  displayName: 'CheckMarkIcon',
  viewBox: '0 0 8 6',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.72797 0.339137C7.67632 0.287066 7.61488 0.245735 7.54718 0.217531C7.47948 0.189326 7.40686 0.174805 7.33352 0.174805C7.26018 0.174805 7.18757 0.189326 7.11987 0.217531C7.05217 0.245735 6.99073 0.287066 6.93908 0.339137L2.80019 4.48358L1.0613 2.73914C1.00768 2.68734 0.944377 2.64661 0.875013 2.61927C0.805649 2.59194 0.73158 2.57853 0.657035 2.57982C0.58249 2.58111 0.508929 2.59707 0.440552 2.62679C0.372175 2.65651 0.310322 2.6994 0.258522 2.75303C0.206723 2.80665 0.165993 2.86995 0.138658 2.93931C0.111322 3.00868 0.0979163 3.08275 0.099206 3.15729C0.100496 3.23184 0.116456 3.3054 0.146174 3.37377C0.175893 3.44215 0.218788 3.504 0.272411 3.5558L2.40575 5.68914C2.45739 5.74121 2.51884 5.78254 2.58654 5.81074C2.65424 5.83895 2.72685 5.85347 2.80019 5.85347C2.87353 5.85347 2.94614 5.83895 3.01384 5.81074C3.08154 5.78254 3.14299 5.74121 3.19463 5.68914L7.72797 1.1558C7.78436 1.10378 7.82936 1.04064 7.86015 0.970363C7.89093 0.900086 7.90682 0.824194 7.90682 0.74747C7.90682 0.670747 7.89093 0.594856 7.86015 0.524578C7.82936 0.4543 7.78436 0.391161 7.72797 0.339137Z"
        fill="currentColor"
      />
    </svg>
  ),
});

export const VideoIcon = createIcon({
  displayName: 'VideoIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.816 15.6205C15.816 17.6135 14.458 19.0215 12.286 19.0215H6.06905C3.89905 19.0215 2.55005 17.6135 2.55005 15.6205V8.66049C2.55005 6.66849 3.89905 5.25049 6.08005 5.25049H12.286C14.458 5.25049 15.816 6.66849 15.816 8.66049V15.6205Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8162 11.2766L19.9132 7.9226C20.5632 7.3876 21.5502 7.8526 21.5502 8.6996V15.5716C21.5502 16.4196 20.5632 16.8826 19.9132 16.3486L15.8162 12.9946"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const SendIcon = createIcon({
  displayName: 'SendIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.3635 2.45312L11.3635 13.4531"
        stroke="#3E1191"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.3635 2.45312L15.3635 22.4531L11.3635 13.4531L2.36353 9.45312L22.3635 2.45312Z"
        stroke="#3E1191"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const CopyIcon = createIcon({
  displayName: 'CopyIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 9H11C9.89543 9 9 9.89543 9 11V20C9 21.1046 9.89543 22 11 22H20C21.1046 22 22 21.1046 22 20V11C22 9.89543 21.1046 9 20 9Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 15H4C3.46957 15 2.96086 14.7893 2.58579 14.4142C2.21071 14.0391 2 13.5304 2 13V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H13C13.5304 2 14.0391 2.21071 14.4142 2.58579C14.7893 2.96086 15 3.46957 15 4V5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const PhoneNumberIcon = createIcon({
  displayName: 'PhoenNumberIcon',
  viewBox: '0 0 14 10',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.26491 5.9018H3.334L3.23721 4.11997L4.73306 5.10108L5.26981 4.16837L3.66837 3.36765L5.26981 2.56693L4.73306 1.63422L3.23721 2.61532L3.334 0.833496H2.26491L2.3661 2.61532L0.870243 1.63422L0.333496 2.56693L1.93054 3.36765L0.333496 4.16837L0.870243 5.10108L2.3661 4.11997L2.26491 5.9018Z"
        fill="currentColor"
      />
      <path
        d="M10.068 9.84381H11.2999L11.6826 7.52084H12.9409L13.1477 6.28896H11.885L12.193 4.38835H13.4644L13.6668 3.15647H12.3954L12.7781 0.833496H11.5462L11.1635 3.15647H9.22766L9.61043 0.833496H8.37855L7.99578 3.15647H6.73311L6.53073 4.38835H7.7934L7.48544 6.28896H6.21396L6.00718 7.52084H7.28305L6.90029 9.84381H8.13217L8.51493 7.52084H10.4507L10.068 9.84381ZM8.71731 6.28896L9.02528 4.38835H10.9611L10.6531 6.28896H8.71731Z"
        fill="currentColor"
      />
    </svg>
  ),
});

export const ChevronRightIcon = createIcon({
  displayName: 'ChevronRightIcon',
  viewBox: '0 0 8 14',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.0835 1.16683L6.91683 7.00016L1.0835 12.8335"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const ChevronRightIcon2 = createIcon({
  displayName: 'ChevronRightIcon2',
  viewBox: '0 0 6 9.999',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="9.999" viewBox="0 0 6 9.999">
      <defs>
        <clipPath id="clip-path">
          <path
            id="Color"
            d="M1,10A1,1,0,0,1,.293,8.292L3.6,4.987.418,1.694A1,1,0,0,1,1.857.3l3.862,4a1,1,0,0,1-.012,1.4l-4,4A1,1,0,0,1,1,10"
            transform="translate(9.5 7.001)"
            fill="currentColor"
          />
        </clipPath>
      </defs>
      <g id="Group_14075" data-name="Group 14075" transform="translate(-9.5 -7.001)">
        <path
          id="Color-2"
          data-name="Color"
          d="M1,10A1,1,0,0,1,.293,8.292L3.6,4.987.418,1.694A1,1,0,0,1,1.857.3l3.862,4a1,1,0,0,1-.012,1.4l-4,4A1,1,0,0,1,1,10"
          transform="translate(9.5 7.001)"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
});

export const CreditCardIcon = createIcon({
  displayName: 'CreditCardIcon',
  viewBox: '0 0 20 20',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4165 4.5835C17.2449 4.5835 17.9165 5.25507 17.9165 6.0835V13.9168C17.9165 14.7453 17.2449 15.4168 16.4165 15.4168L3.58317 15.4168C2.75474 15.4168 2.08317 14.7453 2.08317 13.9168L2.08317 6.08349C2.08317 5.25507 2.75474 4.5835 3.58317 4.5835L16.4165 4.5835Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 12.0835H17.5V12.9168H2.5V12.0835Z"
        stroke="currentColor"
      />
    </svg>
  ),
});

export const TimeIcon = createIcon({
  displayName: 'TimeIcon',
  viewBox: '0 0 18 18',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.612 1.29199H5.38783C2.87033 1.29199 1.29199 3.07449 1.29199 5.59699V12.4037C1.29199 14.9262 2.86199 16.7087 5.38783 16.7087H12.6112C15.137 16.7087 16.7087 14.9262 16.7087 12.4037V5.59699C16.7087 3.07449 15.137 1.29199 12.612 1.29199Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8258 10.6813L9 8.99549V5.36133"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const PhoneIcon = createIcon({
  displayName: 'PhoneIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.93915 12.275L9.42565 8.69873C9.82151 8.31597 9.90607 7.71292 9.63075 7.23605L7.09921 2.85131C6.76784 2.27736 6.03393 2.08071 5.45998 2.41208L2.41673 4.49977C3.06247 8.35591 5.88167 12.7985 8.64207 15.5589C11.4032 18.32 16.0556 21.3538 19.9167 21.9998L21.7103 18.9647C22.0417 18.3908 21.8451 17.6569 21.2711 17.3255L16.8864 14.794C16.4095 14.5187 15.8064 14.6032 15.4237 14.9991L12.0207 18.3646"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const CategoryIcon = createIcon({
  displayName: 'CatgoryIcon',
  viewBox: '0 0 20 20',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.571 1.66675H16.2932C17.4195 1.66675 18.3331 2.58833 18.3331 3.72523V6.47017C18.3331 7.60621 17.4195 8.52865 16.2932 8.52865H13.571C12.4439 8.52865 11.5303 7.60621 11.5303 6.47017V3.72523C11.5303 2.58833 12.4439 1.66675 13.571 1.66675Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.70727 1.66675H6.42858C7.5557 1.66675 8.46935 2.58833 8.46935 3.72523V6.47017C8.46935 7.60621 7.5557 8.52865 6.42858 8.52865H3.70727C2.58015 8.52865 1.6665 7.60621 1.6665 6.47017V3.72523C1.6665 2.58833 2.58015 1.66675 3.70727 1.66675Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.70727 11.4714H6.42858C7.5557 11.4714 8.46935 12.393 8.46935 13.5308V16.2749C8.46935 17.4118 7.5557 18.3333 6.42858 18.3333H3.70727C2.58015 18.3333 1.6665 17.4118 1.6665 16.2749V13.5308C1.6665 12.393 2.58015 11.4714 3.70727 11.4714Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.571 11.4714H16.2932C17.4195 11.4714 18.3331 12.393 18.3331 13.5308V16.2749C18.3331 17.4118 17.4195 18.3333 16.2932 18.3333H13.571C12.4439 18.3333 11.5303 17.4118 11.5303 16.2749V13.5308C11.5303 12.393 12.4439 11.4714 13.571 11.4714Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const ArrowDown = createIcon({
  displayName: 'ArrowDown',
  viewBox: '0 0 20 21',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.2282 16.729V4.229"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2488 11.6875L10.2288 16.7292L5.20801 11.6875"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const TimesIcon = createIcon({
  displayName: 'TimesIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 6L6 18" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 6L18 18" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
});

export const SupportIcon = createIcon({
  displayName: 'SupportIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Size=24, Weight=01 Thin, State=Active">
        <circle id="Oval" cx="12" cy="12" r="9.5" stroke="currentColor" />
        <circle id="Oval Copy 2" cx="12" cy="12" r="4.5" stroke="currentColor" />
        <path
          id="Path"
          d="M5.29688 5.29639L8.50039 8.4999"
          stroke="currentColor"
          strokeLinecap="round"
        />
        <path
          id="Path_2"
          d="M15.5 15.5L18.6736 18.6736"
          stroke="currentColor"
          strokeLinecap="round"
        />
        <path
          id="Path_3"
          d="M5.26953 18.7251L8.49967 15.5"
          stroke="currentColor"
          strokeLinecap="round"
        />
        <path
          id="Path_4"
          d="M15.5 8.5L18.6826 5.3124"
          stroke="currentColor"
          strokeLinecap="round"
        />
      </g>
    </svg>
  ),
});

export const HeadsetIcon = createIcon({
  displayName: 'HeadsetIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9627 4C7.81458 4 6.67878 7.55556 6.62939 9.33333V10.6667C7.1726 10.5679 8.25902 10.9926 8.25902 13.4815C8.25902 15.3561 7.64271 16.1717 7.10638 16.4602C6.86318 16.591 6.62939 16.3687 6.62939 16.0926V10.6667V9.33333C6.67878 7.55556 7.81458 4 11.9627 4C16.1109 4 17.4442 7.55556 17.5924 9.33333V10.6667V16.5926C17.5924 17.7284 16.9109 20 14.185 20H11.4375C11.0658 20 10.9367 19.6782 11.2897 19.5618C11.5623 19.4719 11.9283 19.4074 12.4072 19.4074C13.5924 19.4074 14.0862 19.8025 14.185 20C16.9109 20 17.5924 17.7284 17.5924 16.5926C17.1479 16.5432 16.259 15.8519 16.259 13.4815C16.259 11.1111 17.1479 10.6173 17.5924 10.6667V9.33333C17.4442 7.55556 16.1109 4 11.9627 4Z"
        fill="currentColor"
      />
      <path
        d="M17.5924 16.5926C17.1479 16.5432 16.259 15.8519 16.259 13.4815C16.259 11.1111 17.1479 10.6173 17.5924 10.6667M17.5924 16.5926V10.6667M17.5924 16.5926C17.5924 17.7284 16.9109 20 14.185 20M17.5924 10.6667V9.33333C17.4442 7.55556 16.1109 4 11.9627 4C7.81458 4 6.67878 7.55556 6.62939 9.33333V10.6667M6.62939 10.6667V16.0926C6.62939 16.3687 6.86318 16.591 7.10638 16.4602C7.64271 16.1717 8.25902 15.3561 8.25902 13.4815C8.25902 10.9926 7.1726 10.5679 6.62939 10.6667ZM14.185 20C12.8502 20 11.9819 20 11.4375 20C11.0658 20 10.9367 19.6782 11.2897 19.5618C11.5623 19.4719 11.9283 19.4074 12.4072 19.4074C13.5924 19.4074 14.0862 19.8025 14.185 20Z"
        stroke="currentColor"
      />
      <path
        d="M6.03704 15.5556V12.1482C5.69136 12.3457 5 12.9778 5 13.926C5 14.8741 5.69136 15.4075 6.03704 15.5556Z"
        fill="currentColor"
        stroke="currentColor"
      />
      <path
        d="M18.1851 15.5556V12.1482C18.5308 12.3457 19.2222 12.9778 19.2222 13.926C19.2222 14.8741 18.5308 15.4075 18.1851 15.5556Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  ),
});

export const WaitingRoomIcon = createIcon({
  displayName: 'WaitingRoomIcon',
  viewBox: '0 0 32.828 32.828',
  path: (
    <svg id="noun_Wait_3377374" xmlns="http://www.w3.org/2000/svg">
      <path
        id="Path_20197"
        d="M19.492,45.563H8.62L7.114,42.647a1.567,1.567,0,1,1,2.834-1.334L10.808,43h-.549a.513.513,0,0,0,0,1.026h6.412a.513.513,0,0,0,0-1.026H11.959l-1.09-2.136a2.585,2.585,0,0,0-1.752-1.411,3.7,3.7,0,1,0-2.631.931,2.593,2.593,0,0,0-.3,2.708l1.249,2.472H3.432c-.508-1.367-2.406-6.584-2.406-8.481a2.539,2.539,0,0,1,1.211-2.129.513.513,0,1,0-.541-.872,3.57,3.57,0,0,0-1.7,3c0,1.941,1.677,6.686,2.339,8.481h-.8a.513.513,0,0,0-.513.513V56.847a.513.513,0,0,0,1.026,0V46.589h17.44a3.074,3.074,0,0,1,3.078,3.334v6.925a.513.513,0,0,0,1.026,0V49.923A4.1,4.1,0,0,0,19.492,45.563Zm-15.5-8.869a2.672,2.672,0,1,1,2.678,2.672A2.672,2.672,0,0,1,3.991,36.694Z"
        transform="translate(0 -24.532)"
        fill="currentColor"
      />
      <path
        id="Path_20198"
        d="M73.951,0A7.951,7.951,0,1,0,81.9,7.951,7.951,7.951,0,0,0,73.951,0Zm.513,14.855v-.849a.513.513,0,0,0-1.026,0v.849a6.925,6.925,0,0,1-6.391-6.391h.816a.513.513,0,0,0,0-1.026h-.816a6.925,6.925,0,0,1,6.391-6.391v.816a.513.513,0,0,0,1.026,0V1.046a6.925,6.925,0,0,1,6.391,6.391h-.749a.513.513,0,0,0,0,1.026h.749A6.925,6.925,0,0,1,74.464,14.855Z"
        transform="translate(-49.073)"
        fill="currentColor"
      />
      <path
        id="Path_20199"
        d="M95.352,17.1H93.98a1.539,1.539,0,0,0-.936-.936V13.513a.513.513,0,0,0-1.026,0v2.654a1.539,1.539,0,1,0,1.962,1.962h1.372a.513.513,0,0,0,0-1.026Zm-2.821,1.026a.513.513,0,1,1,.513-.513A.513.513,0,0,1,92.531,18.129Z"
        transform="translate(-67.653 -9.666)"
        fill="currentColor"
      />
    </svg>
  ),
});

export const IncompleteConsultsIcon = createIcon({
  displayName: 'IncompleteConsultsIcon',
  viewBox: '0 0 29.591 28.695',
  path: (
    <svg id="noun_Error_2915515" xmlns="http://www.w3.org/2000/svg">
      <path
        id="Path_20194"
        d="M203.9,310.451a.448.448,0,1,1-.9,0A12.554,12.554,0,1,0,190.451,323a.448.448,0,1,1,0,.9A13.451,13.451,0,1,1,203.9,310.451Zm-2.69,15.244a5.38,5.38,0,1,1,5.38-5.38A5.38,5.38,0,0,1,201.211,325.695Zm0-.9a4.484,4.484,0,1,0-4.484-4.484A4.484,4.484,0,0,0,201.211,324.8Zm-.634-4.484-1.028-1.028a.448.448,0,1,1,.634-.634l1.028,1.028,1.028-1.028a.448.448,0,0,1,.634.634l-1.028,1.028,1.028,1.028a.448.448,0,0,1-.634.634l-1.028-1.028-1.028,1.028a.448.448,0,1,1-.634-.634Zm-5.195-9.864a.448.448,0,1,1,0,.9H190a.448.448,0,0,1-.448-.448v-8.07a.448.448,0,1,1,.9,0v7.622Z"
        transform="translate(-177 -297)"
        fill="currentColor"
      />
    </svg>
  ),
});

export const EyeIcon = createIcon({
  displayName: 'IncompleteConsultsIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg id="Iconly_Bold_Show" xmlns="http://www.w3.org/2000/svg">
      <g id="Show" transform="translate(2 4)">
        <path
          id="Show-2"
          d="M9.99,16C5.861,16,2.148,13.115.059,8.281a.724.724,0,0,1,0-.571C2.146,2.882,5.858,0,9.99,0H10a9.306,9.306,0,0,1,5.737,2.046,14.235,14.235,0,0,1,4.2,5.664.725.725,0,0,1,0,.571C17.851,13.115,14.135,16,10,16ZM6.1,8A3.9,3.9,0,1,0,10,4.121,3.89,3.89,0,0,0,6.1,8ZM7.562,8a2.487,2.487,0,0,1,.049-.475H7.66a2,2,0,0,0,2-1.921A1.989,1.989,0,0,1,10,5.574,2.419,2.419,0,1,1,7.562,8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
});

export const HealthRecordsIcon = createIcon({
  displayName: 'HealthRecordsIcon',
  viewBox: '0 0 26.779 24',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg">
      <g id="Group_13129" transform="translate(-272.5 -789.5)">
        <g id="Iconly_Light_Document" transform="translate(272.5 789.5)">
          <g id="Document" transform="translate(3 2)">
            <path
              id="Stroke_1"
              d="M7.22.5H0"
              transform="translate(5.496 13.723)"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="1.5"
            />
            <path
              id="Stroke_2"
              d="M7.22.5H0"
              transform="translate(5.496 9.537)"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="1.5"
            />
            <path
              id="Stroke_3"
              d="M2.755.5H0"
              transform="translate(5.496 5.36)"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="1.5"
            />
            <path
              id="Stroke_4"
              d="M12.158,0,4.469,0A4.251,4.251,0,0,0,0,4.607v9.2A4.254,4.254,0,0,0,4.506,18.41l7.689,0a4.252,4.252,0,0,0,4.47-4.6v-9.2A4.255,4.255,0,0,0,12.158,0Z"
              transform="translate(0.751 0.75)"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="1.5"
            />
          </g>
        </g>
        <g id="Iconly_Light_Heart" transform="translate(290.37 801.5)">
          <g id="Heart" transform="translate(-2 0)">
            <path
              id="Path_33961"
              d="M4.143,7.935A15.573,15.573,0,0,1,1.449,5.851,5.324,5.324,0,0,1,.167,3.82,2.823,2.823,0,0,1,1.821.128,2.689,2.689,0,0,1,4.248.534h0A2.693,2.693,0,0,1,6.675.128,2.825,2.825,0,0,1,8.334,3.82,5.324,5.324,0,0,1,7.051,5.851,15.573,15.573,0,0,1,4.357,7.935L4.252,8Z"
              transform="translate(2 0)"
              fill="currentColor"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="0.8"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
});

export const ConsultNotesIcon = createIcon({
  displayName: 'ConsultNotesIcon',
  viewBox: '0 0 20.547 20.403',
  path: (
    <svg id="Group_13128" xmlns="http://www.w3.org/2000/svg">
      <path
        id="Path_20236"
        d="M25.438,15.848l1.624,1.394a.37.37,0,0,0,.521-.023l.639-.744a1.456,1.456,0,0,0-2.2-1.89l-.639.744a.37.37,0,0,0,.057.518ZM9.538,8.224h9.24a.931.931,0,0,1,.681.282l4.05,4.05a.93.93,0,0,1,.282.681v2.411a.309.309,0,0,1-.077.209l-.642.748a.321.321,0,0,1-.565-.209V13.435H19.934a1.356,1.356,0,0,1-1.354-1.354V9.508H9.538a.256.256,0,0,0-.254.254V27.089a.251.251,0,0,0,.254.254H22.253a.255.255,0,0,0,.254-.254V24.667a.31.31,0,0,1,.077-.209l.642-.749a.321.321,0,0,1,.565.209v3.171a1.541,1.541,0,0,1-1.538,1.538H9.538A1.545,1.545,0,0,1,8,27.089V9.762A1.541,1.541,0,0,1,9.538,8.224Zm2.306,6.135h-.722a.268.268,0,0,0-.268.268v.568a.268.268,0,0,0,.268.268h.722a.269.269,0,0,0,.268-.268v-.568A.269.269,0,0,0,11.844,14.359Zm0,3.515h-.722a.268.268,0,0,0-.268.268v.568a.268.268,0,0,0,.268.268h.722a.269.269,0,0,0,.268-.268v-.568A.269.269,0,0,0,11.844,17.874Zm0,3.515h-.722a.268.268,0,0,0-.268.268v.568a.268.268,0,0,0,.268.268h.722a.269.269,0,0,0,.268-.268v-.568A.269.269,0,0,0,11.844,21.389Zm1.551-7.03h5a.268.268,0,0,1,.268.268v.568a.268.268,0,0,1-.268.268h-5a.268.268,0,0,1-.268-.268v-.568A.268.268,0,0,1,13.395,14.359Zm0,3.515h5a.268.268,0,0,1,.268.268v.568a.268.268,0,0,1-.268.268h-5a.268.268,0,0,1-.268-.268v-.568A.268.268,0,0,1,13.395,17.874Zm0,3.515h2.992a.268.268,0,0,1,.268.268v.568a.268.268,0,0,1-.268.268H13.395a.268.268,0,0,1-.268-.268v-.568a.268.268,0,0,1,.268-.268Zm11.617-5.082.83.713.831.712a.348.348,0,0,1,.051.488l-5.43,6.328c.3-.74-.2-.891-.816-.949a.37.37,0,0,1-.324-.278c-.15-.6-.376-1.076-1.061-.663l5.43-6.328a.348.348,0,0,1,.49-.023Zm-6.388,6.9.636-.159a.352.352,0,0,1,.308.068.424.424,0,0,1,.144.282l.051.288a.372.372,0,0,0,.416.357l.292.007a.422.422,0,0,1,.3.1.352.352,0,0,1,.114.294l-.061.653L18.31,26.3a.366.366,0,0,1-.5-.429l.814-2.67Z"
        transform="translate(-8 -8.224)"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  ),
});

export const ConsultToolsIcon = createIcon({
  displayName: 'ConsultToolsIcon',
  viewBox: '0 0 21.027 21.027',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg">
      <g id="noun_tools_2524956" transform="translate(-5 -5)">
        <path
          id="Path_20225"
          d="M5.821,21.24l4.435-4.435a.321.321,0,0,1,.391-.04.933.933,0,0,0,1.367-1.034L15.3,19.013a.933.933,0,0,0-1.034,1.367.321.321,0,0,1-.04.391L9.787,25.206A2.8,2.8,0,1,1,5.821,21.24ZM23.79,9.354a.249.249,0,0,0,.165-.113l2.037-3.265a.234.234,0,0,0-.033-.289l-.309-.309-.309-.309a.234.234,0,0,0-.289-.033L21.787,7.072a.249.249,0,0,0-.113.165l-.184.978-4.778,4.778,1.322,1.322,4.778-4.778ZM23.814,21.4l1.194,1.194a.6.6,0,0,0,1.019-.422,3.923,3.923,0,0,0-5.138-3.809l-8.221-8.221A3.923,3.923,0,0,0,8.857,5a.6.6,0,0,0-.422,1.019L9.63,7.214a1.756,1.756,0,0,1,.087,2.429,1.708,1.708,0,0,1-2.452.038L6.019,8.435A.6.6,0,0,0,5,8.824a3.925,3.925,0,0,0,5.14,3.845l8.217,8.217a3.925,3.925,0,0,0,3.845,5.14.6.6,0,0,0,.389-1.017l-1.245-1.245a1.708,1.708,0,0,1,.038-2.452,1.756,1.756,0,0,1,2.429.087Z"
          transform="translate(0 0)"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
});

export const MedicationIcon = createIcon({
  displayName: 'MedicationIcon',
  viewBox: '0 0 32.599 30.509',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg">
      <g id="noun_Medicine_3961804" transform="translate(0)">
        <path
          id="Path_19759"
          d="M28.108,15.927a8.677,8.677,0,0,1-8.567,14.839ZM12.22,27.151,10.637,29.9a6.677,6.677,0,0,1-9.119,2.444C-1.674,30.5-2.007,26.858-.164,23.668L10.109,5.748c1.243-2.151,2.3-3.031,4.625-3.016a6.646,6.646,0,0,1,3.292.895c2.459,1.419,3.352,2.97,2.936,5.616a6.649,6.649,0,0,1-.515,1.718c-1.308.166-1.786.993-2.917,1.564L18.6,10.647a4.005,4.005,0,1,0-6.937-4L8.478,12.28l5.31,3.064c-.752,1.516-2.493,7.313-2.493,7.313a21.067,21.067,0,0,0,.924,4.493Zm5.006,2.287A8.677,8.677,0,0,1,25.8,14.58Z"
          transform="translate(1.287 -2.732)"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
    </svg>
  ),
});

export const MagnifyIcon = createIcon({
  displayName: 'MagnifyIcon',
  viewBox: '0 0 19 19',
  path: (
    <svg id="Iconly_Light_Search" xmlns="http://www.w3.org/2000/svg">
      <g id="Search" transform="translate(2.199 2.199)">
        <circle
          id="Ellipse_739"
          cx="7.116"
          cy="7.116"
          r="7.116"
          transform="translate(0 0)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Line_181"
          d="M0,0,2.79,2.783"
          transform="translate(12.065 12.435)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  ),
});

export const BinIcon = createIcon({
  displayName: 'BinIcon',
  viewBox: '0 0 27.79 33.86',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.79 33.86">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Icons">
          <path
            className="cls-1"
            fill="none"
            stroke="inherit"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2px"
            d="M24.68,14.94s-.82,10.24-1.3,14.56a3.4,3.4,0,0,1-3.59,3.3c-4,.07-7.94.08-11.9,0a3.36,3.36,0,0,1-3.48-3.28C3.92,25.15,3.1,14.94,3.1,14.94"
          />
          <path
            className="cls-1"
            fill="none"
            stroke="inherit"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2px"
            d="M26.79,10H1"
          />
          <path
            className="cls-1"
            fill="none"
            stroke="inherit"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2px"
            d="M6.59,10l8.27-5.28A2,2,0,0,0,13.76,1h0a2,2,0,0,0-1.07,3.77L21.19,10"
          />
        </g>
      </g>
    </svg>
  ),
});

export const CalendarIcon2 = createIcon({
  displayName: 'CalendarIcon2',
  viewBox: '0 0 16 17.67',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 17.67">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Icons_24px" data-name="Icons 24px">
          <path
            className="cls-1"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M.58,6.67H15.43"
          />
          <path
            className="cls-1"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M11.7,9.92h0"
          />
          <path
            className="cls-1"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8,9.92H8"
          />
          <path
            className="cls-1"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4.3,9.92h0"
          />
          <path
            className="cls-1"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M11.7,13.16h0"
          />
          <path
            className="cls-1"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8,13.16H8"
          />
          <path
            className="cls-1"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4.3,13.16h0"
          />
          <path
            className="cls-1"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M11.37.5V3.24"
          />
          <path
            className="cls-1"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4.64.5V3.24"
          />
          <path
            className="cls-1"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M11.53,1.82h-7C2,1.82.5,3.18.5,5.69v7.54a3.62,3.62,0,0,0,4,3.94h7c2.46,0,4-1.37,4-3.88V5.69C15.51,3.18,14,1.82,11.53,1.82Z"
          />
        </g>
      </g>
    </svg>
  ),
});

export const RXIcon = createIcon({
  displayName: 'RXIcon',
  viewBox: '0 0 15 18.002',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18.002" viewBox="0 0 15 18.002">
      <path
        d="M18.854,12.146a.5.5,0,0,0-.707,0L14.5,15.793l-3.812-3.812A4.492,4.492,0,1,0,10.5,3h-6a.5.5,0,0,0-.5.5v15a.5.5,0,0,0,1,0V12H9.293l4.5,4.5-3.646,3.646a.5.5,0,1,0,.707.707L14.5,17.207l3.646,3.646a.5.5,0,1,0,.707-.707L15.207,16.5l3.646-3.646A.5.5,0,0,0,18.854,12.146ZM5,4h5.5a3.5,3.5,0,1,1,0,7H5Z"
        transform="translate(-4 -2.998)"
        fill="#3e1191"
      />
    </svg>
  ),
});

export const BagIcon = createIcon({
  displayName: 'BagIcon',
  viewBox: '0 0 16 16',
  path: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.33307 5.59335C2.33307 4.74535 3.0264 4.05468 3.87773 4.05468H12.1217C12.9697 4.05468 13.6597 4.74535 13.6597 5.59335V7.63135C12.5644 8.31201 11.3017 8.78868 9.9724 9.02268C9.60707 8.28468 8.84707 7.80068 7.99307 7.80068C7.1464 7.80068 6.38307 8.28268 6.00707 9.01668C4.68573 8.78401 3.42773 8.30935 2.33307 7.63135V5.59335ZM7.13577 2.33073H8.8571C9.3051 2.33073 9.68043 2.63807 9.79177 3.0514H6.20043C6.31243 2.63807 6.6871 2.33073 7.13577 2.33073ZM6.25592 10.066C6.50925 10.1014 6.74059 9.94536 6.80725 9.7027C6.95592 9.16136 7.43259 8.7987 7.99325 8.7987C8.54792 8.7987 9.02925 9.16936 9.16392 9.70003C9.22125 9.92403 9.42259 10.0774 9.64859 10.0774C9.67125 10.0774 9.69459 10.076 9.71725 10.0727C11.4299 9.83536 13.0613 9.22936 14.4359 8.32003C14.5759 8.2267 14.6599 8.0707 14.6599 7.9027V5.59136C14.6599 4.19136 13.5213 3.0527 12.1219 3.0527H10.8039C10.6793 2.08536 9.85859 1.33203 8.85725 1.33203H7.13592C6.13459 1.33203 5.31459 2.0847 5.18925 3.0527H3.87792C2.47459 3.0527 1.33325 4.19136 1.33325 5.59136V7.9027C1.33325 8.0707 1.41725 8.22736 1.55792 8.32003C2.93059 9.22536 4.55525 9.8287 6.25592 10.066ZM7.49677 10.256V11.1187C7.49677 11.3947 7.72077 11.6187 7.99677 11.6187C8.27277 11.6187 8.49677 11.3947 8.49677 11.1187V10.256C8.49677 9.98003 8.27277 9.75603 7.99677 9.75603C7.72077 9.75603 7.49677 9.98003 7.49677 10.256ZM13.6725 10.2755C13.6925 10.0195 13.9012 9.81547 14.1632 9.81547C14.4385 9.81547 14.6619 10.0388 14.6619 10.3141C14.6619 10.3184 14.6539 10.4211 14.6421 10.5735C14.6133 10.9451 14.5616 11.6123 14.5465 11.8695C14.5085 12.4948 14.2659 13.1328 13.8972 13.5768C13.3839 14.1955 12.7299 14.4848 11.8405 14.4868C11.4279 14.4875 9.72252 14.4881 8.01652 14.4881C6.31119 14.4881 4.60519 14.4875 4.19319 14.4868C3.30319 14.4848 2.64919 14.1955 2.13585 13.5761C1.76785 13.1328 1.52452 12.4948 1.48719 11.8695C1.47181 11.616 1.42127 10.9643 1.39223 10.5898C1.37971 10.4285 1.37119 10.3186 1.37119 10.3141C1.37119 10.0388 1.59452 9.81547 1.86985 9.81547C2.13185 9.81547 2.34052 10.0195 2.36052 10.2755C2.36052 10.2755 2.46319 11.4415 2.48519 11.8095C2.50985 12.2168 2.67519 12.6601 2.90585 12.9375C3.23252 13.3315 3.59385 13.4855 4.19452 13.4868C5.01852 13.4881 11.0139 13.4881 11.8385 13.4868C12.4399 13.4855 12.8012 13.3315 13.1272 12.9381C13.3585 12.6601 13.5239 12.2168 13.5485 11.8095C13.5699 11.4415 13.6725 10.2755 13.6725 10.2755Z"
        fill="#008753"
      />
    </svg>
  ),
});

export const LabInstrumentIcon = createIcon({
  displayName: 'LabInstrumentIcon',
  viewBox: '0 0 24.98 33',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.98 33">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Icons">
          <path
            className="cls-1"
            fill="none"
            stroke="#200e32"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.94px"
            d="M8.53,1.61v10.3a3.69,3.69,0,0,1-.42,1.73L1.37,26.8A3.59,3.59,0,0,0,4.57,32H20.41a3.6,3.6,0,0,0,3.22-5.2L17,13.63a3.84,3.84,0,0,1-.39-1.69V1.61"
          />
          <line
            className="cls-2"
            fill="none"
            stroke="#200e32"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2px"
            x1="5.61"
            y1="1"
            x2="19.37"
            y2="1"
          />
          <line
            className="cls-3"
            fill="none"
            stroke="#200e32"
            strokeLinecap="round"
            strokeWidth="2px"
            strokeMiterlimit="10"
            x1="18.49"
            y1="19"
            x2="13.49"
            y2="19"
          />
          <line
            className="cls-3"
            fill="none"
            stroke="#200e32"
            strokeLinecap="round"
            strokeWidth="2px"
            strokeMiterlimit="10"
            x1="15.49"
            y1="9"
            x2="12.49"
            y2="9"
          />
        </g>
      </g>
    </svg>
  ),
});

export const Time2Icon = createIcon({
  displayName: 'Time2Icon',
  viewBox: '0 0 16.42 16.42',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.42 16.42">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Icons_24px" data-name="Icons 24px">
          <path
            className="cls-1"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.92,8.21A7.71,7.71,0,1,1,8.21.5,7.71,7.71,0,0,1,15.92,8.21Z"
          />
          <path
            className="cls-1"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M11.07,10.66,7.93,8.79v-4"
          />
        </g>
      </g>
    </svg>
  ),
});

export const CloseIcon = createIcon({
  displayName: 'CloseIcon',
  viewBox: '0 0 28 28',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
      <g transform="translate(8.908 8.542)">
        <g transform="translate(0 0)">
          <path
            d="M10.541,0,0,10.541"
            transform="translate(0.005 0.005)"
            fill="none"
            stroke="#200e32"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="1.5"
          />
          <path
            d="M10.549,10.552,0,0"
            fill="none"
            stroke="#200e32"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="1.5"
          />
        </g>
      </g>
      <g fill="none" stroke="#04101f" strokeWidth="1">
        <circle cx="14" cy="14" r="14" stroke="none" />
        <circle cx="14" cy="14" r="13.5" fill="none" />
      </g>
    </svg>
  ),
});

export const GoBackIcon = createIcon({
  displayName: 'GoBackIcon',
  viewBox: '0 0 32.177 32.177',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32.177"
      height="32.177"
      viewBox="0 0 32.177 32.177"
    >
      <g transform="translate(0.75 0.75)">
        <g transform="translate(30.677) rotate(90)">
          <path
            d="M0,15.339A15.339,15.339,0,1,0,15.339,0,15.339,15.339,0,0,0,0,15.339Z"
            fill="none"
            stroke="#200e32"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="1.5"
          />
          <path
            d="M0,0,5.756,5.781,11.511,0"
            transform="translate(9.583 17.774)"
            fill="none"
            stroke="#200e32"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="1.5"
          />
          <line
            x1="0.643"
            y1="16.895"
            transform="translate(14.695 6.328)"
            fill="none"
            stroke="#200e32"
            strokeWidth="1.5"
          />
        </g>
      </g>
    </svg>
  ),
});

export const EditIcon = createIcon({
  displayName: 'EditIcon',
  viewBox: '0 0 20.138 21.118',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.138"
      height="21.118"
      viewBox="0 0 20.138 21.118"
    >
      <g id="noun_edit_3578396" transform="translate(-1.929 -1.441)">
        <path
          id="Path_20752"
          data-name="Path 20752"
          d="M18.275,1.809,15.832,4.252h0l-8.311,8.31a.405.405,0,0,0-.112.226l-.468,3.275a.4.4,0,0,0,.4.457.391.391,0,0,0,.049,0l3.33-.413a.4.4,0,0,0,.234-.114l8.309-8.309h0L21.7,5.236a.4.4,0,0,0,0-.565L18.842,1.809a.4.4,0,0,0-.567,0ZM10.481,15.327l-2.674.332.375-2.626L16.114,5.1l2.3,2.3Zm8.5-8.5-2.3-2.3L18.56,2.649l2.3,2.3Z"
          stroke="rgba(3,3,3,0.97)"
          strokeWidth="0.5"
        />
        <path
          id="Path_20753"
          data-name="Path 20753"
          d="M2.579,22.309H19.454a.4.4,0,0,0,.4-.4v-7.34a.4.4,0,0,0-.8,0v6.94H2.979V5.451H8.464a.4.4,0,0,0,0-.8H2.579a.4.4,0,0,0-.4.4V21.909a.4.4,0,0,0,.4.4Z"
          stroke="rgba(3,3,3,0.97)"
          strokeWidth="0.5"
        />
      </g>
    </svg>
  ),
});

export const TriangleArrowDownIcon = createIcon({
  displayName: 'TriangleArrowDownIcon',
  viewBox: '0 0 14.406 12.978',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.406"
      height="12.978"
      viewBox="0 0 14.406 12.978"
    >
      <path
        id="Path_20810"
        data-name="Path 20810"
        d="M5.564.946a1.893,1.893,0,0,1,3.278,0l5.307,9.193a1.893,1.893,0,0,1-1.639,2.839H1.9A1.893,1.893,0,0,1,.256,10.139Z"
        transform="translate(14.406 12.978) rotate(-180)"
      />
    </svg>
  ),
});

export const BellIcon = createIcon({
  displayName: 'BellIcon',
  viewBox: '0 0 13.97 15.476',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13.97"
      height="15.476"
      viewBox="0 0 13.97 15.476"
    >
      <path
        id="Path_20642"
        data-name="Path 20642"
        d="M33.8,35.422a2.329,2.329,0,0,1-4.625,0H26.009a1.507,1.507,0,1,1,0-3.013.138.138,0,0,0,.136-.137V28.985a5.343,5.343,0,0,1,3.7-5.084v-.257a1.644,1.644,0,1,1,3.287,0V23.9a5.343,5.343,0,0,1,3.7,5.084v3.287a.136.136,0,0,0,.136.137,1.507,1.507,0,1,1,0,3.013Zm-.831,0H30a1.507,1.507,0,0,0,2.963,0ZM30.355,24.608a4.52,4.52,0,0,0-3.389,4.377v3.287a.959.959,0,0,1-.958.959.685.685,0,1,0,0,1.37H36.961a.685.685,0,1,0,0-1.37A.957.957,0,0,1,36,32.271V28.985a4.521,4.521,0,0,0-3.389-4.377l-.308-.079v-.884a.822.822,0,1,0-1.644,0v.884Z"
        fill="currentColor"
        transform="translate(-24.5 -22)"
      />
    </svg>
  ),
});

export const PrescriptionIcon = createIcon({
  displayName: 'PrescriptionIcon',
  viewBox: '0 0 32.31 32.63',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.31 32.63">
      <defs>
        <style>{`.cls-1{fill:none;stroke:#200e32;strokeLinecap:round;strokeLinejoin:round;strokeWidth:2px;}`}</style>
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Icons">
          <rect
            className="cls-1"
            x="19.52"
            y="19.71"
            width="16.84"
            height="6.75"
            rx="3.38"
            transform="translate(4.85 51.03) rotate(-90)"
          />
          <line className="cls-1" x1="26.05" y1="23.09" x2="29.82" y2="23.09" />
          <rect className="cls-1" x="1" y="1" width="19.87" height="5.96" rx="2.98" />
          <path
            className="cls-1"
            d="M5,7H16.73l3.36,6.31a6.73,6.73,0,0,1,.78,3.14V27.68a4,4,0,0,1-3.95,3.95H5A4,4,0,0,1,1,27.68V16.08a6.65,6.65,0,0,1,.79-3.14Z"
          />
        </g>
      </g>
    </svg>
  ),
});

export const StarFilledIcon = createIcon({
  displayName: 'StarFilledIcon',
  viewBox: '0 0 329.942 329.942',
  path: (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 329.942 329.942"
    >
      <path
        id="XMLID_16_"
        d="M329.208,126.666c-1.765-5.431-6.459-9.389-12.109-10.209l-95.822-13.922l-42.854-86.837
      c-2.527-5.12-7.742-8.362-13.451-8.362c-5.71,0-10.925,3.242-13.451,8.362l-42.851,86.836l-95.825,13.922
      c-5.65,0.821-10.345,4.779-12.109,10.209c-1.764,5.431-0.293,11.392,3.796,15.377l69.339,67.582L57.496,305.07
      c-0.965,5.628,1.348,11.315,5.967,14.671c2.613,1.899,5.708,2.865,8.818,2.865c2.387,0,4.784-0.569,6.979-1.723l85.711-45.059
      l85.71,45.059c2.208,1.161,4.626,1.714,7.021,1.723c8.275-0.012,14.979-6.723,14.979-15c0-1.152-0.13-2.275-0.376-3.352
      l-16.233-94.629l69.339-67.583C329.501,138.057,330.972,132.096,329.208,126.666z"
        fill="currentColor"
      />
    </svg>
  ),
});

export const ProviderIcon = createIcon({
  displayName: 'ProviderIcon',
  viewBox: '0 0 15 16',
  path: (
    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.631 4.12508C11.631 6.31144 9.81901 8.08341 7.55487 8.08341C5.34766 8.08341 3.50725 6.31144 3.50725 4.12508C3.50725 1.93903 5.34766 0.166748 7.55487 0.166748C9.81901 0.166748 11.631 1.93903 11.631 4.12508ZM9.57868 11.3614C8.73438 11.581 8.06083 12.3572 8.06083 13.2787V14.0209C8.06083 14.1508 8.14304 14.2776 8.23791 14.3704L8.74386 14.8652C8.93992 15.06 9.26246 15.06 9.45852 14.8652C9.65774 14.6734 9.65774 14.358 9.45852 14.1663L9.07273 13.8168V13.2787C9.07273 12.7314 9.55339 12.2891 10.0846 12.2891C10.6728 12.2891 11.125 12.7314 11.125 13.2787V13.8168L10.7677 14.1663C10.5685 14.358 10.5685 14.6734 10.7677 14.8652C10.9637 15.06 11.2863 15.06 11.4823 14.8652L11.9883 14.3704C12.0831 14.2776 12.1369 14.1508 12.1369 14.0209V13.2787C12.1369 12.3572 11.4918 11.581 10.619 11.3614V9.71623C12.9433 10.2698 14.6667 12.2922 14.6667 14.7631V15.0105C14.6667 15.5579 14.2145 16.0001 13.6548 16.0001H1.5119C0.953144 16.0001 0.5 15.5579 0.5 15.0105V14.7631C0.5 12.3201 2.22435 10.2698 4.54762 9.71623V11.6181C3.81715 11.8315 3.28274 12.4932 3.28274 13.2787C3.28274 14.2343 4.07645 15.0105 5.05357 15.0105C6.03069 15.0105 6.8244 14.2343 6.8244 13.2787C6.8244 12.4932 6.28999 11.8315 5.55952 11.6181V9.57397C5.6449 9.57088 5.72712 9.56779 5.8125 9.56779H9.35417C9.43955 9.56779 9.52176 9.57088 9.60714 9.57397L9.57868 11.3614ZM5.78404 13.2787C5.78404 13.69 5.47414 14.0209 5.02511 14.0209C4.633 14.0209 4.26618 13.69 4.26618 13.2787C4.26618 12.8674 4.633 12.5365 5.02511 12.5365C5.47414 12.5365 5.78404 12.8674 5.78404 13.2787Z"
        fill="currentColor"
      />
    </svg>
  ),
});

export const WifiIcon = createIcon({
  displayName: 'WifiIcon',
  viewBox: '0 0 28 16',
  path: (
    <svg width="28" height="16" viewBox="0 0 28 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.75">
        <path
          d="M13.6534 0.00888861C18.4555 0.015755 23.0838 1.80689 26.6395 5.03451C26.7975 5.1431 26.9268 5.28851 27.016 5.45819C27.1053 5.62787 27.152 5.81673 27.152 6.00847C27.152 6.20021 27.1053 6.38907 27.016 6.55875C26.9268 6.72843 26.7975 6.87384 26.6395 6.98243C25.8863 7.74861 25.3409 7.7616 24.5357 6.98243C21.9326 4.63669 18.6373 3.20097 15.1468 2.89181C12.9042 2.65995 10.6378 2.89444 8.49018 3.58052C6.34253 4.26661 4.35999 5.38947 2.66714 6.87854C2.55277 7.00798 2.41114 7.11047 2.25242 7.17862C2.09371 7.24677 1.92187 7.2789 1.74925 7.27269C1.57664 7.26648 1.40755 7.22209 1.25414 7.14271C1.10074 7.06333 0.966836 6.95094 0.862068 6.81361C0.629678 6.59829 0.444028 6.3375 0.316648 6.04743C0.231742 5.81431 0.227851 5.55938 0.305601 5.32377C0.383351 5.08816 0.538206 4.88562 0.745187 4.74882C3.12146 2.6639 5.96946 1.18864 9.04331 0.450418C10.5552 0.108995 12.1042 -0.0393654 13.6534 0.00888861Z"
          fill="currentColor"
        />
        <path
          d="M13.6535 5.74854C17.1367 5.76197 20.5016 7.01401 23.1463 9.28076C24.1463 10.1378 23.6788 11.1897 22.7048 11.6442C22.4898 11.7494 22.2462 11.7809 22.0116 11.734C21.7769 11.6871 21.5642 11.5643 21.4062 11.3845C19.2979 9.51896 16.5945 8.46449 13.7798 8.40977C10.9652 8.35505 8.22288 9.30364 6.04362 11.0858C5.89831 11.2561 5.71147 11.3859 5.50121 11.4627C5.29095 11.5394 5.06441 11.5605 4.84358 11.5239C4.62276 11.4874 4.41514 11.3943 4.24087 11.2538C4.0666 11.1134 3.9316 10.9302 3.84897 10.7222C3.71822 10.4836 3.67907 10.2055 3.73884 9.94012C3.79862 9.67472 3.95322 9.44025 4.17362 9.28076C6.8067 7.00286 10.1718 5.74901 13.6535 5.74854Z"
          fill="currentColor"
        />
        <path
          d="M13.6534 11.2686C15.8826 11.2732 18.0406 12.0538 19.7569 13.4762C19.8921 13.5695 20.0067 13.6896 20.0933 13.8292C20.18 13.9687 20.237 14.1247 20.2607 14.2872C20.2844 14.4498 20.2743 14.6155 20.2311 14.7739C20.1879 14.9324 20.1124 15.0803 20.0095 15.2083C19.9065 15.3363 19.7783 15.4417 19.6328 15.5179C19.4873 15.5942 19.3276 15.6396 19.1637 15.6513C18.9999 15.663 18.8354 15.6408 18.6805 15.5861C18.5256 15.5313 18.3836 15.4453 18.2635 15.3332C17.0059 14.2799 15.4251 13.6899 13.7849 13.6615C12.1447 13.6332 10.5444 14.1682 9.25115 15.1774C9.12445 15.2805 8.97795 15.3565 8.82071 15.4007C8.66347 15.4449 8.49883 15.4564 8.33696 15.4345C8.17509 15.4126 8.01943 15.3578 7.8796 15.2733C7.73978 15.1889 7.61875 15.0767 7.524 14.9436C7.42896 14.8157 7.36109 14.6697 7.32457 14.5145C7.28804 14.3594 7.28362 14.1984 7.3116 14.0415C7.33957 13.8846 7.39935 13.7351 7.48724 13.6021C7.57513 13.4692 7.68928 13.3556 7.82268 13.2684C9.4916 11.9753 11.5422 11.272 13.6534 11.2686Z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
});

export const EyeOff = createIcon({
  displayName: 'EyeOff',
  viewBox: '0 0 16 16',
  path: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.359 11.238C15.06 9.72 16 8 16 8C16 8 13 2.5 7.99996 2.5C7.03955 2.50331 6.09002 2.70342 5.20996 3.088L5.97996 3.859C6.6274 3.62315 7.31091 3.50168 7.99996 3.5C10.12 3.5 11.879 4.668 13.168 5.957C13.7883 6.58069 14.3444 7.26513 14.828 8C14.77 8.087 14.706 8.183 14.633 8.288C14.298 8.768 13.803 9.408 13.168 10.043C13.003 10.208 12.831 10.371 12.651 10.529L13.359 11.238Z"
        fill="currentColor"
      />
      <path
        d="M11.297 9.17587C11.5201 8.55171 11.5615 7.87701 11.4162 7.23029C11.2708 6.58356 10.9449 5.99139 10.4762 5.52269C10.0075 5.05398 9.41529 4.72801 8.76857 4.5827C8.12184 4.43738 7.44715 4.47871 6.82299 4.70187L7.64599 5.52487C8.0303 5.46986 8.42214 5.50511 8.79046 5.62783C9.15878 5.75055 9.49346 5.95736 9.76798 6.23188C10.0425 6.5064 10.2493 6.84107 10.372 7.2094C10.4947 7.57772 10.53 7.96956 10.475 8.35387L11.297 9.17587ZM8.35399 10.4749L9.17599 11.2969C8.55183 11.52 7.87714 11.5613 7.23041 11.416C6.58368 11.2707 5.99151 10.9448 5.52281 10.476C5.0541 10.0073 4.72813 9.41517 4.58282 8.76845C4.43751 8.12172 4.47883 7.44702 4.70199 6.82287L5.52499 7.64587C5.46998 8.03018 5.50523 8.42202 5.62795 8.79034C5.75067 9.15866 5.95748 9.49334 6.232 9.76786C6.50652 10.0424 6.8412 10.2492 7.20952 10.3719C7.57784 10.4946 7.96968 10.5299 8.35399 10.4749Z"
        fill="currentColor"
      />
      <path
        d="M3.35 5.47C3.17 5.63 2.997 5.792 2.832 5.957C2.21165 6.58069 1.65552 7.26512 1.172 8L1.367 8.288C1.702 8.768 2.197 9.408 2.832 10.043C4.121 11.332 5.881 12.5 8 12.5C8.716 12.5 9.39 12.367 10.02 12.14L10.79 12.912C9.90994 13.2965 8.9604 13.4967 8 13.5C3 13.5 0 8 0 8C0 8 0.939 6.279 2.641 4.762L3.349 5.471L3.35 5.47ZM13.646 14.354L1.646 2.354L2.354 1.646L14.354 13.646L13.646 14.354Z"
        fill="currentColor"
      />
    </svg>
  ),
});

export const CopyIcon2 = createIcon({
  displayName: 'CopyIcon2',
  viewBox: '0 0 25 24',
  path: (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.0215 9H11.0215C9.91691 9 9.02148 9.89543 9.02148 11V20C9.02148 21.1046 9.91691 22 11.0215 22H20.0215C21.1261 22 22.0215 21.1046 22.0215 20V11C22.0215 9.89543 21.1261 9 20.0215 9Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.02148 19H7.02148C6.49105 19 5.98234 18.7893 5.60727 18.4142C5.2322 18.0391 5.02148 17.5304 5.02148 17V8C5.02148 7.46957 5.2322 6.96086 5.60727 6.58579C5.98234 6.21071 6.49105 6 7.02148 6H16.0215C16.5519 6 17.0606 6.21071 17.4357 6.58579C17.8108 6.96086 18.0215 7.46957 18.0215 8V9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const QRIcon = createIcon({
  displayName: 'QRIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M0 0H9V9H0V0ZM24 0V9H15V0H24ZM15 16.5H18V13.5H15V10.5H18V13.5H21V10.5H24V13.5H21V16.5H24V21H21V24H18V21H13.5V24H10.5V18H15V16.5ZM18 16.5V21H21V16.5H18ZM0 24V15H9V24H0ZM3 3V6H6V3H3ZM18 3V6H21V3H18ZM3 18V21H6V18H3ZM0 10.5H3V13.5H0V10.5ZM7.5 10.5H13.5V16.5H10.5V13.5H7.5V10.5ZM10.5 3H13.5V9H10.5V3Z"
      fill="currentColor"
    />
  ),
});

export const VerifiedIcon2 = createIcon({
  displayName: 'VerifiedIcon2',
  viewBox: '0 0 16 16',
  path: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="16" height="16" fill="url(#VerifiedIcon2)" />
      <defs>
        <pattern id="VerifiedIcon2" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_2814_2090" transform="scale(0.03125)" />
        </pattern>
        <image
          id="image0_2814_2090"
          width="32"
          height="32"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  ),
});

export const DownloadIcon = createIcon({
  displayName: 'DownloadIcon',
  viewBox: '0 0 21 20',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.37131 1.39502V11.6191L7.73679 9.97907L7.65282 9.90628C7.35966 9.68782 6.94295 9.71117 6.67614 9.97689C6.38264 10.2692 6.38167 10.7441 6.67396 11.0376L9.58996 13.9656L9.59162 13.967C9.61659 13.9919 9.64331 14.0151 9.67159 14.0363L9.67418 14.0385C9.96823 14.2575 10.3863 14.2331 10.6528 13.9656L13.5688 11.0376L13.6412 10.9533C13.8585 10.6592 13.8334 10.2426 13.5666 9.97689L13.4823 9.90445C13.1883 9.6872 12.7717 9.71226 12.506 9.97907L10.8713 11.6198V1.39502L10.8645 1.29325C10.8148 0.927173 10.501 0.64502 10.1213 0.64502C9.70709 0.64502 9.37131 0.980806 9.37131 1.39502ZM15.9044 19.117C18.2519 19.0083 20.1211 17.0712 20.1211 14.6968V9.81282L20.1163 9.60399C20.0073 7.25098 18.0665 5.37782 15.6871 5.37782H14.7541L14.6523 5.38466C14.2862 5.43433 14.0041 5.74812 14.0041 6.12782C14.0041 6.54203 14.3399 6.87782 14.7541 6.87782H15.6871L15.8595 6.8828C17.4001 6.97202 18.6211 8.24907 18.6211 9.81282V14.6968L18.6161 14.8687C18.5272 16.4045 17.2542 17.6218 15.6961 17.6218H4.55609L4.38366 17.6168C2.84311 17.5276 1.62109 16.2497 1.62109 14.6868V9.80182L1.62606 9.63005C1.71505 8.09542 2.98873 6.87782 4.54609 6.87782H5.48809L5.58987 6.87097C5.95594 6.82131 6.23809 6.50751 6.23809 6.12782C6.23809 5.7136 5.90231 5.37782 5.48809 5.37782H4.54609L4.33174 5.38292C1.9879 5.49474 0.121094 7.43059 0.121094 9.80182V14.6868L0.125921 14.8956C0.234945 17.2479 2.17686 19.1218 4.55609 19.1218H15.6961L15.9044 19.117Z"
      fill="currentColor"
    />
  ),
});

export const CalendarIcon4 = createIcon({
  displayName: 'CalendarIcon4',
  viewBox: '0 0 24 24',
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 2V6"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 2V6"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 10H21"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const CashIcon = createIcon({
  displayName: 'CashIcon',
  viewBox: '0 0 15 10',
  path: (
    <path
      d="M14 0.625H1C0.767936 0.625 0.545376 0.717187 0.381282 0.881282C0.217187 1.04538 0.125 1.26794 0.125 1.5V8.5C0.125 8.73206 0.217187 8.95462 0.381282 9.11872C0.545376 9.28281 0.767936 9.375 1 9.375H14C14.2321 9.375 14.4546 9.28281 14.6187 9.11872C14.7828 8.95462 14.875 8.73206 14.875 8.5V1.5C14.875 1.26794 14.7828 1.04538 14.6187 0.881282C14.4546 0.717187 14.2321 0.625 14 0.625ZM4.64375 8.625L0.875 5.33125V4.66875L4.64375 1.375H10.3562L14.125 4.66875V5.33125L10.3562 8.625H4.64375ZM14.125 1.5V3.675L11.5 1.375H14C14.0332 1.375 14.0649 1.38817 14.0884 1.41161C14.1118 1.43505 14.125 1.46685 14.125 1.5ZM1 1.375H3.5L0.875 3.675V1.5C0.875 1.46685 0.88817 1.43505 0.911612 1.41161C0.935054 1.38817 0.966848 1.375 1 1.375ZM0.875 8.5V6.325L3.5 8.625H1C0.966848 8.625 0.935054 8.61183 0.911612 8.58839C0.88817 8.56495 0.875 8.53315 0.875 8.5ZM14 8.625H11.5L14.125 6.325V8.5C14.125 8.53315 14.1118 8.56495 14.0884 8.58839C14.0649 8.61183 14.0332 8.625 14 8.625ZM7.5 2.625C7.03027 2.625 6.57109 2.76429 6.18052 3.02526C5.78995 3.28623 5.48554 3.65715 5.30579 4.09113C5.12603 4.5251 5.07899 5.00264 5.17063 5.46334C5.26227 5.92404 5.48847 6.34723 5.82062 6.67938C6.15277 7.01153 6.57596 7.23772 7.03666 7.32936C7.49737 7.421 7.9749 7.37397 8.40887 7.19421C8.84285 7.01446 9.21377 6.71005 9.47474 6.31948C9.73571 5.92891 9.875 5.46973 9.875 5C9.875 4.37011 9.62478 3.76602 9.17938 3.32062C8.73398 2.87522 8.12989 2.625 7.5 2.625ZM7.5 6.625C7.17861 6.625 6.86443 6.5297 6.5972 6.35114C6.32997 6.17258 6.12169 5.91879 5.9987 5.62186C5.8757 5.32493 5.84352 4.9982 5.90622 4.68298C5.96892 4.36776 6.12369 4.07821 6.35095 3.85095C6.57821 3.62369 6.86776 3.46892 7.18298 3.40622C7.4982 3.34352 7.82493 3.3757 8.12186 3.4987C8.41879 3.62169 8.67258 3.82997 8.85114 4.0972C9.0297 4.36443 9.125 4.67861 9.125 5C9.12335 5.43047 8.95162 5.84284 8.64723 6.14723C8.34284 6.45162 7.93047 6.62335 7.5 6.625Z"
      fill="white"
    />
  ),
});

export const CheckListIcon = createIcon({
  displayName: 'CheckListIcon',
  viewBox: '0 0 80 80',
  path: (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="80" height="80" fill="url(#CheckListIcon)" />
      <defs>
        <pattern id="CheckListIcon" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_1600_2743" transform="scale(0.015625)" />
        </pattern>
        <image
          id="image0_1600_2743"
          width="64"
          height="64"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  ),
});

export const PinIcon = createIcon({
  displayName: 'PinIcon',
  viewBox: '0 0 80 80',
  path: (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="80" height="80" fill="url(#PinIcon)" />
      <defs>
        <pattern id="PinIcon" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_1600_2747" transform="scale(0.015625)" />
        </pattern>
        <image
          id="image0_1600_2747"
          width="64"
          height="64"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  ),
});

export const HomeIcon1 = createIcon({
  displayName: 'HomeIcon1',
  viewBox: '0 0 80 80',
  path: (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="80" height="80" fill="url(#HomeIcon1)" />
      <defs>
        <pattern id="HomeIcon1" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_1585_1252" transform="scale(0.015625)" />
        </pattern>
        <image
          id="image0_1585_1252"
          width="64"
          height="64"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  ),
});

export const PharmacyIcon = createIcon({
  displayName: 'PharmacyIcon',
  viewBox: '0 0 80 80',
  path: (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="80" height="80" fill="url(#PharmacyIcon)" />
      <defs>
        <pattern id="PharmacyIcon" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_1585_1242" transform="scale(0.015625)" />
        </pattern>
        <image
          id="image0_1585_1242"
          width="64"
          height="64"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  ),
});

export const ResultSheetIcon = createIcon({
  displayName: 'ResultSheetIcon',
  viewBox: '0 0 48 48',
  path: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="48" height="48" fill="url(#ResultSheetIcon)" />
      <defs>
        <pattern id="ResultSheetIcon" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_1600_2794" transform="scale(0.015625)" />
        </pattern>
        <image
          id="image0_1600_2794"
          width="64"
          height="64"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  ),
});

export const CartIcon = createIcon({
  displayName: 'CartIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 7H18.79C19.0694 7.00001 19.3457 7.05857 19.6011 7.17191C19.8565 7.28524 20.0854 7.45083 20.2729 7.65801C20.4603 7.86519 20.6023 8.10936 20.6897 8.37478C20.777 8.64019 20.8078 8.92097 20.78 9.199L20.18 15.199C20.1307 15.6925 19.8997 16.1501 19.532 16.4829C19.1642 16.8157 18.686 17 18.19 17H8.64C8.17747 17.0002 7.72918 16.84 7.37144 16.5469C7.01371 16.2537 6.76866 15.8456 6.678 15.392L5 7Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M5 7L4.19 3.757C4.13583 3.54075 4.01095 3.34881 3.83521 3.21166C3.65946 3.0745 3.44293 3.00001 3.22 3H2M8 21H10M16 21H18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const TrashIcon = createIcon({
  displayName: 'TrashIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 6H5H21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11V17"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 11V17"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const ShareIcon = createIcon({
  displayName: 'ShareIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z" />
    </svg>
  ),
});

export const BackIcon = createIcon({
  displayName: 'BackIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7337 5.21259C15.4392 4.92914 14.9625 4.92914 14.6687 5.21259L8.44114 11.2225C7.85295 11.7901 7.85295 12.7109 8.44114 13.2786L14.7139 19.3328C15.0054 19.6133 15.4761 19.6169 15.7713 19.34C16.0733 19.0573 16.0763 18.5914 15.7796 18.3043L10.0385 12.7647C9.74405 12.4805 9.74405 12.0205 10.0385 11.7363L15.7337 6.24028C16.0281 5.95683 16.0281 5.49676 15.7337 5.21259Z"
        fill="#200e32"
      />
    </svg>
  ),
});

export const XCloseIcon = createIcon({
  displayName: 'XCloseIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 6L6 18"
        stroke="#200e32"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6L18 18"
        stroke="#200e32"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const SpendingWalletIcon = createIcon({
  displayName: 'SpendingWalletIcon',
  viewBox: '0 0 20 20',
  path: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.0833 6.06667V4.16667C17.0833 3.25 16.3333 2.5 15.4166 2.5H3.74992C2.82492 2.5 2.08325 3.25 2.08325 4.16667V15.8333C2.08325 16.75 2.82492 17.5 3.74992 17.5H15.4166C16.3333 17.5 17.0833 16.75 17.0833 15.8333V13.9333C17.5749 13.6417 17.9166 13.1167 17.9166 12.5V7.5C17.9166 6.88333 17.5749 6.35833 17.0833 6.06667ZM16.2499 7.5V12.5H10.4166V7.5H16.2499ZM3.74992 15.8333V4.16667H15.4166V5.83333H10.4166C9.49992 5.83333 8.74992 6.58333 8.74992 7.5V12.5C8.74992 13.4167 9.49992 14.1667 10.4166 14.1667H15.4166V15.8333H3.74992Z"
        fill="#6B57E6"
      />
      <path
        d="M12.9166 11.25C13.6069 11.25 14.1666 10.6904 14.1666 10C14.1666 9.30964 13.6069 8.75 12.9166 8.75C12.2262 8.75 11.6666 9.30964 11.6666 10C11.6666 10.6904 12.2262 11.25 12.9166 11.25Z"
        fill="#6B57E6"
      />
    </svg>
  ),
});

export const SavingsWalletIcon = createIcon({
  displayName: 'SavingsWalletIcon',
  viewBox: '0 0 20 20',
  path: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.33341 2.5H16.6667C17.1088 2.5 17.5327 2.67559 17.8453 2.98816C18.1578 3.30072 18.3334 3.72464 18.3334 4.16667V9.16667C18.3334 11.3768 17.4554 13.4964 15.8926 15.0592C14.3298 16.622 12.2102 17.5 10.0001 17.5C8.90573 17.5 7.8221 17.2845 6.81105 16.8657C5.80001 16.4469 4.88135 15.833 4.10752 15.0592C2.54472 13.4964 1.66675 11.3768 1.66675 9.16667V4.16667C1.66675 3.72464 1.84234 3.30072 2.1549 2.98816C2.46746 2.67559 2.89139 2.5 3.33341 2.5Z"
        stroke="#F79C17"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66675 8.33398L10.0001 11.6673L13.3334 8.33398"
        stroke="#F79C17"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const CareFundWalletIcon = createIcon({
  displayName: 'CareFundWalletIcon',
  viewBox: '0 0 20 20',
  path: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8333 2.5H4.16667C3.25 2.5 2.50833 3.25 2.50833 4.16667L2.5 15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5ZM15.8333 15.8333H4.16667V4.16667H15.8333V15.8333ZM8.75 14.1667H11.25V11.25H14.1667V8.75H11.25V5.83333H8.75V8.75H5.83333V11.25H8.75V14.1667Z"
        fill="#1081DF"
      />
    </svg>
  ),
});

export const MoveIcon = createIcon({
  displayName: 'MoveIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.90918 9.45508L2.90918 12.4551L5.90918 15.4551"
        stroke="#3E1191"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.90918 5.45508L12.9092 2.45508L15.9092 5.45508"
        stroke="#3E1191"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9092 19.4551L12.9092 22.4551L9.90918 19.4551"
        stroke="#3E1191"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.9092 9.45508L22.9092 12.4551L19.9092 15.4551"
        stroke="#3E1191"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.90918 12.4551H22.9092"
        stroke="#3E1191"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9092 2.45508V22.4551"
        stroke="#3E1191"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const QRCodeIcon = createIcon({
  displayName: 'QRCodeIcon',
  viewBox: '0 0 20 20',
  path: (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.60693 5.41602V7.91602H6.10693V5.41602H8.60693ZM9.85693 4.16602H4.85693V9.16602H9.85693V4.16602ZM8.60693 12.0827V14.5827H6.10693V12.0827H8.60693ZM9.85693 10.8327H4.85693V15.8327H9.85693V10.8327ZM15.2736 5.41602V7.91602H12.7736V5.41602H15.2736ZM16.5236 4.16602H11.5236V9.16602H16.5236V4.16602ZM11.5236 10.8327H12.7736V12.0827H11.5236V10.8327ZM12.7736 12.0827H14.0236V13.3327H12.7736V12.0827ZM14.0236 10.8327H15.2736V12.0827H14.0236V10.8327ZM11.5236 13.3327H12.7736V14.5827H11.5236V13.3327ZM12.7736 14.5827H14.0236V15.8327H12.7736V14.5827ZM14.0236 13.3327H15.2736V14.5827H14.0236V13.3327ZM15.2736 12.0827H16.5236V13.3327H15.2736V12.0827ZM15.2736 14.5827H16.5236V15.8327H15.2736V14.5827ZM19.0236 5.83268H17.3569V3.33268H14.8569V1.66602H19.0236V5.83268ZM19.0236 18.3327V14.166H17.3569V16.666H14.8569V18.3327H19.0236ZM2.35693 18.3327H6.5236V16.666H4.0236V14.166H2.35693V18.3327ZM2.35693 1.66602V5.83268H4.0236V3.33268H6.5236V1.66602H2.35693Z"
        fill="#3E1191"
      />
    </svg>
  ),
});

export const NeoCardIcon = createIcon({
  displayName: 'NeoCardIcon',
  viewBox: '0 0 72 66',
  path: (
    <svg width="72" height="66" viewBox="0 0 72 66" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M39.7765 89.5133C44.8329 85.8884 49.1156 81.3465 52.3207 76.2099C55.1467 71.6684 57.0924 66.7632 58.0541 61.7564C59.0046 56.8519 59.0301 51.9342 58.1292 47.2375C57.8148 45.5622 57.3815 43.922 56.8318 42.3273C54.3038 34.7375 49.0512 28.4799 41.9022 24.5413C33.7924 20.1696 24.0407 18.647 14.1564 20.2091C4.13128 21.639 -5.42501 26.5369 -12.6211 33.9333C-13.7824 35.1424 -14.8503 36.4261 -15.8145 37.7722C-17.9962 40.6518 -19.4678 43.9055 -20.1035 47.2548C-20.7392 50.6041 -20.5199 53.9493 -19.4645 57.0042C-17.3856 62.5057 -13.3827 66.9973 -8.05353 69.8084C-9.11167 71.7359 -10.0387 73.713 -10.8284 75.7265C-11.2576 76.9292 -11.191 78.1856 -10.6427 79.2288C-10.0944 80.2719 -9.10764 81.0195 -7.89215 81.3127C-6.67666 81.6058 -5.32825 81.4215 -4.13355 80.7987C-2.93884 80.176 -1.99201 79.1639 -1.4943 77.9778C-0.95968 76.6388 -0.353965 75.3188 0.320332 74.0231C2.89635 75.0991 5.56671 76.0025 8.3139 76.7272C13.0731 78.1031 18.2539 78.3389 23.4279 77.4152C26.1088 76.8709 28.6971 75.7624 30.9932 74.1752C33.238 72.6177 35.1116 70.6084 36.4508 68.322C37.4685 66.585 38.1111 64.7085 38.3366 62.8151C38.5621 60.9217 38.3655 59.0539 37.7595 57.3338C37.5667 56.7738 37.3356 56.2301 37.0675 55.7058C35.193 52.1992 32.142 49.462 28.3289 47.8659C24.5328 46.1438 20.085 45.7251 15.6667 46.674C11.2932 47.789 7.23309 50.1434 4.06134 53.4037C1.56799 55.9023 -0.690063 58.5963 -2.68079 61.4475C-5.98514 59.4875 -8.50095 56.593 -9.92829 53.1092C-10.5242 51.3956 -10.6357 49.5138 -10.2527 47.6351C-9.86964 45.7564 -9.0042 43.9403 -7.73503 42.3519C-7.08542 41.4429 -6.36559 40.5759 -5.58251 39.7594C4.82442 28.8133 23.1375 25.7549 36.1069 32.8695C41.5024 35.852 45.4653 40.5827 47.3721 46.3175C48.7814 50.3774 49.1974 54.7901 48.5915 59.251C47.9855 63.7119 46.372 68.1148 43.8622 72.1561C41.4787 75.9856 38.316 79.3883 34.5849 82.1376C30.8539 84.8869 26.6402 86.9194 22.2248 88.0998C14.5837 90.2445 6.71726 89.8183 0.0377006 86.8977C-1.1036 86.3975 -2.46631 86.3746 -3.75066 86.834C-5.03501 87.2934 -6.1358 88.1976 -6.81086 89.3476C-7.48591 90.4975 -7.67994 91.7991 -7.35025 92.966C-7.02056 94.1329 -6.19415 95.0694 -5.05286 95.5697C1.7764 98.5198 9.57515 99.5154 17.4848 98.4468C25.3944 97.3782 33.108 94.2869 39.7765 89.5133ZM5.70096 65.5327C8.75407 61.388 12.364 56.929 16.8556 55.8683C19.1267 55.5132 21.3773 55.7763 23.3383 56.6261C25.2993 57.476 26.8878 58.8766 27.9137 60.6605C28.0149 60.852 28.1012 61.0516 28.1719 61.2577C28.3673 61.7853 28.4327 62.3613 28.3635 62.9458C28.2943 63.5304 28.0923 64.1094 27.7713 64.6427C27.1952 65.5543 26.4162 66.3512 25.4969 66.9694C24.5776 67.5876 23.5435 68.0099 22.4777 68.2024C16.5944 69.3894 10.4577 67.4271 5.69857 65.5258L5.70096 65.5327Z"
        fill="white"
        fillOpacity="0.4"
      />
    </svg>
  ),
});

export const PocketIcon = createIcon({
  displayName: 'PocketIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.27246 3.45508H20.2725C20.8029 3.45508 21.3116 3.66579 21.6867 4.04086C22.0617 4.41594 22.2725 4.92465 22.2725 5.45508V11.4551C22.2725 14.1072 21.2189 16.6508 19.3435 18.5261C17.4682 20.4015 14.9246 21.4551 12.2725 21.4551C10.9592 21.4551 9.65888 21.1964 8.44563 20.6939C7.23237 20.1913 6.12998 19.4547 5.20139 18.5261C3.32603 16.6508 2.27246 14.1072 2.27246 11.4551V5.45508C2.27246 4.92465 2.48317 4.41594 2.85825 4.04086C3.23332 3.66579 3.74203 3.45508 4.27246 3.45508Z"
        stroke="#3E1191"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.27246 10.4551L12.2725 14.4551L16.2725 10.4551"
        stroke="#3E1191"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const NewDownloadIcon = createIcon({
  displayName: 'NewDownloadIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM17 11L15.59 9.59L13 12.17V4H11V12.17L8.41 9.59L7 11L12 16L17 11Z"
        fill="black"
      />
    </svg>
  ),
});

export const ShowCardIcon = createIcon({
  displayName: 'ShowCardIcon',
  viewBox: '0 0 20 20',
  path: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99984 1.66602C5.39984 1.66602 1.6665 5.39935 1.6665 9.99935C1.6665 14.5993 5.39984 18.3327 9.99984 18.3327C14.5998 18.3327 18.3332 14.5993 18.3332 9.99935C18.3332 5.39935 14.5998 1.66602 9.99984 1.66602ZM9.99984 16.666C6.3165 16.666 3.33317 13.6827 3.33317 9.99935C3.33317 6.31602 6.3165 3.33268 9.99984 3.33268C13.6832 3.33268 16.6665 6.31602 16.6665 9.99935C16.6665 13.6827 13.6832 16.666 9.99984 16.666Z"
        fill="#3E1191"
      />
      <path
        d="M5.9165 8.48268C6.13317 8.94935 6.2415 9.44935 6.24984 9.98268C6.25817 10.5077 6.1415 11.0243 5.9165 11.5327L7.05817 12.0493C7.3665 11.3743 7.5165 10.6743 7.50817 9.96602C7.49984 9.26602 7.34984 8.59102 7.05817 7.96602L5.9165 8.48268Z"
        fill="#3E1191"
      />
      <path
        d="M11.1082 6.10768C11.7582 7.41602 12.0915 8.72435 12.0915 9.97435C12.0915 11.2327 11.7582 12.5493 11.1082 13.8827L12.2332 14.4327C12.9665 12.9243 13.3415 11.4243 13.3415 9.97435C13.3415 8.52435 12.9665 7.03268 12.2332 5.54935L11.1082 6.10768Z"
        fill="#3E1191"
      />
      <path
        d="M8.49984 7.26602C8.9415 8.15768 9.1665 9.10768 9.1665 10.0993C9.1665 11.0743 8.94984 11.9577 8.5165 12.7243L9.59984 13.341C10.1415 12.3827 10.4165 11.2993 10.4165 10.0993C10.4165 8.91602 10.1498 7.77435 9.6165 6.70768L8.49984 7.26602Z"
        fill="#3E1191"
      />
    </svg>
  ),
});

export const BackArrowIcon = createIcon({
  displayName: 'BackArrowIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21 11H6.83L10.41 7.41L9 6L3 12L9 18L10.41 16.59L6.83 13H21V11Z" fill="black" />
    </svg>
  ),
});

export const StethoscopeNewIcon = createIcon({
  displayName: 'StethoscopeNewIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.47678 3.65413C5.21403 3.65413 5.81166 3.05648 5.81166 2.31925C5.81166 1.58202 5.21403 0.984375 4.47678 0.984375C3.98268 0.984375 3.55131 1.25282 3.32051 1.65181H3.1419C2.03606 1.65181 1.13959 2.54828 1.13959 3.65413V9.66108H2.47447V3.65413C2.47447 3.28552 2.77329 2.98669 3.1419 2.98669H3.32051C3.55131 3.38569 3.98268 3.65413 4.47678 3.65413Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.24889 9.66107H2.47453H1.13965C0.77104 9.66107 0.469085 9.96055 0.502537 10.3276C0.657709 12.0304 1.40375 13.6337 2.62261 14.8525C3.5164 15.7463 4.61687 16.3859 5.81172 16.7246V18.3378C5.81172 19.2097 6.36903 19.9514 7.14687 20.2262C7.1753 22.8743 9.33079 25.0122 11.9855 25.0122C14.658 25.0122 16.8245 22.8457 16.8245 20.1732V17.5035C16.8245 16.1211 17.945 15.0006 19.3274 15.0006C20.7097 15.0006 21.8302 16.1211 21.8302 17.5035V19.1191C21.0525 19.394 20.4954 20.1357 20.4954 21.0075C20.4954 22.1134 21.3918 23.0098 22.4977 23.0098C23.6036 23.0098 24.5 22.1134 24.5 21.0075C24.5 20.1357 23.9428 19.394 23.1651 19.1191V17.5035C23.1651 15.384 21.4469 13.6657 19.3274 13.6657C17.2078 13.6657 15.4896 15.384 15.4896 17.5035V20.1732C15.4896 22.1085 13.9208 23.6773 11.9855 23.6773C10.0679 23.6773 8.51011 22.1369 8.48188 20.226C9.25938 19.951 9.81635 19.2094 9.81635 18.3378V16.7246C11.0112 16.3859 12.1117 15.7463 13.0055 14.8525C14.2244 13.6337 14.9704 12.0304 15.1256 10.3276C15.1591 9.96055 14.857 9.66107 14.4884 9.66107V3.65413C14.4884 2.54828 13.592 1.65181 12.4861 1.65181H12.3075C12.0767 1.25282 11.6453 0.984375 11.1512 0.984375C10.414 0.984375 9.81635 1.58202 9.81635 2.31925C9.81635 3.05648 10.414 3.65413 11.1512 3.65413C11.6453 3.65413 12.0767 3.38569 12.3075 2.98669H12.4861C12.8547 2.98669 13.1535 3.28552 13.1535 3.65413V9.66107H12.3793C12.0106 9.66107 11.7176 9.96202 11.6548 10.3253C11.5187 11.1125 11.1427 11.8447 10.5702 12.4172C9.83925 13.1482 8.84783 13.5588 7.81404 13.5588C6.78031 13.5588 5.7889 13.1482 5.05792 12.4172C4.48546 11.8447 4.10942 11.1125 3.97326 10.3253C3.91046 9.96202 3.61745 9.66107 3.24889 9.66107ZM12.8736 10.996H13.6708C13.4214 12.0903 12.8679 13.1023 12.0616 13.9087C10.9351 15.0352 9.40721 15.668 7.81404 15.668C6.22093 15.668 4.69303 15.0352 3.56653 13.9087C2.76017 13.1023 2.20673 12.0903 1.95728 10.996H2.75454C2.98862 11.883 3.45406 12.7011 4.11403 13.3611C5.09536 14.3424 6.4263 14.8937 7.81404 14.8937C9.20184 14.8937 10.5328 14.3424 11.5141 13.3611C12.1741 12.7011 12.6395 11.883 12.8736 10.996ZM22.4977 20.3401C22.8663 20.3401 23.1651 20.6389 23.1651 21.0075C23.1651 21.3762 22.8663 21.675 22.4977 21.675C22.1291 21.675 21.8302 21.3762 21.8302 21.0075C21.8302 20.6389 22.1291 20.3401 22.4977 20.3401ZM8.48148 17.0029V18.3378C8.48148 18.7064 8.18266 19.0052 7.81404 19.0052C7.44541 19.0052 7.1466 18.7064 7.1466 18.3378V17.0029H8.48148Z"
        fill="white"
      />
    </svg>
  ),
});

export const FilterIcon = createIcon({
  displayName: 'FilterIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.93102 14.9902H2.90259"
        stroke="#121212"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0981 14.9898C18.0981 16.3153 17.0236 17.3898 15.6981 17.3898C14.3726 17.3898 13.2981 16.3153 13.2981 14.9898C13.2981 13.6634 14.3726 12.5898 15.6981 12.5898C17.0236 12.5898 18.0981 13.6634 18.0981 14.9898Z"
        stroke="#121212"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0688 5.22066H18.0983"
        stroke="#121212"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.9021 5.22031C2.9021 6.54678 3.97661 7.62031 5.3021 7.62031C6.62759 7.62031 7.7021 6.54678 7.7021 5.22031C7.7021 3.89482 6.62759 2.82031 5.3021 2.82031C3.97661 2.82031 2.9021 3.89482 2.9021 5.22031Z"
        stroke="#121212"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const ChevronDownIcon = createIcon({
  displayName: 'ChevronDownIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.175 6.9126L10 10.7293L13.825 6.9126L15 8.0876L10 13.0876L5 8.0876L6.175 6.9126Z"
        fill="black"
      />
    </svg>
  ),
});

export const MapMarkerIcon = createIcon({
  displayName: 'MapMarkerIcon',
  viewBox: '0 0 48 48',
  path: (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M42 20C42 34 24 46 24 46C24 46 6 34 6 20C6 15.2261 7.89642 10.6477 11.2721 7.27208C14.6477 3.89642 19.2261 2 24 2C28.7739 2 33.3523 3.89642 36.7279 7.27208C40.1036 10.6477 42 15.2261 42 20Z"
        stroke="#069048"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 26C27.3137 26 30 23.3137 30 20C30 16.6863 27.3137 14 24 14C20.6863 14 18 16.6863 18 20C18 23.3137 20.6863 26 24 26Z"
        stroke="#069048"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const EnvelopeIcon = createIcon({
  displayName: 'EnvelopeIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
        stroke="#121212"
        strokeOpacity="0.85"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 6L12 13L2 6"
        stroke="#121212"
        strokeOpacity="0.85"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});

export const LikedIcon = createIcon({
  displayName: 'LikedIcon',
  viewBox: '0 0 15 16',
  path: (
    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="15" height="15" transform="translate(0 0.5)" fill="white" fill-opacity="0.01" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.35254 5.40538C1.35254 3.44504 2.93606 1.85254 4.89352 1.85254C6.25775 1.85254 6.86064 2.42342 7.50008 3.43551C8.13952 2.42342 8.74241 1.85254 10.1067 1.85254C12.0641 1.85254 13.6477 3.44504 13.6477 5.40538C13.6477 7.24047 12.6014 9.00514 11.4009 10.4693C10.2637 11.8563 8.922 13.0509 8.00607 13.8665C7.94651 13.9195 7.88875 13.971 7.83297 14.0207C7.6433 14.19 7.35686 14.19 7.16719 14.0207C7.11141 13.971 7.05365 13.9195 6.99409 13.8665C6.07816 13.0509 4.73647 11.8563 3.59932 10.4693C2.39878 9.00514 1.35254 7.24047 1.35254 5.40538Z"
        fill="#E5484D"
      />
    </svg>
  ),
});

export const UnLikedIcon = createIcon({
  displayName: 'UnLikedIcon',
  viewBox: '0 0 12 12',
  path: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="12" height="12" fill="white" fill-opacity="0.01" />
      <path
        d="M5.57736 2.61547L6.00006 3.28451L6.42276 2.61547C6.66782 2.2276 6.87117 1.98294 7.10387 1.82677C7.32419 1.67892 7.61435 1.58203 8.08533 1.58203C9.3732 1.58203 10.4181 2.63027 10.4181 3.9243C10.4181 5.213 9.67566 6.50998 8.73404 7.65844C7.85256 8.7335 6.80762 9.66502 6.07235 10.3198L6.00006 10.3841L5.92778 10.3198C5.1925 9.66502 4.14755 8.7335 3.26611 7.65845L3.2661 7.65844C2.32445 6.51 1.58203 5.21301 1.58203 3.9243C1.58203 2.63026 2.6269 1.58203 3.91481 1.58203C4.38578 1.58203 4.67594 1.67892 4.89625 1.82677C5.12896 1.98293 5.3323 2.2276 5.57736 2.61547ZM2.88104 7.97416L2.87946 7.97546L2.88104 7.97416Z"
        stroke="#646464"
      />
    </svg>
  ),
});

export const ReplyIcon = createIcon({
  displayName: 'ReplyIcon',
  viewBox: '0 0 12 12',
  path: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 10.125C8.48528 10.125 10.5 8.27817 10.5 6C10.5 3.72183 8.48528 1.875 6 1.875C3.51472 1.875 1.5 3.72183 1.5 6C1.5 6.88101 1.8013 7.69751 2.3146 8.36764C2.69236 8.86081 3.03805 9.46696 2.75589 10.0204C2.67661 10.1759 2.57975 10.321 2.4679 10.453C2.5459 10.4669 2.625 10.4779 2.70483 10.4857C2.80188 10.4951 2.90039 10.5 3 10.5C3.641 10.5 4.23508 10.2989 4.72259 9.95643C5.12753 10.0661 5.55626 10.125 6 10.125Z"
        stroke="#646464"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
});

export const FollowedIcon = createIcon({
  displayName: 'FollowedIcon',
  viewBox: '0 0 12 12',
  path: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="#7F56D9"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8.79666 1.6612C9.34696 1.72507 9.75 2.1995 9.75 2.75349V10.5L6 8.625L2.25 10.5V2.75349C2.25 2.1995 2.65304 1.72507 3.20334 1.6612C4.12078 1.55473 5.054 1.5 6 1.5C6.946 1.5 7.87922 1.55473 8.79666 1.6612Z" />
    </svg>
  ),
});

export const UnFollowedIcon = createIcon({
  displayName: 'UnFollowedIcon',
  viewBox: '0 0 12 12',
  path: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.79666 1.6612C9.34696 1.72507 9.75 2.1995 9.75 2.75349V10.5L6 8.625L2.25 10.5V2.75349C2.25 2.1995 2.65304 1.72507 3.20334 1.6612C4.12078 1.55473 5.054 1.5 6 1.5C6.946 1.5 7.87922 1.55473 8.79666 1.6612Z"
        stroke="#646464"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
});
